import { errorPanel } from "./errorPanel";
import { getStickyValue, setStickyValue } from "./Util";

var VR = typeof window.VR !== "undefined" ? window.VR : {};

VR.Edit = (function () {
    var self = {};
    self.Validating = false;
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
        // Member Fields */
    self.Alerts = [];
    self.ApplicationValues = null;
    self.ErrorFields = [];
    self.EventYear = 0;
    self.Fields = [];
    self.editModel = null;
    self.editField = null;
    self.validatingFieldCount = 0;
    self.load = false;
    self.ImageDataSource = new kendo.data.DataSource({
        pageSize: 16
    });
    self.ImageListWindow = null;
    self.State = 0;
    self._lastTabTime = 0;
    self.CurrentSignatureField = null;
    self.Ex = {};
    self.Meta = {};
    self.GridDocsRefreshCreated = false;
    self.LastFocusedField = null;
    //Prevent the default browser action for the backspace key so that the browser doesn't try using the back button
    $(document).on("keydown", function (e) {
        if (
            e.which === 8 &&
            !$(e.target).is(
                "input:not([readonly]):not([type=radio]):not([type=checkbox]), textarea, [contentEditable], [contentEditable=true]"
            )
        ) {
            e.preventDefault();
        }
        else if (e.which === 9) {
            if (self.LastFocusedField !== null && document.activeElement === document.body) {
                e.preventDefault();
                let model = $("#f" + self.LastFocusedField).data("field");
                self.FocusNextField(model, e.shiftKey);
                self.LastFocusedField = null;
            }
        }
    });

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Adds error field to the error field list.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.AddErrorField = function (model) {
        if (model == null) {
            return;
        }

        var index = self.ErrorFields.indexOf(model);
        if (index == -1) {
            self.ErrorFields.push(model);
            if (VR.Common.IsMobile()) {
                var field = $("#f" + model.FieldId);
                field.css("border", "1px solid red");
                $("#mobileErrorsBtnText").html(`${self.GetFieldErrorCount()}`);
            }
        }
    }; //AddErrorField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Adds a new event record for grid.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.AddNewRecord = function (button) {
        if (!button) {
            return;
        }

        var id = $(button).attr("id");
        if (id && id.length > 0) {
            id = id.substring(1);
        }

        var input = $("#f" + id);
        var model = input.data("field");
        if (!model) {
            return;
        }

        var message = VR.Script.ExecuteScript(input, model, {
            Script: model.GridScript,
            Kind: "grid",
            EditNumber: 0
        });

        if (message && message != "OK") {
            VR.Common.ShowError(message);
            return;
        }

        var gridinfo = input.data("grid");
        if (!gridinfo) {
            return;
        }

        var ispreload = false;
        var eventid = gridinfo.EventId;
        if (self.Preloads && self.Preloads.length > 0) {
            ispreload = self.Preloads.indexOf(eventid) > -1;
        }

        if (!ispreload) {
            var selection =
                "new-" +
                gridinfo.EventId +
                "|preload=|source=" +
                self.EventName +
                "|id=" +
                self.EventId;
            VR.Common.SetupEditPage(selection, VR.Common.CanOpen);
        } else {
            var selection = self.GetPreloadData();
            VR.Common.SecurePost(
                "data/preload",
                selection,
                function (result) {
                    if (result.Code != 0) {
                        VR.Common.HandleInvalidResult(result, "Preload", false);
                    } else {
                        var preloadId = result.PreloadId;
                        var selection =
                            "new-" +
                            gridinfo.EventId +
                            "-preload=" +
                            preloadId +
                            "|source=" +
                            self.EventName +
                            "|id=" +
                            self.EventId;
                        VR.Common.SetupEditPage(selection, false);
                    }
                },
                false,
                "data=",
                false,
                true
            );
        }
    }; //AddNewRecord
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Checks to see if the user can leave the page.
        /// </summary>
        /// <param name="onsuccess">The onsucess handler.</param>
        /// <param name="parameter">The field model.</param>
        /// <returns></returns>*/
    self.CanLeavePage = function (onsuccess, parameter) {
        if (
            self.IsDisplayOnly ||
            (!self.CanSaveWithEdits && !self.CanSaveWithoutEdits) ||
            !self.CanSave ||
            self.CanLeave
        ) {
            if (onsuccess) {
                onsuccess(parameter);
            }
        } else {
            var canClose = true;
            var model = null;
            $.each(self.Fields, function (index, field) {
                if (field.HasChange) {
                    canClose = false;
                    model = field;
                    return false;
                }
            });

            if (canClose) {
                if (onsuccess) {
                    onsuccess(parameter);
                }
            } else {
                var handler = function (parameter) {
                    self.CanLeaveValidated = true;
                    if (onsuccess) {
                        onsuccess(parameter);
                    }
                };

                var message =
                    "You have unsaved changes. Do you want to leave this page?";
                VR.Common.ShowMessageBox(message, handler, true, parameter);
            }
        }
    };

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
        /// <summary>
        /// Capitizes the first letter in each word of the string, then sets all other characters to lowercase
        /// </summary>
        /// <param name="value">Input string.</param>
        /// <returns>Capitalized string.</returns>*/
    self.CapitalizeEachWord = function (value) {
        let capitalizeNextLetterCodes = [45, 39];
        // [-, ']
        //00df is small sharp s and is allowed, don't have capital sharp s 1e9e
        let specialUpToLow = {
            200: 232, 209: 241, 192: 224, 193: 225, 194: 226, 195: 227, 196: 228, 197: 229, 198: 230, 210: 242, 211: 243, 212: 244, 213: 245, 214: 246,
            216: 248, 199: 231, 200: 232, 201: 233, 202: 234, 203: 235, 217: 249, 218: 250, 219: 251, 220: 252, 204: 236, 205: 237, 206: 238, 207: 239,
            221: 253, 208: 240, 222: 254, 376: 255,
            //7838: 223 //do not change sharp s capitalization for now
        };
        let specialLowToUp = {
            232: 200, 241: 209, 224: 192, 225: 193, 226: 194, 227: 195, 228: 196, 229: 197, 230: 198, 242: 210, 243: 211, 244: 212, 245: 213, 246: 214,
            248: 216, 231: 199, 232: 200, 233: 201, 234: 202, 235: 203, 249: 217, 250: 218, 251: 219, 252: 220, 236: 204, 237: 205, 238: 206, 239: 207,
            253: 221, 240: 208, 254: 222, 255: 376,
            //223: 7838
        };
        
        let valueArr = value.split(" ");
        let outputWords = [];
        for (let i = 0; i < valueArr.length; i++) {
            let singleWord = valueArr[i];
            let charArr = singleWord.split("");
            for (let j = 0; j < charArr.length; j++) {
                if (j === 0) {
                    let charCode0 = charArr[j].charCodeAt();
                    if (charCode0 >= 97 && charCode0 <= 122) {
                        //currently lowercase, make uppercase
                        charArr[j] = String.fromCharCode(charCode0 - 32);
                    }
                    else if (typeof specialLowToUp[charCode0] === "number") {
                        charArr[j] = String.fromCharCode(specialLowToUp[charCode0]);
                    }
                }
                else {
                    let charCode = charArr[j].charCodeAt();
                    if (charCode >= 65 && charCode <= 90) {
                        //currently uppercase, make lowercase
                        charArr[j] = String.fromCharCode(charCode + 32);
                    }
                    else if (typeof specialUpToLow[charCode] === "number") {
                        charArr[j] = String.fromCharCode(specialUpToLow[charCode]);
                    }
                    else if (capitalizeNextLetterCodes.includes(charCode) && j + 1 < charArr.length) {
                        let nextCharCode = charArr[j + 1].charCodeAt();
                        if (nextCharCode >= 97 && nextCharCode <= 122) {
                            //currently lowercase, make uppercase
                            charArr[j + 1] = String.fromCharCode(nextCharCode - 32);
                        }
                        else if (typeof specialLowToUp[nextCharCode] === "number") {
                            charArr[j + 1] = String.fromCharCode(specialLowToUp[nextCharCode]);
                        }
                        if (!capitalizeNextLetterCodes.includes(nextCharCode)) {
                            j++;
                        }
                    }
                }
            }
            outputWords.push(charArr.join(""));
        }
        return outputWords.join(" ");
    };

    self.CheckIsComboBoxValueAllowed = function (input) {
        var elem = $(input);
        var elemModel = (elem[0].type === "radio"
            ? $(`#${elem[0].name}`)
            : elem
        ).data("field");
        var returnValue = true;
        var value = !!elemModel.FieldValue
            ? elemModel.FieldValue
            : self.GetInputValue(elem, true);
        var comboBox = elem.data("kendoComboBox");

        if (elemModel.FieldType == "ComboBox") {
            var multispaces = RegExp(/\s\s+/g);
            if (multispaces.test(value)) {
                value = value.replace(/\s\s+/g, " ");
                VR.Script.MoveLit(value, elemModel.FieldName);
            }
            if (value) {
                if (elemModel.AllowOther == true) {
                    if (value != elemModel.OriginalValue
                        && comboBox.select() === -1
                        && value != elemModel.DefaultValue
                        && !nx.IsInList(elemModel.FieldId)) {
                        self.SetFieldStatus(comboBox.input, elemModel, "literal", null, null);
                    }
                } else {
                    if (comboBox.value() && comboBox.select() === -1 && !nx.IsInList(elemModel.FieldId)) {
                        returnValue = false;
                    }
                    else if (elemModel.ValidationDropdownItems !== null) {
                        let found = false;
                        for (let k = 0; k < elemModel.ValidationDropdownItems.length && found === false; k++) {
                            let curItem = elemModel.ValidationDropdownItems[k];
                            found = value.toString().toLowerCase() === (curItem.ValueInt === null ? curItem.ValueString.toLowerCase() : curItem.ValueInt.toString());
                        }
                        if (found === false && elemModel.ValidationDropdownItems.length <= 1) {
                            let cbDataList = comboBox.dataSource.data();
                            for (let i = 0; i < cbDataList.length && found === false; i++) {
                                let curItem = cbDataList[i];
                                if (value.toString().toLowerCase() === curItem.value.toString().toLowerCase()) {
                                    found = true;
                                }
                            }
                        }
                        returnValue = found;
                    }
                }
            }
        }
        return returnValue;
    }

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
    /// <summary>
    /// Creates a field validator.
    /// </summary>
    /// <param name="model">The field model.</param>
    /// <returns></returns>*/
    self.CreateFieldValidator = function (model) {
        if (
            model.FieldType &&
            model.FieldType != "Button" &&
            model.FieldType != "Grid" &&
            model.FieldType != "Image" &&
            model.FieldType != "Label" &&
            model.FieldType != "CheckBox"
        ) {
            var field = $("#f" + model.FieldId);
            //VRS-5885
            var isEnabled = field.data("field").IsEnabled;
            if (typeof (isEnabled) === "boolean") {
                field.data("initEnabled", isEnabled);
            }
            else {
                field.data("initEnabled", false);
            }

            var error = model.PatternError;
            if (model.InputPattern && model.InputPattern.length > 0) {
                if (!error || error.length == 0) {
                    error = "Invalid format.";
                }
                $(field).attr("pattern", VR.Common.HtmlEscape(model.InputPattern));
                $(field).attr("data-pattern-msg", VR.Common.HtmlEscape(error));
            }

            if (model.InputMax) {
                $(field).attr("max", VR.Common.HtmlEscape(model.InputMax));
                $(field).attr("data-max-msg", "The number exceeds maximum.");
            }

            if (model.InputMin) {
                $(field).attr("min", VR.Common.HtmlEscape(model.InputMin));
                $(field).attr("data-max-msg", "The number is below minimum.");
            }

            if (model.InputStep) {
                $(field).attr("step", VR.Common.HtmlEscape(model.InputStep));
            }

            if (model.FieldType != "AutoComplete" && model.FieldType != "TextBox") {
                //Delay OnChange for AutoComplete so that it won't fired many time unnecessarily.
                field.on("change", function (e) {
                    if (model.FieldType == "ComboBox") {
                        var combobox = $(this).data("kendoComboBox");
                        var previousvalue = $(this).data("prevValue");
                        if (combobox.value() == previousvalue) {
                            return;
                        } else {
                            $(this).data("prevValue", combobox.value());
                        }
                    }

                    self.DoFieldValueChanged(this);
                    if (combobox) {
                        model.PreviousValue = combobox.value();
                    } else {
                        model.PreviousValue = self.GetInputValue(this);
                    }
                });
            }

            field.off("keydown.cfv").on("keydown.cfv", function (e) {
                if (
                    $(this).hasClass("readonly-text") &&
                    $(this).is(":not([role='listbox'])")
                ) {
                    if (e.which != 9) {
                        e.preventDefault();
                    }
                }
                // Handle Tab for fields whose type-specific keydown may not be bound on the live element
                if (e.which === 9 && !e.isDefaultPrevented()) {
                    var m = $(this).data("field");
                    if (m) {
                        e.preventDefault();
                        e.stopPropagation();
                        var now = performance.now();
                        if (now - self._lastTabTime < 150) return;
                        self._lastTabTime = now;
                        if (m.FieldType !== "Button") {
                            self.DoFieldValueChanged("#f" + m.FieldId);
                        }
                        var input = $("#f" + m.FieldId);
                        self.DoSkipFields(input);
                        VR.Script._editRedirectedFocus = false;
                        m._validating = false;
                        self.ValidateFieldRules(input, m);
                        if (VR.Script._editRedirectedFocus && !e.shiftKey) {
                            return;
                        }
                        if (e.shiftKey) { VR.Script._editRedirectedFocus = false; }
                        self.FocusNextField(m, e.shiftKey);
                    }
                }
            });

            field.off("blur.cfv").on("blur.cfv", function (e) {
                console.log("onblur field=" + $(this).attr("id"));
                var model = $(this).data("field");

                // Prevent multiple blur processing
                if (model && model._processingBlur) {
                    return;
                }

                if (model) {
                    model._processingBlur = true;

                    setTimeout(function () {
                        model._processingBlur = false;
                    }, 150);
                }

                if ($(this).hasClass("readonly-text") || !model || !model.IsEnabled || model._validating) {
                    return;
                }
                var prevStr;
                var curStr;
                var prevVal;
                var curVal;
                if (model.FieldType == "TextBox") {
                    if (!model.PreviousValue) {
                        if (model.OriginalValue != null) {
                            model.PreviousValue = model.OriginalValue;
                        }
                        else {
                            model.PreviousValue = "";
                        }
                    }
                    prevStr = model.PreviousValue;
                    curStr = self.GetInputValue(this); //do we want to pass in a false here for procesing before the DoFieldValueChanged?

                    //VRS-5681 - run normal field value changed process when just clicking out of a field (mainly used to fix correct casing on field)
                    if (model.FieldType != "Button") {
                        self.DoFieldValueChanged("#f" + model.FieldId);
                        if (model.FieldType == "Signature") {
                            self.ValidateField("#f" + model.FieldId);
                        }
                    }
                }
                else {
                    prevVal = ~~(model.OriginalValue && model.OriginalValue != ""); // this can't be right, only looks at the original value
                    curVal = ~~(self.GetInputValue(this) && self.GetInputValue != ""); // the second step is to check if the function exists?
                }

                var status = ~~(
                    model.FieldStatus &&
                    (model.FieldStatus == "skipped" || model.FieldStatus == "overridden")
                );


                if (
                    (model.FieldType == "AutoComplete" && model.HasChange) ||
                    (model.FieldType == "ComboBox" && model.HasChange) ||
                    (curVal != prevVal && status == 1) || // does this do anything?
                    (model.FieldType == "TextBox" && curStr != prevStr) //for text box do I need an equivalent status check or is the doField's check sufficient?
                ) {
                    //Do not process OnChange for AutoComplete so that it won't fire many times unnecessarily.
                    //Note that TextBox does not process for on change
                    //note that DoFieldValueChanged is called in onchange for some controls and here for others or sometimes both
                    self.DoFieldValueChanged(this); //skipped is handled inside of DoFieldValueChanged
                }

                // after we are done, the fieldvalue will
                // become the previousvalue for the next time through
                if (model.FieldType == "TextBox") {
                    model.PreviousValue = self.GetInputValue(this);
                }
                VR.Script.LastFocus = { model: model, field: this };
                self.DoFilterFields(this);
                //VR.Diagnostic.AddEvent(new VR.Diagnostic.Event("Field Blur", e));
                let initEnabled = $(e.target).data("initEnabled");
                // Kendo validator removed — call validation directly
                if (!model._blurValidated) {
                    model._blurValidated = true;
                    self.ValidateFieldRules(field, model);
                    setTimeout(function() { model._blurValidated = false; }, 300);
                }

            });

            // Kendo validator removed — validation logic moved to ValidateFieldRules()
            var data = field.data("field");
            if (!data) {
                field.data("field", model);
            }
            var dropdownBox = field.data("kendoDropDownList");
            if (dropdownBox) {
                //now dropdowns may not have a filter we'll need to check to see if the input exists.
                if (dropdownBox.filterInput) {
                    dropdownBox.filterInput.off("focus.cfv").on("focus.cfv", function () {
                        var model = $(this).data("field");

                        // Prevent multiple focus processing
                        if (model && model._processingFocus) {
                            return;
                        }

                        if (model) {
                            model._processingFocus = true;

                            setTimeout(function () {
                                model._processingFocus = false;
                            }, 150);

                            nx.Model = model;
                            //model.Validated = false;
                        } else {
                            nx.Model = null;

                        }
                        if ($(this).val() == "")
                            $(this).trigger($.Event("keydown", { keyCode: 8 }));
                    });
                }
            } else {
                field.off("focus.cfv").on("focus.cfv", function (e) {
                    console.log("onfocus this=" + $(this).attr("id"));
                    var model = $(this).data("field");

                    // Prevent multiple focus processing
                    if (model && model._processingFocus) {
                        return;
                    }

                    if (model) {
                        model._processingFocus = true;

                        setTimeout(function () {
                            model._processingFocus = false;
                        }, 150);

                        nx.Model = model;
                        //model.Validated = false;
                        console.log("onfocus model.FieldName=" + model.FieldName);
                    } else {
                        nx.Model = null;
                        console.log("onfocus nodata");
                    }
                });
            }
        }
    }; //CreateFieldValidator

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Creates the HTML string for the image viewer.
        /// </summary>
        /// <param name="result">The image reqest ressponse model.</param>
        /// <param name="image">The image model.</param>
        /// <returns>The HTML string for the image editor.</returns>*/
    self.CreateImageViewer = function (result, image) {
        var type = result.FileType;
        if (type) {
            type = type.toLowerCase();
        }
        var html = "";
        if (!result || !result.Images || result.Images.length < 1) {
            return html;
        }

        if (result.Images.length == 1) {
            var source = result.Images[0];
            var imageId = image ? image.ImageId : 'single';
            var description = image ? VR.Common.HtmlEscape(image.Description || 'Image') : 'Image';

            switch (type) {
                case "bmp":
                case "gif":
                case "tiff":
                case "jpeg":
                case "png":
                    if (type == "tiff") {
                        type = "jpeg";
                    }
                    html +=
                        "<img id='single-image-" + imageId + "' class='edit-image' src='data:image/" +
                        VR.Common.HtmlEscape(type) +
                        ";base64," +
                        VR.Common.HtmlEscape(source) +
                        "' alt='" + description + "' role='img' aria-label='" + description + "' data-testid='single-image-" + imageId + "' />";
                    break;
                case "pdf":
                    var key =
                        "key=" +
                        source +
                        "|email=" +
                        true +
                        "|print=" +
                        true +
                        "|save=" +
                        true +
                        "|event=" +
                        self.EventName +
                        "|eventid=" +
                        self.EventId +
                        "|name=AttachedFile" +
                        "|local=" +
                        self.GetFieldValue("LOCAL_FILE_NUMBER") +
                        "|dialog=" +
                        true +
                        "|copy=" +
                        1 +
                        "|printer=" +
                        "|open=" +
                        false;
                    var selection = "selection=" + encodeURIComponent(key);
                    var url =
                        VR.Common.GetRootURL() +
                        "report/report?selection=" +
                        encodeURIComponent(selection);
                    html += "<iframe id='pdf-viewer-" + imageId + "' src='" + url + "' title='" + description + " PDF Viewer' aria-label='PDF document viewer for " + description + "' data-testid='pdf-viewer-" + imageId + "'></iframe>";
                    break;
                default:
                    html +=
                        "<div id='file-container-" + imageId + "' class='edit-filecontainer' role='region' aria-label='File viewer for " + description + "' data-testid='file-container-" + imageId + "'>" +
                        "<img id='file-preview-" + imageId + "' style='height: 200px; width: 150px; margin: 50px;' src='" +
                        image.ImageSource +
                        "' alt='" + description + " preview' data-testid='file-preview-" + imageId + "' />" +
                        "<iframe id='file-iframe-" + imageId + "' class='edit-iframe' src='" +
                        VR.Common.GetRootURL() +
                        VR.Common.HtmlEscape(source) +
                        "' title='" + description + " file viewer' aria-label='File viewer for " + description + "' data-testid='file-iframe-" + imageId + "'></iframe></div>";
                    break;
            }
        } else {
            // Multi-image case - FIX: Define imageId and description here
            var imageId = image ? image.ImageId : 'multi';
            var description = image ? VR.Common.HtmlEscape(image.Description || 'Image') : 'Image';

            // Images first
            $.each(result.Images, function (index, source) {
                var style = "";
                if (index > 0) {
                    style = "style=' display: none; '";
                }
                html +=
                    "<img id='page-image-" + imageId + "-" + index + "' class='edit-image' " +
                    style +
                    " data-page-number='" +
                    index +
                    "' src='data:image/jpeg;base64," +
                    VR.Common.HtmlEscape(source) +
                    "' alt='" + description + "' role='img' aria-label='" + description + "' data-testid='page-image-" + imageId + "-" + index + "' />";
            });
        }

        return html;
    }; //CreateImageViewer

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Creates the image editor window.
        /// </summary>
        /// <param name="id">The element Id.</param>
        /// <param name="result">The image reqest ressponse model.</param>
        /// <returns></returns>*/
    self.CreateImageWindow = function (id, result) {
        var windowHost = $("#" + id + "-window");
        windowHost.data("Image", result);
        var height = $("nav").height();
        height = VR.Common.ToFloat(height) + 20;
        var top = height + "px";
        var width = "60%";
        height = "80%";
        var left = "20%";
        if (VR.Common.IsMobile()) {
            if (VR.Common.IsNavBurger()) {
                width = "98%";
                left = "1%";
            } else {
                width = "90%";
                left = "5%";
            }
        }

        var idstring = VR.Common.HtmlEscape(id);

        windowHost.kendoWindow({
            animation: false,
            position: {
                top: top,
                left: left
            },
            height: height,
            width: width,
            title: "Image Viewer",
            actions: ["Pin", "Close"],
            "data-testid": "image-window-" + id,
            close: function (e) {
                setTimeout(function () {
                    $(".k-window").css("z-index", "1000");
                }, 1000);
            },
            open: function (e) {
                var iframe = windowHost.find(".edit-iframe");
                $(iframe).css("display", "none");
                var elemenet = windowHost.parents(".k-window");
                elemenet.css("z-index", "1000");
                var parentWindow = windowHost.data("kendoWindow");
                var result = windowHost.data("Image");
                var type = result.FileType;
                if (type) {
                    type = type.toLowerCase();
                }
                var isImage = false;
                switch (type) {
                    case "bmp":
                    case "gif":
                    case "tiff":
                    case "jpeg":
                    case "png":
                        isImage = true;
                        break;
                }
                if (isImage) {
                    parentWindow.Annotation = result.Annotations;
                    parentWindow.AnnotationWidth = result.AnnotateWidth;
                    parentWindow.AnnotationHeight = result.AnnotateHeight;
                    if (result.Images.length > 1) {
                        setTimeout(function (e) {
                            var canvas = idstring + "-canvas";
                            var image = idstring + "-editor";
                            VR.Image.Annotation.InitTiffImage(canvas, image, parentWindow);
                        }, 300);
                    } else {
                        setTimeout(function (e) {
                            var canvas = idstring + "-canvas";
                            var image = idstring + "-editor";
                            VR.Image.Annotation.InitImage(canvas, image, parentWindow);
                        }, 300);
                    }
                }
            },
            visible: false
        });

        windowHost.css("z-index", "1000");
        if (VR.Common.IsMobile()) {
            var parents = windowHost.parents(".k-window");
            var handle = parents.find(".k-resize-se");
            handle.css("opacity", "1");
            handle.css("background-color", "#66f");
            handle.css("z-index", "1010");
            handle.css("width", "32px");
            handle.css("height", "32px");
        }

        var description = VR.Common.HtmlString(result.Description);
        var html = "<div class='image-window-container'>";

        // Header section with controls
        html += "<div class='image-window-header'>";
        html += "<div class='image-metadata'>";
        html += "<label for='image-description-" + idstring + "'>Description:</label>";
        html += "<input type='text' id='image-description-" + idstring + "' class='imagedit-input' value='" + VR.Common.HtmlEscape(description) + "' />";
        html += "</div>";

        if (self.ImageSecurity && self.ImageSecurity.CanSetSecurity) {
            html += "<div class='security-controls' style='margin-left: 115px;'>";
            html += "<label for='" + VR.Common.HtmlEscape(id) + "-imagewindow-appfunction'>Function:</label>";
            html += "<input type='search' id='" + VR.Common.HtmlEscape(id) + "-imagewindow-appfunction' value='" + VR.Common.HtmlEscape(result.ApplicationFunction || '') + "' />";
            html += "</div>";
        }
        html += "</div>";

        if (self.ImageSecurity && self.ImageSecurity.CanInactivate) {
            var checkid = VR.Common.HtmlEscape(id) + "-check";
            var checked = "";
            if (result.IsActive) {
                checked = "checked='checked'";
            }
            html += "<div class='checkbox-controls' style='margin-top: 10px;'>";
            html += "<input class='imagedit-input' type='checkbox' id='" + checkid + "' " + checked + " data-testid='" + checkid + "' " + checked + " style='margin-right: 5px; vertical-align: middle;' />";
            html += "<label for='" + checkid + "' style='display: inline; vertical-align: middle;'>Is Active?</label>";
            html += "<span style='margin-left: 20px;font-weight: bold;'>Created: " + (result.DateCreated ? kendo.toString(kendo.parseDate(result.DateCreated), 'MM/dd/yyyy') : 'N/A') + "</span>";
            html += "</div>";
        }

        // Action buttons section
        html += "<div class='image-controls'>";
        var type = result.FileType;
        if (type) {
            type = type.toLowerCase();
        }
        var isImage = false;
        switch (type) {
            case "bmp":
            case "gif":
            case "tiff":
            case "jpeg":
            case "png":
                isImage = true;
                break;
        }

        if (isImage && (result.IsActive || (self.ImageSecurity && self.ImageSecurity.CanPrintInactive))) {
            html += "<button type='button' class='btn btn-warning' id='imageviewer-print-" + id + "' data-testid='imageviewer-print-" + id + "'>Print</button>";
        }
        if (self.ImageSecurity && self.ImageSecurity.CanUpdateImage) {
            html += "<button type='button' class='btn btn-info' id='imageviewer-edit-" + id + "' data-testid='imageviewer-edit-" + id + "'>Edit</button>";
        }
        if (result && result.CanSaveImage) {
            html += "<button type='button' class='btn btn-success' id='imageviewer-save-" + id + "' data-testid='imageviewer-save-" + id + "'>Save</button>";
        }
        html += "<button type='button' class='btn btn-primary imageviewer-closebutton' id='imageviewer-close-" + id + "' data-testid='imageviewer-close-" + id + "'>Close</button>";
        if (isImage && self.ImageSecurity && self.ImageSecurity.CanToggleAnnote) {
            html += "<button type='button' class='btn btn-default' id='imageviewer-toggle-" + id + "' data-testid='imageviewer-toggle-" + id + "'>Toggle Annotation</button>";
        }
        html += "</div>";

        // Content section with pager and images
        html += "<div class='image-window-content'>";

        // Pager section
        if (result.Images.length > 1) {
            html += "<div class='image-pager-container'>";
            html += "<div id='imageviewer-pager-" + id + "' class='image-pager'></div>";
            html += "</div>";
        }

        // Image display area
        html += "<div class='edit-image-container' style='height: 100%' role='img' aria-labelledby='image-label-" + idstring + "' data-testid='image-container-" + idstring + "'>";
        html += "<span id='image-label-" + idstring + "' class='sr-only'>" + VR.Common.HtmlEscape(description) + "</span>";
        html += "<div id='" + idstring + "-editor' class='editor-image' style='height: 100%' role='img' aria-label='Main Image Display' data-testid='image-editor-" + idstring + "' /></div>";
        html += "<div><canvas id='" + idstring + "-canvas' class='annotation-canvas' role='img' aria-label='Image Annotations Layer' data-testid='image-canvas-" + idstring + "'></canvas></div>";
        html += "</div>";

        html += "</div>"; // Close image-window-content
        html += "</div>"; // Close image-window-container

        // Hidden elements
        html += "<div id='" + idstring + "-backup' data-testid='" + idstring + "-backup' style='display:none;'></div>";
        html += "<div id='" + idstring + "-workarea' data-testid='" + idstring + "-workarea' style='display:none;'><canvas id='" + idstring + "-workcanvas'></canvas></div>";

        windowHost.html(html);
        //console.log("Image display area found:", windowHost.find('.image-display-area').length);

        // Initialize controls
        windowHost.find("input[type='text']").kendoAutoComplete({
            placeholder: "Enter image description"
        });

        var dataSource = new kendo.data.DataSource({
            transport: {
                read: function (options) {
                    var filterValue = "";
                    if (options.data && options.data.filter && options.data.filter.filters.length > 0) {
                        filterValue = options.data.filter.filters[0].value;
                    }

                    var url = VR.Common.GetRootURL("event/edit");
                    VR.Common.SecurePost(
                        url + "data/secfile",
                        filterValue,
                        function (result) {
                            if (result.Code == 0) {
                                var data = [];
                                data.push({ text: " ", value: "" });
                                $.each(result.List, function (index, item) {
                                    data.push({ text: item, value: item, key: item });
                                });
                                options.success(data);
                            } else {
                                options.error(result);
                                VR.Common.HandleInvalidResult(result, "Image", true);
                            }
                        },
                        true,
                        undefined,
                        false,
                        false
                    );
                }
            },
            serverFiltering: true,
            schema: {
                data: function (response) {
                    return response;
                }
            }
        });

        var input = windowHost.find("input[type='search']");
        input.kendoComboBox({
            autoBind: false,
            dataTextField: "text",
            dataValueField: "value",
            dataSource: dataSource,
            filter: "contains",
            minLength: 1,
            placeholder: "Select application function",
            height: 160,
            change: function (e) {
                var editor = $("#" + id + "-editor");
                var changed = editor.attr("data-changed") || "";
                if (!changed.includes("sec")) {
                    changed += "|sec";
                }
                editor.attr("data-changed", changed);
            }
        });

        var combobox = $(input).data("kendoComboBox");
        if (combobox && result.ApplicationFunction) {
            combobox.value(result.ApplicationFunction);
        }

        setupAppFunctionDropdown(input, "create");

        var inputs = windowHost.find(".imagedit-input");
        inputs.on("change", function (e) {
            var type = $(this).attr("type");
            switch (type) {
                case "checkbox":
                    type = "isactive";
                    break;
                default:
                    type = "desc";
                    break;
            }
            var editor = $("#" + id + "-editor");
            var changed = editor.attr("data-changed");
            if (!changed) {
                changed = "";
            }
            if (changed.indexOf(type) == -1) {
                changed += "|" + type;
            }
            editor.attr("data-changed", changed);
        });

        var parent = windowHost.parents(".k-window");
        parent.css("z-index", "1000");

        return windowHost;
    }; //CreateImageWindow

    // Helper function for setting up Application Function dropdown attributes and events
    function setupAppFunctionDropdown(input, idstring) {
        var parent = $(input).parents(".k-combobox");
        $(parent).attr("id", "image-appfunction-combobox-" + idstring);
        $(parent).attr("data-testid", "image-appfunction-combobox-" + idstring);
        $(parent).attr("aria-label", "Application Function Selector");
        $(parent).find(".k-input-inner").attr("id", "image-appfunction-inner-" + idstring);
        $(parent).find(".k-input-inner").attr("data-testid", "image-appfunction-inner-" + idstring);
        $(parent).find(".k-input-value-text").attr("data-testid", "image-appfunction-text-" + idstring);
        $(parent).find(".k-input-button").attr("id", "image-appfunction-button-" + idstring);
        $(parent).find(".k-input-button").attr("data-testid", "image-appfunction-button-" + idstring);
        $(parent).find(".k-input-button").attr("aria-label", "Open dropdown");
        $(parent).on("keypress", function (e) {
            if (e.key == "-") {
                var dropdownlist = $(input).data("kendoComboBox");
                if (dropdownlist) {
                    dropdownlist.open();
                    $(input).select();
                }
            }
        });
    }

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Returns a HTML string for one input field.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns>The HTML string for one input field</returns>*/
    self.CreateInputField = function (model) {
        var panelHtml =
            "<div id='g" +
            VR.Common.HtmlEscape(model.FieldId) +
            "' class='form-group'><span id='l" +
            VR.Common.HtmlEscape(model.FieldId) +
            "' class='col-sm-8 col-md-6";

        if (model.IsRequired) {
            panelHtml += " required-label ";
        }

        panelHtml += "' >" + VR.Common.HtmlEscape(model.FieldLabel) + "</span>";
        panelHtml +=
            "<div id='p" +
            VR.Common.HtmlEscape(model.FieldId) +
            "' class='col-sm-8 col-md-6'><input id='f" +
            VR.Common.HtmlEscape(model.FieldId) +
            "' name='f" +
            VR.Common.HtmlEscape(model.FieldId) +
            "' " +
            " data-field-name='" +
            VR.Common.HtmlEscape(model.FieldName) +
            "'";

        if (model.FieldType == "AutoComplete") {
            panelHtml += " style=' border-color: magenta;'";
        }

        if (model.IsDisplayOnly == true) {
            panelHtml += " disabled ";
        }

        if (model.IsRequired) {
            panelHtml += " input-required required ";
        }

        panelHtml += " class='input-field";

        if (model.FieldStatus) {
            panelHtml += " input-" + VR.Common.HtmlEscape(model.FieldStatus);
        }

        panelHtml += "' ";

        var type = model.InputType;
        if (type) {
            switch (type.toLowerCase()) {
                case "datetime":
                    type = "datetime-local";
                    break;
                case "telephone":
                    type = "tel";
                    break;
            }
        }

        if (type) {
            panelHtml += " type='" + VR.Common.HtmlEscape(type) + "' ";
        }

        if (model.InputPattern) {
            var error = model.PatternError;
            if (!error) {
                error = "Invalid format.";
            }
            panelHtml +=
                " pattern='" +
                VR.Common.HtmlEscape(model.InputPattern) +
                "' data-pattern-msg='" +
                VR.Common.HtmlEscape(error) +
                "'";
        }

        if (model.InputMax) {
            panelHtml +=
                " max='" +
                VR.Common.HtmlEscape(model.InputMax) +
                "' data-max-msg='The number exceeds the maximum.' ";
        }

        if (model.InputMin) {
            panelHtml +=
                " min='" +
                VR.Common.HtmlEscape(model.InputMin) +
                "' data-min-msg='The number is less than the minimum.' ";
        }

        if (model.InputStep) {
            panelHtml += " step='" + VR.Common.HtmlEscape(model.InputStep) + "' ";
        }

        var value = VR.Common.HtmlEscape(
            VR.Common.ToFormattedValue(model.FieldValue)
        );

        if (model.Case && model.Case != "" && model.Case != "normal") {
            var testVal = self.GetInputValue($("#f" + model.FieldId), true);
            if (testVal == value) {
                panelHtml += " data-casing='keep'";
            } else {
                panelHtml += " data-casing='ignore'";
            }
        }

        panelHtml +=
            " value='" +
            value +
            "' /></div><p class='invalid-msg' id='f" +
            model.FieldId +
            "-msg' style=' display: none; '></p></div></div>" +
            "<div class='form-horizontal form-widgets col-sm-6'>";

        model.FieldValue = VR.Common.ToDate(model.FieldValue);

        return panelHtml;
    }; //CreateInputField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Creates notes editor.
        /// </summary>
        /// <param name="grid">The grid.</param>
        /// <param name="row">The grid row.</param>
        /// <returns></returns>*/
    self.CreateNotesEditor = function () {
        var editor = $("#notes-editor").data("kendoEditor");
        if (!editor) {
            var tools = false;
            if (self.IsNotesAdmin || self.CanSaveNotes) {
                tools = [
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "justifyLeft",
                    "justifyCenter",
                    "justifyRight",
                    "justifyFull",
                    "insertUnorderedList",
                    "insertOrderedList",
                    "indent",
                    "outdent",
                    "unlink",
                    "subscript",
                    "superscript",
                    "createTable",
                    "addRowAbove",
                    "addRowBelow",
                    "addColumnLeft",
                    "addColumnRight",
                    "deleteRow",
                    "deleteColumn",
                    "formatting",
                    "cleanFormatting",
                    "fontName",
                    "fontSize",
                    "foreColor",
                    "backColor",
                    "print",
                    "pdf"
                ];
            }

            $("#notes-editor").kendoEditor({
                tools: tools,
                "data-testid": "notes-editor"
            });

            var dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (options) {
                        // Get the filter value from the dropdown itself, not from a separate list
                        var filterValue = "";
                        if (options.data && options.data.filter && options.data.filter.filters.length > 0) {
                            filterValue = options.data.filter.filters[0].value;
                        }

                        var url = VR.Common.GetRootURL("event/edit");
                        VR.Common.SecurePost(
                            url + "data/secfile",
                            filterValue, // Pass the filter value to the server
                            function (result) {
                                if (result.Code == 0) {
                                    var data = [];
                                    data.push({ text: " ", value: "" });
                                    $.each(result.List, function (index, item) {
                                        data.push({ text: item, value: item, key: item });
                                    });
                                    if (!!options) options.success(data);
                                    return data;
                                } else {
                                    options.error(result);
                                    VR.Common.HandleInvalidResult(result, "Notes", true);
                                    return [];
                                }
                            },
                            true,
                            undefined,
                            false,
                            false
                        );
                    }
                },
                serverFiltering: true
            });

            var input = $("#note-secfunction");
            input.kendoDropDownList({
                autoBind: false,
                dataTextField: "text",
                dataValueField: "value",
                dataSource: dataSource,
                filter: "contains",
                height: 150
            });

            var parent = input.parents(".k-picker");
            $(parent).attr("id", "note-secfunction-dropdown").attr("data-testid", "note-secfunction-dropdown");
            $(parent).find(".k-input-inner").attr("id", "note-secfunction-inner").attr("data-testid", "note-secfunction-inner");
            $(parent).find(".k-input-value-text").attr("id", "note-secfunction-text").attr("data-testid", "note-secfunction-text");
            $(parent).find(".k-input-inner").attr("id", "note-secfunction-inner").attr("data-testid", "note-secfunction-inner");
            $(parent).find(".k-input-button").attr("id", "note-secfunction-select").attr("data-testid", "note-secfunction-select");
            $(parent).on("keypress", function (e) {
                if (e.key == "-") {
                    var dropdownlist = $(input).data("kendoDropDownList");
                    if (dropdownlist) {
                        dropdownlist.open();
                        $(input).select();
                    }
                }
            });

            editor = $("#notes-editor").data("kendoEditor");

            var body = editor.body;
            $(body).on("contextmenu", function (event) {
                event.preventDefault();
            });

            if (!self.IsNotesAdmin && !self.CanNewNotes) {
                $("#notes-new").css("diaplay", "none");
            } else {
                $("#notes-new").on("click", function (e) {
                    var editor = $("#notes-editor").data("kendoEditor");
                    if (!editor) {
                        return;
                    }

                    editor.value("");
                    var notes = {};
                    var model = {};
                    var id = $("#notes-list-body").attr("data-field-id");
                    if (id == "0") {
                        notes.FieldName = "--Record--";
                        model.FieldLabel = "--Record--";
                    } else {
                        model = self.GetFieldModel(id);
                        if (model == null) {
                            notes.FieldName = "";
                            model = { FieldLabel: "" };
                        } else {
                            notes.FieldName = model.FieldName;
                        }
                    }
                    notes.IsActive = true;

                    self.Note = notes;
                    $("#note-field-name").html(VR.Common.HtmlEscape(notes.FieldName));
                    $("#note-field-label").html(VR.Common.HtmlEscape(model.FieldLabel));
                    $("#note-isactive").attr("checked", notes.IsActive);

                    var dropdownList = $("#note-secfunction").data("kendoDropDownList");
                    if (dropdownList != null) {
                        dropdownList.select(-1);
                    }

                    $("#notes-body").attr("data-notes-id", "0");
                    $("#notes-modal").modal("show");
                });
            }

            $("#noteslist-modal").on("shown.bs.modal", function (e) {
                var dialog = $("#noteslist-modal .modal-content");
                var table = $("#notes-table");
                var height = $(dialog).height();
                var winheight = $(window).height();

                if (height > winheight - 250) {
                    height = winheight - 250;
                    $(table).css("max-height", height + "px");
                }
            });

            $("#notes-modal").on("shown.bs.modal", function (e) {
                $(document).off("focusin.modal"); //Fix for KendoDropDownList closes immediately when the dopdown is opened. http://stackoverflow.com/questions/14795035/twitter-bootstrap-modal-blocks-text-input-field
                var editor = $("#notes-editor").data("kendoEditor");
                if (editor) {
                    editor.focus();
                }
            });

            $("#notes-modal").on("hide.bs.modal", function (e) {
                self.CreateNotesList();
            });

            if (!self.IsNotesAdmin && !self.CanSaveNotes) {
                $("#notes-save").css("display", "none");
            } else {
                $("#notes-save").on("click", function (e) {
                    var editor = $("#notes-editor").data("kendoEditor");
                    if (editor == null) {
                        return;
                    }

                    var value = editor.value();
                    value = VR.Common.HtmlEscape(value);

                    var secfunc = "";
                    var dropDownList = $("#note-secfunction").data("kendoDropDownList");
                    if (dropDownList != null) {
                        secfunc = dropDownList.value();
                    }

                    var event = self.EventName;
                    var eventId = self.EventId;
                    var fieldId = $("#notes-list-body").attr("data-field-id");
                    var fieldName = $("#note-field-name").html();
                    var id = $("#notes-body").attr("data-notes-id");
                    var isActive = $("#note-isactive").attr("checked") == "checked";

                    var selection =
                        "event=" +
                        event +
                        "|eventId=" +
                        eventId +
                        "|fieldId=" +
                        fieldId +
                        "|fieldName=" +
                        fieldName +
                        "|notesId=" +
                        id +
                        "|secfunc=" +
                        secfunc +
                        "|isActive=" +
                        isActive +
                        "|value=" +
                        value;

                    selection = encodeURIComponent(selection);
                    var url = VR.Common.GetRootURL("event/edit") + "data/notesupdate";
                    VR.Common.Post(
                        url,
                        { selection: selection, value: value },
                        function (response) {
                            //var json = VR.Common.DecryptData();
                            var result = $.parseJSON(response.Json);

                            if (result.Code == 0) {
                                var id = $("#notes-body").attr("data-notes-id");
                                if (id == "0") {
                                    self.Notes.push(result.Note);
                                    self.NotesCount++;
                                    if (VR.Common.IsMobile()) {
                                        $("#mobileNotesBtnText").html(VR.Common.HtmlEscape(self.NotesCount));
                                    } else {
                                        $("#notes-count").html("Notes count: " + VR.Common.HtmlEscape(self.NotesCount));
                                    }
                                } else {
                                    var index = self.Notes.indexOf(self.Note);
                                    if (index > -1) {
                                        self.Notes.splice(index, 1);
                                        if (index >= self.Notes.length) {
                                            self.Notes.push(result.Note);
                                        } else {
                                            self.Notes.splice(index, 0, result.Note);
                                        }
                                    }
                                }
                                $("#notes-modal").modal("hide");
                            } else {
                                $("#notes-error").html(VR.Common.HtmlEscape(result.Message));
                                VR.Common.HandleInvalidResult(result, "Save Notes", false);
                            }
                        }
                    );
                });
            }
        }
    }; //CreateNotesEditor

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Creates notes list.
        /// </summary>
        /// <returns></returns>*/
    self.CreateNotesList = function () {
        var id = $("#notes-list-body").attr("data-field-id");
        var model = null;
        if (id != "0") {
            model = $("#f" + id).data("field");
        }
        var html = "";
        if (self.Notes && self.Notes.length !== 0) {
            if (VR.Common.IsMobile()) {
                $("#notes-col-hdr-id").hide();
                $("#notes-col-hdr-field").hide();
                $("#notes-col-hdr-createdate").hide();
                $("#notes-col-hdr-modusrid").hide();
                $("#notes-col-hdr-moddate").hide();
                $("#notes-col-hdr-active").hide();
                $("#notes-col-hdr-appfunct").hide();
                $.each(self.Notes, function (index, note) {
                    if (model === null || model.FieldName === note.FieldName) {
                        html += `<tr><td>${VR.Common.HtmlEscape(note.ShortNotes)}</td><td>${VR.Common.HtmlEscape(note.ModifyUserName)}</td>
                        <td><button class='btn btn-success notes-btn' id='notes-${VR.Common.HtmlEscape(note.NotesId)}'>View</button></td>`;
                        html += self.IsNotesAdmin || self.CanDeleteNotes
                            ? "<td><button class='btn btn-danger notesd-btn' id='notesd-" + VR.Common.HtmlEscape(note.NotesId) + "'>Delete</button></td>"
                            : "";
                        html += "</tr>";
                    }
                });
            }
            else {
                $.each(self.Notes, function (index, note) {
                    if (model == null || model.FieldName == note.FieldName) {
                        var create = VR.Common.ToFormattedValue(note.CreateDate);
                        var modified = VR.Common.ToFormattedValue(note.ModifyDate);
                        html +=
                            "<tr>" +
                            "<td>" +
                            VR.Common.HtmlEscape(note.NotesId) +
                            "</td>" +
                            "<td>" +
                            VR.Common.HtmlEscape(note.FieldName) +
                            "</td>" +
                            "<td>" +
                            VR.Common.HtmlEscape(note.ShortNotes) +
                            "</td>" +
                            "<td>" +
                            VR.Common.HtmlEscape(create) +
                            "</td>" +
                            "<td>" +
                            VR.Common.HtmlEscape(note.ModifyUserId) +
                            "</td>" +
                            "<td>" +
                            VR.Common.HtmlEscape(note.ModifyUserName) +
                            "</td>" +
                            "<td>" +
                            VR.Common.HtmlEscape(modified) +
                            "</td>";
                        html +=
                            self.IsNotesAdmin || self.CanDeleteNotes
                                ? "<td>" + VR.Common.HtmlEscape(note.IsActive) + "</td>"
                                : "<td></td>";
                        html +=
                            "<td>" +
                            VR.Common.HtmlEscape(note.ApplicationFunction) +
                            "</td>" +
                            "<td><button class='btn btn-success notes-btn' id='notes-" +
                            VR.Common.HtmlEscape(note.NotesId) +
                            "'>View</button></td>";
                        html +=
                            self.IsNotesAdmin || self.CanDeleteNotes
                                ? "<td><button class='btn btn-danger notesd-btn' id='notesd-" +
                                VR.Common.HtmlEscape(note.NotesId) +
                                "'>Delete</button></td>"
                                : "<td></td>";
                        html += "</tr>";
                    }
                });
            }
        }

        var noteslist = $("#notes-list");
        if (html.length == 0) {
            html = "<p>No notes to show.</p>";
        }

        noteslist.html(html);

        noteslist.find(".notes-btn").on("click", function (e) {
            var id = $(this).attr("id");
            if (id && id.length > 6) {
                id = id.substring(6);
            }

            if (!self.Notes) {
                return;
            } else {
                var notes = null;
                $.each(self.Notes, function (index, note) {
                    if (note.NotesId == id) {
                        notes = note;
                        return false;
                    }
                });

                if (notes != null) {
                    var editor = $("#notes-editor").data("kendoEditor");
                    if (!editor) {
                        return;
                    }

                    var value = notes.Notes;
                    value = VR.Common.HtmlUnescape(value);
                    editor.value(value);
                    self.Note = notes;
                    var model = self.GetFieldModel(notes.FieldName);
                    $("#note-field-name").html(VR.Common.HtmlEscape(notes.FieldName));
                    if (model) {
                        $("#note-field-label").html(VR.Common.HtmlEscape(model.FieldLabel));
                    } else {
                        $("#note-field-label").html(VR.Common.HtmlEscape(notes.FieldName));
                    }
                    $("#note-isactive").attr("checked", notes.IsActive);
                    var dropdownlist = $("#note-secfunction").data("kendoDropDownList");
                    if (dropdownlist != null) {
                        if (!notes.ApplicationFunction) {
                            dropdownlist.select(-1);
                        } else {
                            dropdownlist.select(function (item) {
                                return item.value == notes.ApplicationFunction;
                            });
                            var selected = dropdownlist.select();
                            if (selected == -1) {
                                var data = {
                                    text: notes.ApplicationFunction,
                                    value: notes.ApplicationFunction
                                };
                                dropdownlist.dataSource.add(data);
                                dropdownlist.select(function (item) {
                                    return item.value == notes.ApplicationFunction;
                                });
                                selected = dropdownlist.select();
                            }
                        }
                    }

                    $("#notes-body").attr("data-notes-id", id);
                    $("#notes-modal").modal("show");
                }
            }
        });

        if (self.IsNotesAdmin || self.CanDeleteNotes) {
            noteslist.find(".notesd-btn").on("click", function (e) {
                var id = $(this).attr("id");
                if (id && id.length > 7) {
                    id = id.substring(7);
                }

                if (!self.Notes) {
                    return;
                } else {
                    var index = -1;
                    $.each(self.Notes, function (i, note) {
                        if (note.NotesId == id) {
                            index = i;
                            return false;
                        }
                    });

                    if (index > -1) {
                        self.NotesId = id;
                        self.NotesIndex = index;
                        VR.Common.ShowMessageBox(
                            "Do you want to delete this note?",
                            self.DeleteNotes,
                            true
                        );
                    }
                }
            });
        }
    }; //CreateNotesList

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Deletes image.
        /// </summary>
        /// <param name="id">The image Id.</param>
        /// <returns></returns>*/
    self.DeleteImage = function () {
        var id = self.ImageId;
        if (id && id.indexOf("image-") > -1) {
            id = id.substring("image-".length);
        }

        id = parseInt(id);
        if (isNaN(id)) {
            return;
        }

        var selected = null;
        $.each(self.ImageDataSource.data(), function (index, model) {
            if (model.ImageId == id) {
                selected = model;
                return false;
            }
        });

        if (!selected) {
            return;
        }

        VR.Common.SecurePost("data/imagedelete", "image=" + id, function (result) {
            if (result.Code != 0) {
                VR.Common.HandleInvalidResult(result, "Image", true);
            } else {
                var list = $("#image-list");
                list.find(".image").off("dblclick");
                var images = self.ImageDataSource.data();
                var index = images.indexOf(selected);
                if (index == -1) {
                    return;
                }
                var image = images[index];
                var windowHost = $("#" + image.ImageId + "-window");
                var imageWindow = windowHost.data("kendoWindow");
                if (imageWindow) {
                    imageWindow.destroy();
                }

                images.splice(index, 1);
                self.ImageDataSource.data(images);

                $("#image-pager")
                    .data("kendoPager")
                    .refresh();
                var kendoList = list.data("kendoListView");
                kendoList.refresh();

                $("#image-list .image").on("dblclick", function (e) {
                    var imageId = this.id;
                    if (imageId.indexOf("image-") > -1) {
                        imageId = imageId.substring("image-".length);
                    }
                    var urlParams = new URLSearchParams(window.location.search);
                    var eventEditParam = urlParams.get('selection') || "";
                    var url = VR.Common.GetRootURL();
                    window.open(url + "event/imagewindow?" + eventEditParam + "&vrsimageid=" + imageId, "_blank", "popup=1,menubar=no,toolbar=no,status=no,resizable=yes,fullscreen=yes");
                });

                self.ImageCount--;
                if (VR.Common.IsMobile()) {
                    $("#mobileImagesBtnText").html(VR.Common.HtmlEscape(self.ImageCount));
                }
                else {
                    $("#images-count").html("Image count: " + VR.Common.HtmlEscape(self.ImageCount));
                }
            }
        });
    }; //DeleteImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Deletes notes.
        /// </summary>
        /// <returns></returns>*/
    self.DeleteNotes = function () {
        var url = VR.Common.GetRootURL("event/edit") + "data/notesdelete";
        VR.Common.SecurePost(
            url,
            self.NotesId,
            function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Delete Notes", false);
                } else {
                    var index = self.NotesIndex;

                    self.Notes.splice(index, 1);
                    self.CreateNotesList();
                    self.NotesCount--;
                    if (VR.Common.IsMobile()) {
                        $("#mobileNotesBtnText").html(VR.Common.HtmlEscape(self.NotesCount));
                    } else {
                        $("#notes-count").html("Notes count: " + VR.Common.HtmlEscape(self.NotesCount));
                    }
                    
                }
            },
            true,
            "notesid=",
            false,
            false
        );
    }; //DeleteNotes

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Deletes the current event record.
        /// </summary>
        /// <returns></returns>*/
    self.DeleteRecord = function () {
        var event = self.EventName;
        var eventid = self.EventId;
        var selection = "name=" + event + "|id=" + eventid;
        VR.Common.SecurePost("event/delete", selection, function (result) {
            if (result.Code != 0) {
                if (result.Code == 1370) {
                    VR.Common.ShowError(result.Message);
                } else {
                    VR.Common.HandleInvalidResult(result, "Delete Record", false);
                }
            } else {
                $("#messagebox-title").html("Event Record Deleted");
                $("#messagebox-text").html("This event record was deleted..");
                $("#messagebox-codebox").css("display", "none");
                $("#messagebox-body").css("display", "none");
                $("#messagebox-text").css("overflow", "hidden");

                var message;
                if (VR.Common.CanOpen) {
                    message = "This window will close.";
                } else {
                    message = "This window will be redirected to the dashboard.";
                }

                $("#messagebox-footer").html(message);
                $("#messagebox-header").css("background-color", "#6495ed");
                $("#messagebox-closebutton").removeClass("btn-danger");
                $("#messagebox-closebutton").addClass("btn-primary");

                $("#messagebox-modal").modal("show");

                self.CanLeaveValidated = true;

                $("#messagebox-modal")
                    .off("hidden.bs.modal")
                    .on("hidden.bs.modal", function (e) {
                        if (VR.Common.CanOpen) {
                            window.close();
                        } else {
                            $("#dashboard-menu").trigger("click");
                        }
                    });
            }
        });
    }; //DeleteRecord

    self.DisableByPassVariable = function (bypass, model, isHardEdit) {
        if (!model) {
            return "";
        }
        // Show enabled bypass buttons only if the edit is soft (not a hard edit)
        if (model && !isHardEdit && model.ByPassValue && !model.AllowUnknown) {
            if (model.ByPassValue.indexOf(bypass.toString()) > -1) {
                return "";
            } else {
                return "disabled";
            }
        } else {
            return "disabled";
        }
    }; //DisableByPassVariable

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Displays the current grid event record.
        /// </summary>
        /// <param name="parameter">The grid event parameter.</param>
        /// <returns></returns>*/
    self.DisplayEvent = function (parameter) {
        if (!parameter) {
            return;
        }

        if (
            (!self.CanSaveWithEdits && !self.CanSaveWithoutEdits) ||
            !self.CanSave ||
            self.CanClose
        ) {
            self.DisplayGridEvent(parameter);
        } else {
            var canClose = true;
            $.each(self.Fields, function (index, model) {
                if (model.HasChange) {
                    canClose = false;
                    return false;
                }
            });

            if (canClose) {
                self.DisplayGridEvent(parameter);
            } else {
                var handler = function (parameter) {
                    self.CanLeaveValidated = true;
                    self.DisplayGridEvent(parameter);
                };
                VR.Common.ShowMessageBox(
                    "You have unsaved changes. Do you want to leave this page?",
                    handler,
                    true,
                    parameter
                );
            }
        }
    }; //DisplayEvent

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Displays the current grid event record.
        /// </summary>
        /// <param name="parameter">The grid event parameter.</param>
        /// <returns></returns>*/
    self.DisplayGridEvent = function (parameter) {
        var grid = parameter.grid;
        var row = parameter.selected;
        if (!grid || !row) {
            return;
        }

        var event = grid.GridEvent;
        var item = grid.dataItem(row);
        if (item == null) {
            return;
        }

        var eventId = item[grid.GridKey];
        if (eventId == null) {
            return;
        }

        var selection = event + "-" + eventId.toString() + "-" + VR.Edit.IsCasEvent.toString();
        var input = $("#f" + grid.FieldId);
        var model = input.data("field");
        if (model && model.IsDisplayOnly) {
            selection += "-displayonly";
        }
        VR.Common.SetupEditPage(selection, VR.Common.CanOpen);
    }; //DisplayGridEvent


    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
        /// <summary>
        /// Performs house keeping job for after save.
        /// </summary>
        /// <param name="result">The returned result.</param>
        /// <param name="ChangedValues">The event values</param>
        /// <returns></returns>*/
    self.DoAfterSave = function (result, isNoEdits, ChangedValues) {
        if (!result) {
            return;
        }
        var allValues = [];
        var values = ChangedValues.split("|");
        for (var i = 0; i < values.length; i++) {
            allValues.push(values[i].substr(values[i].indexOf("=") + 1, values[i].length));
        }

        if (result.Values.length > 0) {
            $.each(result.Values, function (index, field) {
                var input = $("#f" + field.FieldId);
                var model = $(input).data("field");

                if (model) {

                    // If a value for a field was sent to the server, but the server returned no value for this field, have that field keep its value
                    // Else assign the value returned from the server to the field
                    model.FieldValue = ((field.FieldValue === "" || field.FieldValue === null) && (allValues[index] !== "" || allValues[index] !== null)) ? allValues[index] : field.FieldValue;

                    if (model.FieldType === "DatePicker") {
                        let format = model.InputFormat;
                        if (format == null || format == "") {
                            format = "MM/dd/yyyy";
                        }
                        if (
                            model.FieldValue &&
                            model.FieldValue.indexOf("99") < 0 &&
                            model.FieldValue.indexOf("88") < 0
                        ) {
                            model.FieldValue = moment(model.FieldValue).format(
                                format.toUpperCase()
                            );
                            input.val(model.FieldValue);
                        }
                    }

                    if (model.FieldType != "Image") {
                        model.OriginalValue = model.FieldValue;
                        if (model.isRetained && editPageData.CRUDType == "Create") {
                            setStickyValue(model.FieldId, model.FieldValue);
                        }
                    } else {
                        var value = $("#f" + model.FieldId).attr("field-changed");
                        if (value != "1") {
                            model.OriginalValue = model.FieldValue;
                        } else {
                            var url = VR.Common.GetRootURL("event/edit") + "data/imagesave";
                            var src = $("#f" + model.FieldId).prop("src");
                            if (src && src != "" && src.indexOf("data:image/") > -1) {
                                src = src.replace(/\+/g, "#");
                            } else {
                                src = null;
                            }
                            var eventId = self.EventId;
                            var id = model.FieldValue;
                            var selection =
                                "data=" +
                                src +
                                "|id=" +
                                id +
                                "|eventId=" +
                                eventId +
                                "|fieldId=" +
                                model.FieldId;
                            selection = encodeURIComponent(selection);
                            var data = { selection: selection };
                            VR.Common.Ajax({
                                type: "POST",
                                url: url,
                                data: data,
                                success: function (response) {
                                    //var json = VR.Common.DecryptData(response.Json);
                                    var result = $.parseJSON(response.Json);

                                    if (result.Code != 0) {
                                        VR.Common.HandleInvalidResult(result, "Save Image", true);
                                    } else {
                                        if (id == null || id == "" || id != result.Message) {
                                            model.FieldValue = result.Message;
                                            model.OriginalValue = model.FieldValue;
                                        }
                                        $("#f" + model.FieldId).attr("field-changed", "");
                                    }
                                },
                                dataType: "json",
                                async: false
                            });
                        }
                    }

                    if (input.length > 0) {
                        self.ForceSetFieldValue(input, model.FieldValue);
                    }
                    model.HasChange = false;

                    var errorData = null;
                    if (result.Errors && result.Errors.length > 0) {
                        $.each(result.Errors, function (index, error) {
                            if (model.FieldId == error.FieldId) {
                                model.HasSaveError = true;
                                errorData = error;
                                return false;
                            }
                        });

                        if (errorData != null) {
                            model.ErrorMessage = errorData.Message;
                            self.AddErrorField(model);
                            self.ErrorPanel.setError({
                                field: input,
                                model: model,
                                message: errorData.Message,
                                location: errorData.Location,
                                isHardEdit: errorData.IsHardEdit
                            });
                        }
                    }
                }
            });
        }

        self.InitFields(null, isNoEdits);

        // Remove the existing alerts
        self.Alerts.splice(0, self.Alerts.length);
        if (result.Alerts) {
            if (result.Alerts.length > 0) {
                // Populate the Alerts with the number of Actual alerts returned from the server
                $.each(result.Alerts, function (index, alert) {
                    self.Alerts.push(alert);
                });
            }
        }
        self.SyncEventAlertsCount(result.Alerts.length);

        var alerts = $("#alerts-dropdown").data("kendoDropDownList");
        if (alerts) {
            var dataSource = new kendo.data.DataSource({
                data: self.Alerts
            });
            alerts.setDataSource(dataSource);
            alerts.select(0);
            alerts.trigger("change");
        }

        if (result.Code == 0) {
            self.EventId = result.EventId;
            var title = $("#main-container").attr("event-title");
            title = title + " : " + self.EventId;
            $("#plugins").html(VR.Common.HtmlEscape(title));
            self.SaveCount++;
            VR.Common.CreateAmendmentsMenu();
            VR.Common.CreateDocumentsMenu();
            self.SetupNotes();
            $("#mobileErrorsBtnText").html(`${self.GetFieldErrorCount()}`);
        }
    }; //DoAfterSave

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Performs field value changed functions.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <returns></returns>*/
    self.DoFieldValueChanged = function (input) {
        var model = $(input).data("field");
        var curVal = self.GetInputValue(input, true);
        var fieldVal = model.FieldValue;
        var origVal = "";
        //VRS-5885
        if (typeof (model) === "object" && typeof (model.FieldValue) !== "undefined" && model.FieldValue !== null) {
            origVal = model.OriginalValue;
        }
        //below we use bitwise operators (https://www.w3schools.com/js/js_bitwise.asp)
        // the | is a bitwise OR which sets each bit to 1if one of two bits is 1
        // << Shifts left by pushing zeros in from the right and let the leftmost bits fall off. The number following << is the number of places to shift.
        // EXAMPLE: this is a new record and we are setting the value of the field for the first time.
        //      fieldVal = 0 or 00000
        //      curVal = 1 or 00001
        //      fieldVal == curVal = 0 or 00000
        //  this evaluates to (0 | 1 | 0) or:
        //      scenario = 00000
        //                 00010
        //                 00000
        //        result = 00010 or 2
        // EXAMPLE2: this is an existing record and we have changed the value of the field.
        //      fieldVal = 1 or 00001
        //      curVal = 1 or 00001
        //      fieldVal == curVal = 0 or 00000
        //  this evaluates to (0 | 1 | 0) or:
        //      scenario = 00001
        //                 00010
        //                 00000
        //        result = 00011 or 3
        var scenario =
            ~~(fieldVal && fieldVal != "") |
            (~~(curVal && curVal != "") << 1) |
            (~~(curVal == fieldVal) << 2);
        switch (scenario) {
            case 1:
            //curval != fieldVal, only prev val is set with a value != ""
            case 2:
            //curval != fieldVal, only curval is set with a value != ""
            case 3:
                var model = $(input).data("field");
                if (model.AllowOther === true && model.FieldType === "ComboBox" && curVal !== "") {
                    let setFieldStatus = Array.isArray(model.ValidationDropdownItems) && !model.ValidationDropdownItems.map(x => x.ValueInt === null ? x.ValueString : x.ValueInt).includes(curVal);
                    if (setFieldStatus) {
                        let cBox = $(input).data("kendoComboBox");
                        if (cBox) {
                            //VRS-5885
                            let data = null;
                            if (typeof (cBox.dataSource) === "object") {
                                data = cBox.dataSource.data();
                            }
                            if (data) {
                                setFieldStatus = !data.map(x => x.value.toLowerCase()).includes(curVal.toLowerCase());
                            }
                        }
                    }
                    if (setFieldStatus) {
                        self.SetFieldStatus(input, model, "literal", null, null);
                    }
                    else {
                        self.ResetField(input);
                    }
                }
                else {
                    // both curval and fieldVal are set, but !=
                    self.ResetField(input);
                }
                break;
            case 4:
            // curval = fieldVal because neither are set
            case 7:
                // curval = fieldVal, both are set
                // VRS-5670 Tom Barlock 1/29/2024 - commented out if statement
                //if (curVal == origVal) {
                //    model.HasChange = false;
                //    model.HasChangeOvrd = false;
                //}
                break;
            default:
            //nonsense conditions, throw some exception to handle it, or ignore
        }

        if (!model) {
            return;
        }

        var id = input.id;
        var name = $(input).attr("data-field-name");
        if (name) {
            //var inputs = $("#tab-content").find("input[data-field-name='" + name + "']");
            var inputs = self.GetInputFields(name);

            if (inputs.length > 0) {
                $.each(inputs, function (i, field) {
                    var format = $(field).data("casing") != "ignore";
                    var value = self.GetInputValue(input, format);
                    self.SetFieldValue(field, value, false, true);
                });
            }
        }

        // if form is initializing or field value has changed.
        if (self.State <= 0 || curVal != model.PreviousValue) {
            self.DoRelatedFields(input);
        }
    }; //DoFieldValueChanged
    function performLookup(
        fieldId,
        value,
        filter,
        valfiltertype,
        voidVal,
        webfiltertype,
        eventYear,
        responseFunction
    ) {
        var model = $("#f" + fieldId).data("field");
        if (VR.Edit.State <= 0) return;
        let lookupType = null;
        if (model && typeof (model.LookupType) === "string") {
            lookupType = model.LookupType;
        }
        var url = "data/lookup";
        var request = {
            FieldId: fieldId,
            Value: ((value || "") + "").replace(/\|\|/g, "").replace(/\|$/, ""),
            Filter: ((filter || "") + "").replace(/\|\|/g, "").replace(/\|$/, ""),
            ValFilterType: ((valfiltertype || "") + "")
                .replace(/\|\|/g, "")
                .replace(/\|$/, ""),
            VoidValue: ((voidVal || "") + "").replace(/\|\|/g, "").replace(/\|$/, ""),
            WebFilterType: ((webfiltertype || "") + "")
                .replace(/\|\|/g, "")
                .replace(/\|$/, ""),
            EventYear: VR.Edit.EventYear,
            LookupType: lookupType
        };
        request.Value = request.Value.trim();

        VR.Common.SecurePost(
            url,
            { lookup: request },
            function (e) {
                responseFunction(e);
            },
            false
        );
    }

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Performs filter field change.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <param name="value">The filter value.</param>
        /// <returns></returns>*/
    self.DoFilterField = function (input, value) {
        var model = $(input).data("field");
        if (!model || model.FieldType != "ComboBox") {
            return;
        }

        if (!model.FilterValue || model.FilterValue != value) {
            model.FilterValue = value;
            var filterValues = self.GetFilterValues(model);
            filterValues = filterValues;
            var voidVal = "";
            if (model && model.VoidField) {
                voidVal = self.GetFieldValue(model.VoidField);
            }
            voidVal = voidVal;
            var url = VR.Common.GetRootURL("event/edit");
            var field = model;

            var valfiltertype = "";
            if (model && model.ValFilterType) {
                valfiltertype = model.ValFilterType;
            }
            valfiltertype = encodeURIComponent(valfiltertype);
            var webfiltertype = "";
            if (model && model.WebFilterType) {
                webfiltertype = model.WebFilterType;
            }
            webfiltertype = encodeURIComponent(webfiltertype);

            //var webfiltertype = model.WebFilterType;
            //var valfiltertype = model.ValFilterType;
            performLookup(
                model.FieldId,
                "",
                filterValues,
                valfiltertype,
                voidVal,
                webfiltertype,
                self.EventYear,
                function (result) {
                    var data = [];
                    var index = -1;
                    var value = self.GetFieldValue(model.FieldId);
                    var comboBox = $(input).data("kendoComboBox");
                    if (result.Code != 0) {
                        VR.Common.HandleInvalidResult(result, "Lookup", true);
                    }
                    else if (result.DropdownOptions) {
                        for (let i = 0; i < result.DropdownOptions.length; i++) {
                            let option = result.DropdownOptions[i];
                            let curValue = option.ValueInt === null ? option.ValueString : option.ValueInt;
                            if (value == curValue) {
                                index = i;
                            }
                            data.push({ text: option.Label, value: curValue });
                        }
                        if (comboBox) {
                            comboBox.dataSource.data(data);
                            comboBox.refresh();
                            if (index > -1) {
                                comboBox.select(index);
                            }
                        }
                    }
                    else if (result.List) {
                        for (var i = 0; i < result.List.length; i++) {
                            var val = result.List[i];
                            if (value == val) {
                                index = i;
                            }
                            data.push({ text: val, value: val });
                        }

                        if (data.length == 0) {
                            //data.push({ text: "", value: "" });
                        }
                        if (comboBox) {
                            comboBox.dataSource.data(data);
                            comboBox.refresh();
                            if (index > -1) {
                                comboBox.select(index);
                            }
                        }
                    }
                }
            );
        }
    }; //DoFilterField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Performs filter field changes.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <returns></returns>*/
    self.DoFilterFields = function (input) {
        var model = $(input).data("field");
        if (model && model.FilterDependents && model.FilterDependents.length > 0) {
            var value = self.GetInputValue(input);
            $.each(model.FilterDependents, function (index, id) {
                var field = $("#f" + id);
                self.DoFilterField(field, value);
            });
        }
    }; //DoFilterFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Performs related field functions.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <returns></returns>*/
    self.DoRelatedFields = function (input) {
        var model = $(input).data("field");
        if (!model) {
            return;
        }

        if (!model.RelatedFields || model.RelatedFields.length == 0) {
            self.DoSkipFields(input);
            return;
        }

        var key = null;
        switch (model.FieldType) {
            case "AutoComplete":
                var autocomplete = $(input).data("kendoAutoComplete");
                if (autocomplete != null) {
                    var val = autocomplete.value();
                    var list = autocomplete.dataSource.data();
                    var index = -1;
                    if (list && list.length > 0) {
                        $.each(list, function (i, data) {
                            if (data != null && data.text == val) {
                                if (data.key != null) {
                                    key = data.key;
                                }
                                return false;
                            }
                        });
                    }
                }
                break;
            case "ComboBox":
                var combobox = $(input).data("kendoComboBox");
                if (combobox != null) {
                    var dataItem = combobox.dataItem();
                    if (dataItem != null && dataItem.key != null) {
                       key = dataItem.key;
                        
                    }
                }
                break;
        }

        var value = $(input).val();
        if (!value) {
            value = "";
        }
        if (value != "" && !nx.IsInList(model.FieldId)) {
            value = "OTHER";
        }
        var request = {
            RelatedFields: model.RelatedFields,
            Value: value,
            FieldId: model.FieldId
        };

        if (key != null) {
            request.Key = key;
        }
        if (model && model.VoidField) {
            var voidVal = self.GetFieldValue(model.VoidField);
            request.VoidValue = voidVal;
        }

        request.Filter = self.GetFilterValues(model);

        var url = VR.Common.GetRootURL("/event/edit") + "data/related";
        VR.Common.SecurePost(
            url,
            { request: request },
            function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Related", true);
                    return;
                }
                model.HasRelatedValue =
                    result.Code == 0 && result.Data && result.Data.length > 0;
                self.DoSkipFields(input);
                $.each(model.RelatedFields, function (index, id) {
                    var data = null;
                    if (model.HasRelatedValue) {
                        for (var i = 0; i < result.Data.length; i++) {
                            if (result.Data[i].FieldId == id) {
                                data = result.Data[i];
                                break;
                            }
                        }
                    }

                    var related = $("#f" + id);
                    var relatedModel = related.data("field");
                    if (model.HasRelatedValue) {
                        if (data != null) {
                            var value = VR.Common.ToFormattedValue(data.FieldValue);
                            self.SetFieldValue(related, value, true, true);
                        }
                    }

                    setTimeout(function (e) {
                        if (id != model.FieldId) {
                            self.DoRelatedFields(related);
                            self.DoSkipFields(related);
                            if (
                                relatedModel &&
                                relatedModel.FilterDependents &&
                                relatedModel.FilterDependents.length > 0
                            )
                                self.DoFilterFields(related);
                        }
                    }, 10);
                });
            },
            false,
            undefined,
            false,
            false
        );
    }; //DoRelatedFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Executes OnDisplay script.
        /// </summary>
        /// <returns></returns>*/
    self.ExecuteOnDisplay = function () {
        //var prevState = self.State;
        // VRS-6693: On-load alert firing removed from ExecuteOnDisplay.
        // This loop was dead code: VR.Script.Validate was called without a
        // `parameter` argument (guard returned early and fired nothing), it
        // passed the for..in index instead of the edit object, and it iterated
        // FieldId order. On-load alerts fire in form (tab->field) order via the
        // Initialze self.Tabs loop and ValidateOnLoad.

        var script = self.OnDisplay;
        if (!script || script == "") {
            return;
        }
        var message = VR.Script.ExecuteScript(
            {},
            {},
            { EditNumber: 0, Script: script, Kind: "ondisplay" }
        );
        if (message !== null && message !== "") {
            VR.Common.ShowError(message);
        }

        self.State = 1;
    }; //ExecuteOnDisplay

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Executes OnSave script.
        /// </summary>
        /// <returns></returns>*/
    self.ExecuteOnSave = function () {
        VR.Common.QueueManager.DequeueAll();
        var script = self.OnSave;
        if (!script || script == "") {
            return;
        }

        var edit = { EditNumber: 0, Script: script, Kind: "onsave" };
        VR.Script.ExecuteScript({}, {}, edit);
        return edit;
    }; //ExecuteOnSave

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Performs skip field logic.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <param name="isInit">The value to inidcate if this is an initilization.</param>
        /// <returns></returns>*/
    self.DoSkipFields = function (input, isInit) {
        //if ($(input).hasClass("readonly-text")) {
        //    return;
        //}

        var model = $(input).data("field");
        if (!model || !model.DependentFields || model.DependentFields.length == 0) {
            return;
        }

        $.each(model.DependentFields, function (index, dependentId) {
            var dependentfield = $("#f" + dependentId);
            var data = $(dependentfield).data("field");
            //if ((isInit && dependentfield.hasClass("readonly-text")) || !data || data.IsEnabled == false || data.IsDisplayOnly == true) {
            //    return;
            //}
            if (!data || data.IsEditable == false || data.IsDisplayOnly == true) {
                return;
            }

            $.each(data.SkipFields, function (i, skipField) {
                var field = $("#f" + skipField.FieldId);
                var value = self.GetInputValue(field).toUpperCase();
                if (value == null) {
                    value = "";
                }
                var skipvalues = skipField.SkipValues || [];
                var isSkip = false;
                for (var i = 0; i < skipvalues.length; i++) {
                    var skipval = skipvalues[i];
                    if (skipval) {
                        switch (skipval.Value.toUpperCase()) {
                            case "NOT=BLANK":
                                if (model.FieldType == "CheckBox") {
                                    isSkip = $(field).prop("checked");
                                } else {
                                    isSkip = value != "";
                                }
                                break;
                            case "NOT=OTHER":
                                isSkip = value != "OTHER";
                                isSkip = VR.Script.IsInList(skipField.FieldId);
                                break;
                            case "NOT=":
                                if (!skipval.SkipValues) {
                                    isSkip = value != "";
                                } else {
                                    isSkip = true;
                                    $.each(skipval.SkipValues, function (ind, val) {
                                        if (val.toUpperCase() == value) {
                                            isSkip = false;
                                        }
                                        if (!isSkip) {
                                            return false;
                                        }
                                    });
                                }
                                break;
                            case "BLANK":
                                if (model.FieldType == "CheckBox") {
                                    isSkip = !$(field).prop("checked");
                                } else {
                                    isSkip = value == "";
                                }
                                break;
                            default:
                                isSkip = skipval.Value.toUpperCase() == value;
                                break;
                        }
                    }

                    if (isSkip) {
                        break;
                    }
                }
                self.SetReadOnly(dependentfield, isSkip);
                //Setting ParamBypassed propery on each dependent field so we can use IsfieldSkipped function to write edits.
                // These are set in Event Screen Designer > Attributes > Skip Fields On
                data.ParamBypassed = !!isSkip;
                if (isSkip) {
                    return false;
                }
            });
        });
    }; //DoSkipFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Keydown event handler for fields
        /// </summary>
        /// <param name="e">The event handler argument.</param>
        /// <returns></returns>*/
    self.FieldKeyDown = function (e) {
        if (e.ctrlKey || e.altKey || e.metaKey) {
            return;
        }

        //console.log(
        //    "e.key=" + e.key + ", e.which=" + e.which + ", e.ctrlKey=" + e.ctrlKey
        //);

        switch (e.which) {
            case 9: // Tab key
                var model = $(e.target).data("field");
                if (!model) {
                    var parent = $(e.target).parents(".edit-field");
                    if (parent.length < 1) {
                        if ($(e.target).hasClass("grid-button")) {
                            if (e.shiftKey) {
                                if ($(e.target).prev("button").hasClass("grid-button")) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    $(e.target).prev().focus();
                                    return;
                                }
                            } else {
                                if ($(e.target).next("button").hasClass("grid-button")) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    $(e.target).next().focus();
                                    return;
                                } else {
                                    // Last grid button - find grid field model
                                    var gridContainer = $(e.target).closest(".edit-group");
                                    var inputs = gridContainer.find(".input-field");
                                    var gridModel = null;

                                    $.each(inputs, function (index, input) {
                                        var id = $(input).attr("id");
                                        if (id && id.indexOf("f") === 0) {  
                                            gridModel = $(input).data("field");
                                            return false;
                                        }
                                    });

                                    if (gridModel) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        self.FocusNextField(gridModel, false);
                                        return;
                                    }
                                }
                            }
                        } else {
                            parent = $(e.target).parents(".edit-group"); // For grid buttons
                        }
                    }

                    var inputs = parent.find(".input-field");
                    $.each(inputs, function (idx, input) {
                        var id = $(input).attr("id");
                        if (id) {
                            var pos = id.indexOf("f");
                            if (pos === 0) {
                                model = $(input).data("field");
                                return false; // break loop
                            }
                        }
                    });
                }

                if (!model) {
                    var lastButton = $('#validation-panel')
                        .find('.MuiCard-root')
                        .last()
                        .find('button:not(.Mui-disabled)')
                        .last()
                        .get(0);

                    if (e.target === lastButton) {
                        e.preventDefault();
                        e.stopPropagation();
                        $('#save-button').focus();
                    } else {
                        return;
                    }
                }

                e.preventDefault();
                e.stopPropagation();
                var now = performance.now();
                if (now - self._lastTabTime < 150) return;
                self._lastTabTime = now;

                if (model.FieldType !== "Button") {
                    self.DoFieldValueChanged("#f" + model.FieldId);
                    if (model.FieldType === "Signature") {
                        self.ValidateField("#f" + model.FieldId);
                    }
                }

                var input = $("#f" + model.FieldId);
                if (model.FieldType === "ComboBox") {
                    var cb = input.data("kendoComboBox");
                    if (cb) cb.input.blur();
                }
                self.DoSkipFields(input);
                VR.Script._editRedirectedFocus = false;
                VR.Script._suppressFocusRedirect = e.shiftKey;
                // VRS-6460/VRS-6121: Run edits synchronously before FocusNextField.
                // Without this, edits fire async via blur and nx.Focus gets overridden.
                model._validating = false;
                self.ValidateFieldRules(input, model);
                VR.Script._suppressFocusRedirect = false;
                // If an edit called nx.Focus during validation, don't override it
                // BUT: respect Shift+Tab — user intent to go backward takes priority
                if (VR.Script._editRedirectedFocus && !e.shiftKey) {
                    break;
                }
                if (e.shiftKey) { VR.Script._editRedirectedFocus = false; }
                self.FocusNextField(model, e.shiftKey);

                if (model.FieldType === "ComboBox") {
                    var errorFields = self.ErrorFields;
                    var errorExists = false;
                    for (var i = 0; i < errorFields.length && !errorExists; i++) {
                        if (errorFields[i].FieldId === model.FieldId) {
                            errorExists = true;
                        }
                    }
                    if (!errorExists) {
                        var valid = self.CheckIsComboBoxValueAllowed(input);
                        if (!valid) {
                            self.ErrorPanel.setError({
                                field: input,
                                model: model,
                                message: "Entry doesn't exist. Please select a value from the list.",
                                location: null,
                                isHardEdit: model.isHardEdit,
                                errorType: "validation"
                            });
                            self.TakeActionOnField("skipped", "Entry doesn't exist. Please select a value from the list.", null, input, model);
                            self.AddErrorField(model);
                        }
                    }
                }
                break;

            case 192: // Diacritical replacement
                VR.Script.ReplaceDiacricals(e);
                break;

            case 46:
                var fields = $(e.target);
                if (fields.length > 0) {
                    if (
                        fields.attr("readonly") === "readonly" ||
                        fields.attr("disabled") === "disabled"
                    ) {
                        break;
                    }
                }
                break;

            case 113: // F2
                self.ShowPopupMenu(e);
                break;

            case 13: // Enter key
                // Handle button clicks
                if ($(e.target).is('button')) {
                    e.preventDefault();
                    e.target.click();
                    return;
                }

                if (nx && nx.Model && nx.Model.FieldId > 0) {
                    var inputEnter = $("#f" + nx.Model.FieldId);
                    var modelEnter = inputEnter.data("field");
                    if (modelEnter && modelEnter.FieldType !== "MemoEdit" && e.keyCode === 13) {
                        e.preventDefault();
                    } else if (modelEnter.FieldType === "ComboBox") {
                        var dropdownlist = inputEnter.data("kendoComboBox");
                        var dataSet = modelEnter.DropDownList || $.map(dropdownlist.dataSource.data(), function (data) {
                            return data.text;
                        });

                        var currentValue = dropdownlist.value().toLowerCase();
                        for (var j = 0; j < dataSet.length; j++) {
                            if (dataSet[j].toLowerCase().indexOf(inputEnter.val().toLowerCase()) === 0) {
                                VR.Script.MoveLit(dataSet[j], modelEnter.FieldName);
                                break;
                            }
                        }
                    }
                }
                break;
        }
    };

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Keyup event handler for fields.
        /// </summary>
        /// <param name="e">The event handler argument.</param>
        /// <returns></returns>*/
    self.FieldKeyUp = function (e) {
        var input = $(e.target);
        var model = input.data("field");
        if (!model) {
            var parent = input.parents(".edit-field");
            if (parent.length < 1) {
                parent = input.parents(".edit-group"); //For grid buttons.
            }
            var inputs = parent.find(".input-field");
            $.each(inputs, function (index, input2) {
                var id = $(input2).attr("id");
                if (id) {
                    var index = id.indexOf("f");
                    if (index == 0) {
                        input = $(input2);
                        model = input.data("field");
                        return false;
                    }
                }
            });
        }

        if (!model) {
            return;
        }

        if (e.which < 32 || e.which > 126 || e.altKey || e.ctrlKey || e.metaKey) {
            return;
        }

        if (!model.MaxLength) {
            return;
        }

        var value = self.GetFieldRawValue(model.FieldId);
        //var value = self.GetFieldValue(model.FieldId);
        if (
            value != null &&
            value.toString().length >= model.MaxLength &&
            model.FieldType != "ComboBox"
        ) {
            e.preventDefault();
            if (e.target.value != $("#f" + model.FieldId).val()) {
                $("#f" + model.FieldId).val(e.target.value);
            }
            if (SkipOnEndField) {
                var input = $("#f" + model.FieldId);
                self.DoFieldValueChanged(input);
                self.DoSkipFields(input);
                model._validating = false;
                VR.Script._editRedirectedFocus = false;
                VR.Script._validatingEdits = true;
                self.ValidateFieldRules(input, model);
                VR.Script._validatingEdits = false;
                if (VR.Script._editRedirectedFocus) {
                    return;
                }
                self.FocusNextField(model, e.shiftKey && e.which == 8);
            }
        }
    }; //FieldKeyUp

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets focus on the first field.
        /// </summary>
        /// <returns></returns>*/
    //self.FocusFirstField = function () {
    //    var model = self.FirstField;
    //    if (!model && self.Fields && self.Fields.length > 0) {
    //        $.each(self.Fields, function (index, model) {
    //            if (model.FieldType != "Hidden" && model.FieldType != "Label" && model.FieldType != "Image") {
    //                self.FirstField = model;
    //                return false;
    //            }
    //        });
    //    }

    //    if (!model) {
    //        return;
    //    }

    //    var input = $("#f" + model.FieldId);
    //    if (!input || input.length < 1) {
    //        return;
    //    }

    //    var gadget = null;
    //    switch (model.FieldType) {
    //        case "AutoComplete": gadget = $(input).data("kendoAutoComplete"); break;
    //        case "ComboBox": gadget = $(input).data("kendoComboBox"); break;
    //        case "MultiSelect": gadget = $(input).data("kendoMultiSelect"); break;
    //        case "NumericTextBox": gadget = $(input).data("kendoNumericTextBox"); break;
    //        case "RadioButton": gadget = $(input).find("input:first"); break;
    //    }

    //    if (gadget) {
    //        gadget.focus();
    //    } else {
    //        $(input).focus();
    //    }

    //    VR.Image.TypeFromImage.Model = model;
    //}; //FocusFirstField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets focus on the next field.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <param name="e">The value to indicate if focusing on the previous field.</param>
        /// <returns></returns>*/
    self.FocusNextField = function (model, isPrev) {
        if (!model) {
            return;
        }
        var count = self.Fields.length;
        var input = $("#f" + model.FieldId);
        var next = model;
        while (count) {
            if (isPrev) {
                next = next.Prev;
            } else {
                next = next.Next;
            }

            if (!next) {
                if ($('#validation-panel').is(":visible")) {
                    $('#validation-panel').find('.MuiCard-root').first().find('button').first().get(0).focus();
                    return;
                }
                else {
                    $('#save-button').focus();
                    return;
                }
            }

            if (
                next.FieldType != "Hidden" &&
                next.FieldType != "Label" &&
                next.FieldType != "Image" &&
                next.FieldType != "Grid"
            ) {
                input = $("#f" + next.FieldId);
                if (
                    !input.hasClass("readonly-text") &&
                    input.attr("aria-disabled") != "true" &&
                    input.is(":not(:disabled)") &&
                    !input.attr("readonly")
                ) {
                    // Activate the tab if field is on a different tab
                    var tabPanel = input.closest('[role="tabpanel"]');
                    if (tabPanel.length > 0 && !tabPanel.is(":visible")) {
                        var tabId = tabPanel.attr("aria-labelledby");
                        if (tabId) {
                            var tabLink = $("#" + tabId);
                            tabLink.trigger("click");
                        }
                    }
                    model = next;
                    break;
                } else {
                    console.log("FocusNextField: skipping field", next.FieldName, "- readonly or disabled");
                }
            }
            else if (next.FieldType === "Grid") {
                input = $("#p" + next.FieldId);
                if (
                    !input.hasClass("readonly-text") &&
                    input.attr("aria-disabled") != "true" &&
                    input.is(":not(:disabled)") &&
                    !input.attr("readonly")
                ) {
                    // Activate the tab if grid is on a different tab
                    var tabPanel = input.closest('[role="tabpanel"]');
                    if (tabPanel.length > 0 && !tabPanel.hasClass("active")) {
                        var tabId = tabPanel.attr("aria-labelledby");
                        if (tabId) {
                            var tabLink = $("#" + tabId);
                            tabLink.trigger("click");
                        }
                    }
                    input.find("input").focus();
                    return;
                }
            }
            count--;
        }

        if (!model || !input || input.length < 1) {
            return;
        }

        // Final check before focusing - Kendo 2025 may update DOM asynchronously
        // SetReadOnly has a 100ms setTimeout, so we need to wait longer
        setTimeout(function() {
            // VRS-6460: If an edit redirected focus, don't override it
            if (VR.Script._editRedirectedFocus) { return; }
            if (
                !input.hasClass("readonly-text") &&
                input.attr("aria-disabled") != "true" &&
                input.is(":not(:disabled)") &&
                !input.attr("readonly")
            ) {
                VR.Script.FocusField({ input: input[0], model: model }, false);
            } 
        }, 150);
    }; //FocusNextField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets field value forciblly.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <param name="value">The field value.</param>
        /// <param name="applyall">The value to indicate if the change is applied to all fields with the same field name.</param>
        /// <returns></returns>*/
    self.ForceSetFieldValue = function (input, value, applyall) {
        var field = $(input).data("field");
        if (field) {
            self.SetFieldValue(input, value, applyall);
        }
    }; //ForceSetFieldValue

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Show image editor.
        /// </summary>
        /// <param name="editor">The source image editor.</param>
        /// <returns></returns>*/
    self.EditImage = function (editor) {
        var modal = $("#imageeditor-modal");
        $("#imageeditor-extension")
            .css("display", "")
            .parent()
            .css("display", "");
        $("#imageeditor-filetype").css("display", "none");
        var headers = modal.find(".imageeditor-headers");
        headers.css("display", "none");
        var size = self.SetImageEditorSize(modal);
        $("#imageedit-canvassection, #imageedit-canvasannote").css(
            "display",
            "none"
        );
        var id = editor.attr("id");
        var image = editor.find(".edit-image");
        var source = image.attr("src");
        $("#imageedit-filesource").css("display", "none");
        $("#imageedit-buttons").css("display", "");
        $("#imageedit-slidebars").css("display", "");
        $("#imageedit-annotationsection").css("display", "");
        $("#imageedit-editsection").css("display", "");
        $("#imageedit-acceptbutton").css("display", "");
        $("#imageedit-savetodatabse, #imageedit-savetofile").css("display", "none");
        var imagedit = $("#imageedit-editor");
        imagedit.css("display", "");
        imagedit.attr("src", source);
        imagedit.attr("data-editor", id);
        imagedit.cropper("destroy");
        imagedit.cropper({
            minCanvasWidth: size.width,
            minCanvasHeight: size.height,
            minContainerHeight: size.height,
            minContainerWidth: size.width,
            zoomOnWheel: false
        });
        $("#imageedit-buttons")
            .find(".btn-cropbutton")
            .css("visibility", "visible");
        $("#imageedit-slidebars").css("visibility", "visible");
        $("#imageedit-dragbutton").addClass("active");
        $("#imageedit-cropbutton").removeClass("active");
        $("#imageeditor-title").html("Image Editor");
        VR.Image.SlideBars.Setup();

        modal.attr("data-fileload", "");
        modal.modal("show");
    }; //EditImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Show Tiff Image editor.
        /// </summary>
        /// <param name="editor">The source image editor.</param>
        /// <returns></returns>*/
    self.EditTiffImage = function (editor) {
        var modal = $("#tiffeditor-modal");
        var modalsize = self.SetImageEditorSize(modal);
        var headers = modal.find(".imageeditor-headers");
        headers.css("display", "none");
        $("#tiffeditor-canvassection,#tiffeditor-canvasannote").css(
            "display",
            "none"
        );
        $("#tiffeditor-buttons").css("display", "");
        $("#tiffeditor-editsection").css("display", "");
        $("#tiffeditor-acceptbutton").css("display", "");
        $("#tiffeditor-savetodatabse, #tiffeditor-savetofile").css(
            "display",
            "none"
        );

        var editorid = editor.attr("id");
        var images = editor.find("img");
        var size = images.length;

        var canvases = $("#tiffeditor-canvassection");
        //canvases.css("display", "none");
        var section = $("#tiffeditor-editsection");
        section.attr("data-image-size", size);
        section.attr("data-page-number", 0);
        section.attr("data-editor", editorid);
        $("#tiffeditor-pagenumber").html("Page 1 of " + size);

        var html = "";
        $.each(images, function (index, image) {
            var source = $(image).attr("src");
            var style = " display : none;";
            if (index == 0) {
                style = "";
            }
            html +=
                "<div id='tiffeditor-pagesection" +
                (index + 1) +
                "' style='" +
                style +
                "'>" +
                "<img id='tiffeditor-page" +
                (index + 1) +
                "' src='" +
                source +
                "' style='" +
                style +
                "' /></div>";
        });
        section.html(html);
        section.css("display", "");
        for (var i = 0; i < size; i++) {
            var imageedit = $("#tiffeditor-page" + (i + 1));
            imageedit.cropper({
                minCanvasWidth: modalsize.width,
                minCanvasHeight: modalsize.height,
                minContainerHeight: modalsize.height,
                minContainerWidth: modalsize.width,
                crop: function (e) { }
            });

            if (i == 0) {
                $("#tiffeditor-pagesection" + (i + 1)).css("display", "");
                var cropper = modal.find(".cropper-container");
                if (cropper.length > 0) {
                    self.TiffModalHeight = cropper.css("height");
                }
            }
        }
        $("#tiffeditor-buttons")
            .find(".btn-cropbutton")
            .css("visibility", "visible");
        $("#tiffeditor-slidebars").css("visibility", "visible");
        $("#tiffeditor-dragbutton").addClass("active");
        $("#tiffeditor-cropbutton").removeClass("active");

        html = "";
        for (var i = 0; i < size; i++) {
            html +=
                "<div id='tiffeditor-canvas" +
                (i + 1) +
                "' style=' display : none; '></div>";
        }
        canvases.html(html);

        var annote = $("#tiffeditor-annotationsection");
        var annotes = annote.data("canvas");
        if (annotes) {
            $.each(annotes, function (index, canvas) {
                canvas.dispose();
                $(canvas.wrapperEl).remove();
            });
        }
        html = "";
        for (var i = 0; i < size; i++) {
            var style = "style='display:none;'";
            if (i == 0) {
                style = "";
            }
            html +=
                "<canvas id='tiffeditor-annotate" +
                (i + 1) +
                "' " +
                style +
                " ></canvas>";
        }
        annote.html(html);
        annote = $("#tiffeditor-canvasannote");
        annotes = annote.data("canvas");
        if (annotes) {
            $.each(annotes, function (index, canvas) {
                canvas.dispose();
                $(canvas.wrapperEl).remove();
            });
        }
        html = "";
        for (var i = 0; i < size; i++) {
            var style = "style='display:none;'";
            var id = "tiffeditor-canvasannote" + (i + 1);
            html +=
                "<div id='" +
                id +
                "' " +
                style +
                " ><canvas id='" +
                id +
                "-canvas'></canvas></div>";
        }
        annote.html(html);
        VR.Image.SlideBars.SetupTiff();
        modal.attr("data-fileload", "");
        modal.modal("show");
    }; //EditTiffImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the application value.
        /// </summary>
        /// <param name="name">The application value name.</param>
        /// <param name="input">The current input.</param>
        /// <returns>The application value.</returns>*/
    self.GetApplicationValue = function (name, input) {
        var returnValue = null;

        //Somewhere/sometime the code was changed from always requiring a string ('f12345' or 'FIELD_NAME') to allowing
        //the field ID as an integer (12345 or 'FIELD_NAME').  The indexOf below returns an error on the ID so we'll
        //get the field name here and use it for this function.
        if (typeof name == "number") {
            var model = $(input).data("field");
            name = model.FieldName;
        }

        if (!name) {
            return returnValue;
        }

        if (name.indexOf("CURRENT_") == 0) {
            name = name.substring("CURRENT_".length);
        }
        if (name.indexOf("@") == 0) {
            name = name.substring("@".length);
        }

        switch (name) {
            case "DATE":
            case "TODAY":
                var date = new Date();
                returnValue = new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                );
                break;
            case "NOW":
                returnValue = new Date();
                break;
            case "CURRENTSFN":
                returnValue = self.GetFieldValue("STATE_FILE_NUMBER");
                break;
            case "DOCPRINTER":
                returnValue = self.DocPrinter;
                break;
            case "DOCUMENT":
                returnValue = self.Document;
                break;
            case "DOCRBVALUE":
                returnValue = self.DocParameter;
                break;
            case "DOCTRACKID":
                returnValue = self.DocTrackId;
                break;
            case "DOCUMENTID":
                returnValue = self.DocumentId;
                break;
            case "NUMCOPIES":
                returnValue = self.NumCopies;
                break;
            case "FAXRECVID":
                returnValue = 0;
                break;
            case "FAXREQID":
                returnValue = self.FaxReqId;
                break;
            case "FAXSIGCODE":
                returnValue = self.FaxSigCode;
                break;
            case "FAXVERSION":
                returnValue = self.FaxVersion;
                break;
            case "FIRSTDOCNUM":
                returnValue = self.FirstDocNum;
                break;
            case "FORMSTATE":
                returnValue = self.State;
                break;
            case "LASTDOCNUM":
                returnValue = self.LastDocNum;
                break;
            case "EVENTID":
                returnValue = self.EventId;
                break;
            case "EVENTNAME":
                returnValue = self.EventName;
                break;
            case "GUIROLE":
                returnValue = self.GuiRole;
                break;
            case "PRINT_BLANK":
                returnValue = false;
                break;
            default:
                if (self.ApplicationValues == null) {
                    var url = VR.Common.GetRootURL() + "data/appvalue";
                    VR.Common.Ajax({
                        type: "POST",
                        url: url,
                        data: null,
                        success: function (response) {
                            //var json = VR.Common.DecryptData(response.Json);
                            var result = $.parseJSON(response.Json);

                            if (result.Code != 0) {
                                VR.Common.HandleInvalidResult(
                                    result,
                                    "Application Value",
                                    true
                                );
                            } else {
                                self.ApplicationValues = result.Values;
                            }
                        },
                        dataType: "json",
                        async: false
                    });
                }

                returnValue = self.ApplicationValues[name];
                if (typeof returnValue === "undefined") {
                    returnValue = null;
                }
                break;
        }

        if (returnValue == null) {
            returnValue = "";
        }

        return returnValue;
    }; //GetApplicationValue

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets changed fields.
        /// </summary>
        /// <returns>The fieldId/string value pair of all changed fields.</returns>*/
    self.GetChangedFields = function () {
        var data = "";
        $.each(self.Fields, function (index, model) {
            if (model.HasChange) {
                data += model.FieldId + "|";
            }
        });

        return data;
    }; //GetChangedFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the current tiff editor.
        /// </summary>
        /// <returns>The current tiff editor.</returns>*/
    self.GetCurrentTiffEditor = function () {
        var section = $("#tiffeditor-editsection");
        var page = parseInt(section.attr("data-page-number"));
        if (isNaN(page) || page < 0) {
            page = 0;
        }

        var tiffpage = $("#tiffeditor-page" + (page + 1));
        return tiffpage;
    }; //GetCurrentTiffEditor

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the current tiff editor page.
        /// </summary>
        /// <returns>The current tiff editor page.</returns>*/
    self.GetCurrentTiffEditorPage = function () {
        var section = $("#tiffeditor-editsection");
        var page = section.attr("data-page-number");
        page = parseInt(page);
        if (isNaN(page) || page < 0) {
            page = 0;
        }

        var tiffpage = $("#tiffeditor-pagesection" + (page + 1));
        return tiffpage;
    }; //GetCurrentTiffEditorPage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the event year.
        /// </summary>
        /// <returns>The event year.</returns>*/
    self.GetEventYear = function () {
        var returnValue = self.GetFieldValue("EVENT_YEAR", true);
        return returnValue;
    }; //GetEventYear

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets field values of all fields.
        /// </summary>
        /// <returns>The fieldId/string value pair of all field values.</returns>*/
    self.GetFieldData = function () {
        var data = "";

        $.each(self.Fields, function (indx, model) {
            var value = self.GetFieldValue(model.FieldId);
            if (model.FieldType == "MaskedTextBox") {
                if (!!model.Mask) {
                    value = VR.Edit.GetFieldRawValue(model.FieldId);
                } else {
                    value = model.OriginalValue;
                }
            } else if (model.FieldDataType == "date") {
                value = VR.Common.ToDateString(value);
                value = value.replace(/([8]{2}|[9]{2})\//g, "01/");
                //value = value.replace(/[9]{4}/g, '0001');
            }
            data += model.FieldId + "=" + value + "|";
        });

        return data;
    }; //GetFieldData

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets Shipping tab data
        /// </summary>
        /// <returns>The fieldId/string value pair of all field values.</returns>*/
    self.GetShippingTabData = function () {
        var data = "";

        $.each(self.Fields, function (indx, model) {
            if (model.Tab == "Shipping" && model.FieldType !== "Button" && model.FieldName !== "Label Layout" && model.FieldName !== "carrier_name_id"
                && model.FieldName !== "Estimated Cost" && model.FieldName !== "SHIPPING_LABEL_TRACKING_NUMBER") {
                var value = self.GetFieldValue(model.FieldId);
                if (model.FieldType == "MaskedTextBox") {
                    if (!!model.Mask) {
                        value = VR.Edit.GetFieldRawValue(model.FieldId);
                    } else {
                        value = model.OriginalValue;
                    }
                }
                data += model.FieldName + "=" + value + "|";
            }
        });
        return data;
    };

    self.GetShipCarrierAndTrackingNumber = function () {
        var data = "";

        $.each(self.Fields, function (indx, model) {
            if (model.Tab == "Shipping" && (model.FieldName.toUpperCase() == "CARRIER_NAME" || model.FieldName.toUpperCase() == "SHIPPING_LABEL_TRACKING_NUMBER")) {
                var value = self.GetFieldValue(model.FieldId);
                data += model.FieldName + "=" + value + "|";
            }
        });
        return data.slice(0, -1);
    };


    //GetFieldData
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets field errors.
        /// </summary>
        /// <returns>The fieldId/string value pair of all field errors.</returns>*/
    self.GetFieldErrors = function () {
        var data = "";
        $.each(self.Fields, function (index, model) {
            if (model.ErrorMessage && model.ErrorMessage != "") {
                data += model.FieldId + "=" + model.ErrorMessage + "|";
            }
        });

        return data;
    }; //GetFieldErrors

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets field error count.
        /// </summary>
        /// <param name="qloc">The query location (if applicable).</param>
        /// <returns>The integer field error count.</returns>*/
    self.GetFieldErrorCount = function (qloc) {
        var errorFields;
        if (!!qloc) {
            errorFields = self.ErrorFields.filter(ele => ele.QueryLocation == qloc);
        } else {
            errorFields = self.ErrorFields;
        }
        return errorFields.length;
    }; // GetFieldErrorCount

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets field model.
        /// </summary>
        /// <param name="field">The field Id or field name.</param>
        /// <returns>The field model object.</returns>*/
    self.GetFieldModel = function (field) {
        var value = null;
        var prefix = null;
        if (field && field.toString().length > 0) {
            prefix = field.substring(0, 1);
        }

        if (prefix == "f" || prefix == "p" || prefix == "g") {
            field = field.substring(1);
        }

        var id = parseInt(field);
        if (!isNaN(id)) {
            var input = $("#f" + id.toString());
            if (input.length > 0) {
                value = $(input).data("field");
            }
        } else {
            //var inputs = $("#tab-content").find("input[data-field-name='" + field + "']");
            var inputs = self.GetInputFields(field);
            if (inputs.length > 0) {
                value = $(inputs).data("field");
            }
        }

        return value;
    }; //GetFieldModel

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets field overrides.
        /// </summary>
        /// <returns>The fieldId/string value pair of all field overrides.</returns>*/
    self.GetFieldOverrides = function () {
        var data = "";
        $.each(self.Fields, function (index, model) {
            if (model.FieldStatus && model.FieldStatus != "") {
                var location = (model.QueryLocation && model.FieldStatus !== "alerttrigger") ? model.QueryLocation : "";

                if (!location) {
                    location = "";
                } else if (location.length > 0) {
                    location = "," + location;
                }

                if (model.FieldStatus !== "literal") {
                    data += model.FieldId + "=" + model.FieldStatus + location + "|";
                }
            }
        });

        return data;
    }; //GetFieldOverrides


    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
     /// <summary>
     /// Gets all the fields that have the status of "literal"
     /// </summary>
     /// <returns> data, which contains the fieldid plus the fieldstatus combined <returns>*/
    self.GetOtherLiteralFields = function() {
        var data = "";
        $.each(self.Fields, function (index, model) {

            // if the field currently has an orange background then add to data
            if (model.AllowOther === true && model.FieldStatus === "literal") {
                data += model.FieldId + "=literal|";
            }
        });

        return data;
    }; //GetOtherLiteralFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
    /// <summary>
    /// Gets the field value.
    /// </summary>
    /// <param name="field">The field Id or field name.</param>
    /// <param name="returnNull">The value to indicate if null sould be return if the field is not found.</param>
    /// <returns>The field value in a string format.</returns>*/
    self.GetFieldValue = function (field, returnNull, isFormatted, comboBoxReturnDisplayValue) {
        var value = null;
        var id = parseInt(field);
        if (!isNaN(id)) {
            var input = $("#f" + id.toString());
            if (input.length > 0) {
                var model = $(input).data("field");
                if (model.FieldType == "MaskedTextBox" && !!model.Mask && isFormatted) {
                    value = VR.Edit.GetInputValue(input, true, false, comboBoxReturnDisplayValue);
                } else {
                    value = VR.Edit.GetInputValue(input, false, true, comboBoxReturnDisplayValue);
                }
            }
        } else {
            //var inputs = $("#tab-content").find(".input-field[data-field-name='" + field + "']");
            var inputs = self.GetInputFields(field);
            if (inputs.length > 0) {
                var model = $(inputs[0]).data("field");
                if (model.FieldType == "MaskedTextBox" && !!model.Mask && isFormatted) {
                    value = VR.Edit.GetInputValue(inputs[0], true, false, comboBoxReturnDisplayValue);
                }
                else if (model.FieldType == "TimePicker" && VR.Common.IsMobile()) {
                    value = VR.Edit.GetInputValue(inputs[0], false, false, comboBoxReturnDisplayValue).replace(":", "");
                }
                else {
                    value = VR.Edit.GetInputValue(inputs[0], false, true, comboBoxReturnDisplayValue);
                }
            }
        }

        if ((value == "" || value == null) && field == "ISACTIVE") {
            value = self.Isactive;
        }

        if (!returnNull && value == null) {
            value = "";
        }
        return value;
    }; //GetFieldValue
    self.GetFieldRawValue = function (field, returnNull) {
        var value = null;
        var id = parseInt(field);
        if (!isNaN(id)) {
            var input = $("#f" + id.toString());
            if (input.length > 0) {
                var model = $(input).data("field");
                value = VR.Edit.GetInputValue(input, false);
            }
        } else {
            var inputs = self.GetInputFields(field);
            if (inputs.length > 0) {
                var model = $(inputs[0]).data("field");
                value = VR.Edit.GetInputValue(inputs[0], false);
            }
        }
        if (value == null && field == "ISACTIVE") {
            value = self.Isactive;
        }

        if (!returnNull && value == null) {
            value = "";
        }
        return value;
    }; //GetRawFieldValue
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the filter values.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns>The field value in a string format.</returns>*/
    self.GetFilterValues = function (model) {
        var value = "";
        if (model && model.FilterFields && model.FilterFields.length > 0) {
            for (var i = 0; i < model.FilterFields.length; i++) {
                var id = model.FilterFields[i];
                value += self.GetFieldValue(id).toString() + "|";
            }
        }

        return value;
    }; //GetFilterValues

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the input fields.
        /// </summary>
        /// <param name="input">The field name.</param>
        /// <returns>The input field list.</returns>*/
    self.GetInputFields = function (field) {
        if (!field) {
            return null;
        }

        var escaped = VR.Common.EscapeSelector(field);
        var inputs = $("#tab-content").find(
            ".input-field[data-field-name='" + escaped + "']"
        );
        if (inputs.length <= 0) {
            escaped = VR.Common.EscapeSelector(field.toUpperCase());
            inputs = $("#tab-content").find(
                ".input-field[data-field-name='" + escaped + "']"
            );
        }

        return inputs;
    }; //GetInputFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the input field value.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <param name="isFormatted">The value to indicate if formatted value should be returned.</param>
        /// isFormatted did nothing prior to 6/17/2020, now it can affect the string handling
        /// <returns>The field value in a string format.</returns>*/
    self.GetInputValue = function (input, isFormatted, comboBoxOverloadFieldValue, comboBoxReturnDisplayValue) {
        var value = null;
        var model = $(input).data("field");
        if (model) {
            switch (model.FieldType) {
                case "CheckBox":
                    value = $(input).prop("checked");
                    if (value) {
                        value = "Y";
                    } else {
                        value = "N";
                    }
                    break;
                case "ComboBox":
                    var comboBox = $(input).data("kendoComboBox");
                    if (!!comboBox) {
                        if (
                            !!comboBox.dataSource &&
                            comboBox.dataSource.data().length > 0
                        ) {
                            var text = comboBox.text();
                            value = comboBox.value();
                            var data = comboBox.dataSource.data();
                            var found = false;
                            for (var item = 0; item < data.length; item++) {
                                if (typeof (data[item].text) !== "undefined" && typeof (data[item].text) !== "null" &&
                                    typeof (text) !== "undefined" && typeof (text) !== "null"
                                ) {
                                    if (data[item].text.toString().toUpperCase() == text.toString().toUpperCase()) {
                                        value = comboBoxReturnDisplayValue === true ? data[item].text : data[item].value;
                                        found = true;
                                        break;
                                    }
                                }
                            }
                            if (!found) value = text;
                        } else {
                            value = comboBox.text();
                            if (value === "" && model.FieldValue !== null && model.FieldValue !== "" && comboBoxOverloadFieldValue === true) {
                                value = model.FieldValue;
                            }
                        }
                    } else {
                        value = $(input).val();
                    }
                    if (!!value && typeof value == "string") {
                        if ($(input).data("casing") != "ignore") {
                            // In ComboBox ?Need to account for isFormatted = false?
                            switch (model.Case) {
                                case "upper":
                                    value = value.toUpperCase();
                                    break;
                                case "lower":
                                    value = value.toLowerCase();
                                    break;
                                case "capitalize":
                                    // In ComboBox ?Need to account for isFormatted = false?
                                    value = self.CapitalizeEachWord(value);
                                    break;
                            }
                        }
                        value = value.trim();
                    }
                    break;
                case "RadioButton":
                    var buttons = $(input).find("input");
                    $.each(buttons, function (index, radio) {
                        var val = $(radio).prop("checked");
                        if (val) {
                            value = $(radio).val();
                        }
                    });
                    break;
                case "Image":
                    value = model.FieldValue;
                    break;
                case "MonthPicker":
                case "DatePicker":
                case "MaskedTextBox":
                    var maskedtextbox = $(input).data("kendoMaskedTextBox");
                    if (maskedtextbox) {
                        value = isFormatted ? maskedtextbox.value() : maskedtextbox.raw();
                        if (model.FieldType == "DatePicker" && value) {
                            value = maskedtextbox.value();
                        }
                    } else {
                        value = $(input).val();
                    }
                    break;
                case "MultiSelect":
                    var multiselect = $(input).data("kendoMultiSelect");
                    if (multiselect) {
                        var list = multiselect.value();
                        if (list && list.length > 0) {
                            value = "";
                            for (var i = 0; i < list.length; i++) {
                                if (i > 0) {
                                    value += "*";
                                }
                                value += list[i].trim();
                            }
                        }
                    } else {
                        value = $(input).val();
                    }
                    break;
                case "Signature":
                    var model = $(input).data("field"); // this line is redundant to the earlier setting of model?
                    if (model) {
                        value = model.FieldValue;
                        if (value) {
                            value = value.toString();
                        }
                    }
                    break;
                default:
                    value = $(input).val();
                    break;
            }

            if (!!value && typeof value == "string") {
                if ($(input).data("casing") != "ignore") {
                    //need to check prev value against current value
                    //VRS-3752 Casing does not work on an already saved record.
                    //check if the value has changed, they might just be tabbing through and not want their
                    //beautiful field recapitalized.
                    //note that OriginalValue may be null while value is ""
                    //This routime works on Textboxes, to work with other controls need code in OnBlur to manage PreviousValue
                    //
                    if (model.FieldType == "TextBox") {
                        if ((model.PreviousValue == null && model.OriginalValue != value) || (model.PreviousValue != null && model.PreviousValue != value)) {
                            if (isFormatted == null || isFormatted == true) {
                                switch (model.Case) {
                                    case "upper":
                                        value = value.toUpperCase();
                                        break;
                                    case "lower":
                                        value = value.toLowerCase();
                                        break;
                                    case "capitalize":
                                        value = self.CapitalizeEachWord(value);
                                        break;
                                }
                            }
                        }
                    }
                    // ComboBox handles its value in the switch statement above, so we exclude it here
                    else if (model.FieldType != null && model.FieldType != "ComboBox") {
                        if ($(input).data("casing") != "ignore") {
                            switch (model.Case) {
                                case "upper":
                                    value = value.toUpperCase();
                                    break;
                                case "lower":
                                    value = value.toLowerCase();
                                    break;
                                case "capitalize":
                                    value = self.CapitalizeEachWord(value);
                                    break;
                            }
                        }
                    }
                }
                value = value.trim();
            }
        }

        if (value == null) {
            value = "";
        }

        return value;
    }; //GetInputValue

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets the isactive value for the current event Id.
        /// </summary>
        /// <returns>The current event Id.</returns>*/
    self.GetIsActive = function () {
        var value = self.GetFieldValue("ISACTIVE", true);

        return value;
    }; //GetIsActive

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Gets field values of all fields for preload.
        /// </summary>
        /// <returns>The field name/string value pair of all field values.</returns>*/
    self.GetPreloadData = function () {
        var data = self.EventName + "|";

        $.each(self.Fields, function (indx, model) {
            var value = self.GetFieldValue(model.FieldId);
            if (model.FieldDataType == "date") {
                value = VR.Common.ToDateString(value);
            }
            data += model.FieldName + "=" + value + "|";
        });

        return data;
    }; //GetPreloadData

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Get the state file number.
        /// </summary>
        /// <returns>The state file number.</returns>*/
    self.GetStateFileNumber = function () {
        var returnValue = self.GetFieldValue("STATE_FILE_NUMBER", true);
        return returnValue;
    }; //GetStateFileNumber

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Inactivates image.
        /// </summary>
        /// <param name="id">The image Id.</param>
        /// <returns></returns>*/
    self.InactivateImage = function (id) {
        if (id && id.indexOf("image-") > -1) {
            id = id.substring("image-".length);
        }

        id = parseInt(id);
        if (isNaN(id)) {
            return;
        }

        var selected = null;
        $.each(self.ImageDataSource.data(), function (index, model) {
            if (model.ImageId == id) {
                selected = model;
                return false;
            }
        });

        if (!selected) {
            return;
        }

        VR.Common.SecurePost(
            "data/imagetoggle",
            "image=" + id + "|active=" + selected.IsActive,
            function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Image", true);
                } else {
                    var list = $("#image-list");
                    list.find(".image").off("dblclick");
                    selected.IsActive = !selected.IsActive;
                    $("#image-pager")
                        .data("kendoPager")
                        .refresh();
                    var list = $("#image-list");
                    var kendoList = list.data("kendoListView");
                    kendoList.refresh();

                    $("#image-list .image").on("dblclick", function (e) {
                        var imageId = this.id;
                        if (imageId.indexOf("image-") > -1) {
                            imageId = imageId.substring("image-".length);
                        }
                        var urlParams = new URLSearchParams(window.location.search);
                        var eventEditParam = urlParams.get('selection') || "";
                        var url = VR.Common.GetRootURL();
                        window.open(url + "event/imagewindow?" + eventEditParam + "&vrsimageid=" + imageId, "_blank", "popup=1,menubar=no,toolbar=no,status=no,resizable=yes,fullscreen=yes");
                    });

                    var element = null;
                    $.each(kendoList.element.children(), function (index, child) {
                        if (child.id == "image-" + id) {
                            element = child;
                            return false;
                        }
                    });
                    kendoList.select(element);

                    var checkbox = $("#" + selected.ImageId + "-check");
                    checkbox.trigger("click");
                }
            }
        );
    }; //InactivateImage

    self.CreateFunction = function (script) {
        return new Function(script);
    }; //CreateFunction

    self.dynscript = function (
        model,
        edit,
        year,
        eventGroup,
        roleCode,
        userName,
        kind
    ) {
        return function () {
            if (!!model.FieldId) {
                VR.Script.EditNumber = edit.EditNumber;
                VR.Script.Edit = edit;
            }
            try {
                //console.log("running edit " + model.FieldId + ":" + edit.EditNumber);
                var fileName = "f" + model.FieldId + "_e" + edit.EditNumber;
                if (!model.FieldId) {
                    var year = VR.Edit.SecurityEventYear;
                    var roleCode = VR.Edit.SecurityRoleCode;
                    var userName = VR.Edit.SecurityUserName;
                    var eventGroup = VR.Edit.SecurityEventGroup;
                    var kind = edit.Kind;
                    fileName =
                        eventGroup +
                        "-" +
                        roleCode +
                        "-" +
                        userName +
                        "-" +
                        year +
                        "-" +
                        kind;
                }
                VR.Edit.CreateFunction(
                    "//# sourceURL=" + fileName + ".js\r\n" + edit.Script
                )();
            } catch (ex) {
                var _message = ex;
                if (ex.message) _message = ex.message;
                if (
                    CanViewScriptEditor &&
                    _message.indexOf("Script.ErrMessage:") == -1
                ) {
                    var jsEditorAnchor = "";
                    var nibble = "";
                    if (!model.FieldId) {
                        nibble = encodeURIComponent(
                            "eventYear=" +
                            year +
                            "|eventGroup=" +
                            eventGroup +
                            "|role_code=" +
                            roleCode +
                            "|user_name=" +
                            userName
                        );
                        //nibble = encodeURI(nibble);
                        jsEditorAnchor =
                            '<a target="_' +
                            model.FieldId +
                            '" href="' +
                            VR.Common.GetRootURL() +
                            "jsedit/roleedit?selection=" +
                            nibble +
                            '">here</a>';
                        alert(
                            "there was an error in " +
                            kind +
                            " role edit.  Click " +
                            jsEditorAnchor +
                            " to edit the script.<br /><br />" +
                            _message
                        );
                    } else {
                        nibble = encodeURIComponent(
                            "FieldId=" + model.FieldId + "|Edit_Number=" + edit.EditNumber
                        );
                        //nibble = encodeURI(nibble);
                        jsEditorAnchor =
                            '<a target="_' +
                            model.FieldId +
                            '" href="' +
                            VR.Common.GetRootURL() +
                            "jsedit/guiedit?selection=" +
                            nibble +
                            '">here</a>';
                        alert(
                            "there was an error in edit " +
                            model.FieldId +
                            ":" +
                            edit.EditNumber +
                            ".  Click " +
                            jsEditorAnchor +
                            " to edit the script.<br /><br />" +
                            _message
                        );
                    }
                }
                if (_message.indexOf("Script.ErrMessage:") == 0) {
                    throw _message.replace("Script.ErrMessage:", "");
                }
                //console.error(ex);
            }
        };
    }; //dynscript

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Initialize fields.
        /// </summary>
        /// <param name="index">The index to the the tab to initialize or null for all fields.</param>
        /// <returns></returns>*/
    self.InitFields = function (index, isNoEdits) {
        if (isNoEdits) return;

        var fields;
        if (index == null) {
            fields = self.Fields;
        } else if (
            !self.Tabs ||
            self.Tabs.length == 0 ||
            index < -1 ||
            index > self.Tabs.length
        ) {
            return;
        } else {
            fields = self.Tabs[index];
        }

        if (!fields || fields.length < 1) {
            return;
        }

        $.each(fields, function (index, model) {
            var input = $("#f" + model.FieldId);
            self.DoSkipFields(input, true);

            if (
                (model.IsEditable == false || model.IsDisplayOnly == true) &&
                !$(input).hasClass("readonly-text")
            ) {
                self.SetReadOnly(input, true);
            }
            self.SetFieldStatusColor(input, model);

            if (
                !self.FirstField &&
                !$(input).hasClass("readonly-text") &&
                model.FieldType != "Hidden" &&
                model.FieldType != "Label" &&
                model.FieldType != "Image" &&
                model.FieldType != "Button"
            ) {
                self.FirstField = model;
            }
        });
    }; //InitFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Initialzes the image scan.
        /// </summary>
        /// <returns></returns>*/
    self.InitScanImage = function () {
        Dynamsoft.DWT.RegisterEvent("OnWebTwainReady", function (e) {
            self.DWObject = Dynamsoft.DWT.GetWebTwain("dwtcontrolContainer");
            self.DWObject.RegisterEvent("OnPostAllTransfers", function () {
                var buttons = $("#scanimage-buttons");
                var size = self.DWObject.HowManyImagesInBuffer;
                if (size && size > 1) {
                    buttons.css("visibility", "visible");
                    self.DWObject.CurrentImageIndexInBuffer = 0;
                    $("#scanimage-pagenumber").html(
                        "Page: " +
                        (self.DWObject.CurrentImageIndexInBuffer + 1) +
                        " of " +
                        self.DWObject.HowManyImagesInBuffer
                    );
                    self.DWObject.RegisterEvent("OnTopImageInTheViewChanged", function (
                        index
                    ) {
                        self.DWObject.CurrentImageIndexInBuffer = index;
                        $("#scanimage-pagenumber").html(
                            "Page: " +
                            (self.DWObject.CurrentImageIndexInBuffer + 1) +
                            " of " +
                            self.DWObject.HowManyImagesInBuffer
                        );
                    });
                } else {
                    buttons.css("visibility", "hidden");
                }
            });

            var list = [];
            for (var i = 0; i < self.DWObject.SourceCount; i++) {
                list.push(self.DWObject.GetSourceNameItems(i));
            }

            var source = $("#scanner-source");
            source.kendoDropDownList({
                dataSource: list,
                "data-testid": "scanner-source"
            });

            var modal = $("#scanimage-modal");
            modal.find(".ds-dwt-container-box").css("margin-left", "150px");
        });

        Dynamsoft.DWT.Load();

        var buttons = $("#scanimage-buttons");
        var button = buttons.find(".btn-primary");
        button.tooltip({
            container: "body",
            trigger: "hover"
        });

        button.on("click", function (e) {
            var id = $(this).attr("id");
            if (id == "scanimage-previousbutton") {
                if (self.DWObject.CurrentImageIndexInBuffer > 0) {
                    self.DWObject.CurrentImageIndexInBuffer -= 1;
                }
            } else {
                if (
                    self.DWObject.CurrentImageIndexInBuffer + 1 <
                    self.DWObject.HowManyImagesInBuffer
                ) {
                    self.DWObject.CurrentImageIndexInBuffer += 1;
                }
            }
        });
    }; //InitScanImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Initialzes the Edit view.
        /// </summary>
        /// <returns></returns>*/
    self.Initialize = function () {
        nxLoading.start("Loading fields. Please wait...");
        VR.Common.SetupComboBoxKeyDown();
        self.Referrer = document.referrer;
        self.State = -1;
        var dataValue = $("#data-value");
        var value = dataValue.attr("data-value");
        if (!value) return;
        var result = $.parseJSON(value);
        dataValue.attr("data-value", "");
        self.EventName = result.EventName;
        self.SpecialEventId = result.SpecialEventId;
        self.EventId = result.EventId;
        self.EventYear = result.EventYear;
        self.GuiRole = result.GuiRole;
        self.ModTypeId = result.ModTypeId;
        self.RegTypeCode = result.RegTypeCode;
        self.RegTypeDescription = result.RegTypeDescription;
        self.Isactive = result.Isactive;
        self.ImageSecurity = result.ImageSecurity;
        self.ImageCount = result.ImageCount;
        self.MissingValues = result.MissingValues;
        self.NotesCount = result.NotesCount;
        self.Preloads = result.Preloads;
        self.CanClose = result.EditSecurity && result.EditSecurity.CanClose;
        self.CanDeleteWithSFN =
            result.EditSecurity && result.EditSecurity.CanDeleteWithSFN;
        self.CanLeave = result.EditSecurity && result.EditSecurity.CanLeave;
        self.CanNumberOverride =
            result.EditSecurity && result.EditSecurity.CanNumberOverride;
        self.CanSave = result.EditSecurity && result.EditSecurity.CanSave;
        self.CanSaveWithEdits = self.CanSave;
        self.CanSaveWithoutEdits =
            result.EditSecurity && result.EditSecurity.CanSaveWithoutEdits;
        self.IsCasEvent = result.IsCasEvent;
        self.IsCasEnabled = result.IsCasEnabled;
        self.IsDataCached = result.IsDataCached;
        self.IsDisplayOnly = result.IsDisplayOnly;
        self.IsKeyCached = result.IsKeyCached;
        self.CanLeaveValidated = false;
        self.SaveCount = 0;
        self.SetupBackButton();
        self.OnDisplay = result.OnDisplay;
        self.OnSave = result.OnSave;
        self.SecurityEventYear = result.SecurityEventYear;
        self.SecurityRoleCode = result.SecurityRoleCode;
        self.SecurityUserName = result.SecurityUsername || "ALL";
        self.SecurityEventGroup = result.SecurityEventGroup;
        self.SourceEvent = result.SourceEvent;
        self.SourceEventId = result.SourceEventId;
        self.MaxImageUpload = parseInt(editPageData.MaxImageUpload);

        if (isNaN(self.MaxImageUpload)) {
            self.MaxImageUpload = 15728640;
        } else {
            self.MaxImageUpload = self.MaxImageUpload * 1048576 * 1.5;
        }

        if (!!result.Alerts) {
            self.Alerts = result.Alerts;
        }

        $("#alerts-dropdown").kendoDropDownList({
            dataTextField: "Message",
            dataValueField: "FieldName",
            dataSource: self.Alerts,
            "data-testid": "alerts-dropdown"
        });
        var selectspan = $("#alerts-dropdown").parent().find("span.k-input-button");
        $(selectspan).removeAttr("aria-label");
        $("#alert-span").css("display", "");
        // Set static test IDs for the generated Kendo elements
        var alertsWidget = $("#alerts-dropdown").data("kendoDropDownList");
        if (alertsWidget) {
            alertsWidget.wrapper.find(".k-input-inner").attr("id", "alerts-dropdown-inner").attr("data-testid", "alerts-dropdown-inner");
        }
        self.SyncEventAlertsCount(self.Alerts.length);

        if (VR.Common.Location === "/event/edit") {
            self.ErrorPanel = errorPanel();
        }
        self.SetupFields(result);
        self.SetupNextButtons();
        $("#loading-image").css("display", "none");
        $("#edit-header").css("display", "block");
        self.SetupSave("save-button", true, false);
        self.SetupSave("editsave-menu", true, false);
        self.SetupSave("saverec-menu", false, false);
        self.SetupSave("savetwin-menu", true, true);
        self.SetupSave("savetwinnoedit-menu", false, true);
        self.SetupNotes();
        self.SetupErrorCount();
        self.SetupLinking();
        self.SetupActionMenus();
        self.SetupWindowKeyDown();
        self.SetupOnBeforeUnload();
        self.SetupOnUnload();
        VR.Common.SetupViewFieldDefs();
        VR.Common.OnResize(self.ResizeWindow);
        self.SetupAllControls();

        // Fix ARIA attributes on datepicker controls
        setTimeout(function() {
            $('input[data-role="datepicker"], .datepicker-input, .masked-date-field').removeAttr('aria-expanded');
        }, 100);
        
        self.State = 1;
        self.ValidateOnLoad(editPageData.PageTitle);

        var dcnt = -1;
        for (let i = 0; i < self.Tabs.length; i++) {
            let curTabList = self.Tabs[i];       
            for (let j = 0; j < curTabList.length; j++) {
                let curField = curTabList[j];
                if (curField.Edits && curField.ShouldRunEdits) {
                    // Check to see if the field has edits
                    var parameter = {
                        message: null,
                        location: null,
                        lastedit: null,
                        edittype: null,
                        errorat: null,
                        state: self.State
                    };
                    var jqueryField = $("#f" + curField.FieldId);
                    $.each(curField.Edits, function (index, edit) {
                        // iterate through the edits
                        if (edit.EditType == "alert") {
                            // check for edits with the alert type
                            var tempModel = $(jqueryField).data("field");
                            if (typeof(tempModel) === "object") {
                                VR.Edit.editModel = tempModel;
                            }
                            VR.Script.Validate(jqueryField, curField, edit, parameter);
                        }
                    });
                }
                if (curField.FieldType === "ComboBox" && curField.FieldValue !== null && curField.FieldValue !== "" &&
                    (curField.ValidationDropdownItems === null || curField.ValidationDropdownItems.length === 0))
                {
                    let field = $("#f" + curField.FieldId);
                    let comboBox = field.data("kendoComboBox");
                    let dataSource = comboBox.dataSource;
                    dataSource.fetch().then(function () {
                        let newData = dataSource.data();
                        let updatedValue = false;
                        for (let k = 0; k < newData.length && !updatedValue; k++) {
                            let curOption = newData[k];
                            if (curOption.text === comboBox.value()) {
                                self.SetFieldValue(field, curOption.value);
                                updatedValue = true;
                            }
                        }
                        // VRS-6693: re-fire this field's alert edits against the
                        // resolved ComboBox value. The synchronous alert pass above
                        // ran before this fetch resolved, so ComboBox-dependent
                        // alerts must be re-evaluated here (synchronous within .then()).
                        if (updatedValue && curField.Edits && curField.ShouldRunEdits) {
                            var reParam = {
                                message: null,
                                location: null,
                                lastedit: null,
                                edittype: null,
                                errorat: null,
                                state: self.State
                            };
                            $.each(curField.Edits, function (index, edit) {
                                if (edit.EditType == "alert") {
                                    var tempModel = $(field).data("field");
                                    if (typeof(tempModel) === "object") {
                                        VR.Edit.editModel = tempModel;
                                    }
                                    VR.Script.Validate(field, curField, edit, reParam);
                                }
                            });
                        }
                    });
                }

                if (curField.FieldType === "ComboBox" && curField.FieldValue) {
                    let elem = $("#f" + curField.FieldId);
                    let elemModel = $("#f" + curField.FieldId).data("field");

                    let hasIssue = false;
                    var value = !!elemModel.FieldValue
                        ? elemModel.FieldValue
                        : self.GetInputValue(elem, true);
                    var comboBox = elem.data("kendoComboBox");

                    var multispaces = RegExp(/\s\s+/g);
                    if (multispaces.test(value)) {
                        value = value.replace(/\s\s+/g, " ");
                        VR.Script.MoveLit(value, elemModel.FieldName);
                    }
                    if (value) {
                        if (elemModel.AllowOther == true) {
                            if (value != elemModel.OriginalValue
                                && comboBox.select() === -1
                                && value != elemModel.DefaultValue
                                && !nx.IsInList(elemModel.FieldId)) {
                                self.SetFieldStatus(comboBox.input, elemModel, "literal", null, null);
                            }
                        } else {
                            if (comboBox.value() && comboBox.select() === -1 && !nx.IsInList(elemModel.FieldId)) {
                                hasIssue = true;
                            }
                            else if (elemModel.ValidationDropdownItems !== null) {
                                let found = false;
                                if (elemModel.ValidationDropdownItems.length > 0) {
                                    for (let k = 0; k < elemModel.ValidationDropdownItems.length && found === false; k++) {
                                        let curItem = elemModel.ValidationDropdownItems[k];
                                        found = value.toString().toLowerCase() === (curItem.ValueInt === null ? curItem.ValueString.toLowerCase() : curItem.ValueInt.toString());
                                    }
                                }
                                else if (nx.IsInList(elemModel.FieldId)) {
                                    found = true;
                                }
                                hasIssue = !found;
                            }
                        }
                    }

                    if (hasIssue) {
                        self.ErrorPanel.setError({
                            field: elem,
                            model: elemModel,
                            message: "Entry doesn't exist. Please select a value from the list.",
                            location: null,
                            isHardEdit: elemModel.isHardEdit,
                            errorType: "validation"
                        });
                        self.TakeActionOnField("skipped", "Entry doesn't exist. Please select a value from the list.", null, elem, elemModel);
                        self.AddErrorField(elemModel);
                    }
                }
            }  
        }

        nxLoading.end();
    }; //Initialze

    self.ValidateOnLoad = function (pageTitle) {
        if (!pageTitle.includes("New")) {
            $.each(self.Fields, function (index, model) {
                if (model.FieldStatus == "skipped") {
                    self.load = true;
                    model.HasSaveError = true;
                    model.ShouldRunEdits = true;
                    self.ValidateField($("#f" + model.FieldId));  
                }
                self.load = false;
            });
        }
    };

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Returns if the record is being saved.
        /// </summary>
        /// <returns></returns>*/
    self.IsSaving = function () {
        return self.State == 2 || self.State == 3;
    }; //IsSaving

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Loads image or a file to the web server.
        /// </summary>
        /// <returns></returns>*/
    self.LoadImageFile = function (extensionOverwrite) {
        var source = $("#image-data").prop("data-src");
        if (source == "") {
            return;
        }

        var modal = $("#imageeditor-modal");
        var headers = modal.find(".imageeditor-headers");
        headers.css("display", "");
        $("#imageedit-acceptbutton").css("display", "none");
        $("#imageedit-savetodatabse, #imageedit-savetofile").css("display", "");

        var appfunc = $("#imageedit-appfunction");
        if (appfunc.length > 0) {
            var dropdownlist = appfunc.data("kendoDropDownList");
            if (!dropdownlist) {
                appfunc.css("width", "200px");
                var dataSource = new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            // Get the filter value from the ComboBox input, not from a separate list
                            var filterValue = "";
                            if (options.data && options.data.filter && options.data.filter.filters.length > 0) {
                                filterValue = options.data.filter.filters[0].value;
                            }

                            var url = VR.Common.GetRootURL("event/edit");
                            VR.Common.SecurePost(
                                url + "data/secfile",
                                filterValue, // Pass the filter value to the server
                                function (result) {
                                    if (result.Code == 0) {
                                        var data = [];
                                        data.push({ text: " ", value: "" });
                                        $.each(result.List, function (index, item) {
                                            data.push({ text: item, value: item, key: item });
                                        });
                                        options.success(data);
                                    } else {
                                        options.error(result);
                                        VR.Common.HandleInvalidResult(result, "Image", true);
                                    }
                                },
                                true,
                                undefined,
                                false,
                                false
                            );
                        }
                    },
                    serverFiltering: true,
                    schema: {
                        data: function (response) {
                            return response; // Return the data array directly
                        }
                    }
                });

                appfunc.kendoDropDownList({
                    autoBind: false,
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: dataSource,
                    filter: "contains",
                    height: 150
                });

                setupAppFunctionDropdown(appfunc, "load");
            }
        }

        var fileType = $("#image-file-group").attr("data-file-type");
        var source = $("#image-data").prop("data-src");
        var extension = $("#image-file").val();
        if (!extension) {
            return;
        }

        var index = extension.lastIndexOf(".");
        if (index == -1 || extension.length - index <= 1) {
            extension = "";
        } else {
            extension = extension.substring(index + 1).toLowerCase();
        }

        switch (extension) {
            case "tif": //change tif to tiff
                extension = "tiff";
                break;
            case "jpg": //change jpg to jpeg
                extension = "jpeg";
                break;
        }

        var imageextension = $("#imageeditor-extension");
        var fileextension = $("#imageeditor-filetype");

        $("#imageedit-canvassection, #imageedit-canvasannote").css(
            "display",
            "none"
        );
        $("#image-data").prop("data-extension", extension);
        if (fileType == "0" && extension != "tiff") {
            var size = self.SetImageEditorSize(modal);

            $("#imageedit-filesource").css("display", "none");
            $("#imageedit-buttons").css("display", "");
            $("#imageedit-editsection").css("display", "");
            $("#imageedit-slidebars").css("display", "");
            $("#imageedit-annotationsection").css("display", "");
            var imagedit = $("#imageedit-editor");
            imagedit.css("display", "");
            imagedit.attr("src", source);
            imagedit.cropper("destroy");
            imagedit.cropper({
                minCanvasWidth: size.width,
                minCanvasHeight: size.height,
                minContainerHeight: size.height,
                minContainerWidth: size.width,
                crop: function (e) { }
            });
            $("#imageedit-buttons")
                .find(".btn-cropbutton")
                .css("visibility", "visible");
            $("#imageedit-slidebars").css("visibility", "visible");
            $("#imageedit-dragbutton").addClass("active");
            $("#imageedit-cropbutton").removeClass("active");
            $("#imageeditor-title").html("Image Editor");
            VR.Image.SlideBars.Setup();
            modal.attr("data-fileload", "");
        } else {
            var content = $(modal).find(".modal-dialog");
            content.css("height", "");
            content.css("width", "");
            content.css("margin-left", "");

            source = VR.Common.GetRootURL() + "/images/";
            switch (extension) {
                case "csv":
                case "doc":
                case "docx":
                case "exe":
                case "pdf":
                case "rtf":
                case "tiff":
                case "txt":
                case "xls":
                case "xlsx":
                case "zip":
                    source += extension + ".png";
                    break;
                default:
                    source += "data.png";
                    break;
            }
            $("#imageedit-filesource").attr("src", source);
            $("#imageedit-filesource").css("display", "");
            $("#imageedit-editor").css("display", "none");
            $("#imageedit-buttons").css("display", "none");
            $("#imageedit-editsection").css("display", "none");
            $("#imageedit-slidebars").css("display", "none");
            $("#imageedit-annotationsection").css("display", "none");
            $("#imageeditor-title").html("File Load");
            modal.attr("data-fileload", "1");
        }

        var description = $("#imagename-text").val();
        $("#imageedit-description").val(description);

        modal.attr("data-annotation", "");
        modal.modal("show");
        if (extensionOverwrite) {
            var dropdown = $("#imageeditor-extension").data("kendoDropDownList");
            if (dropdown) dropdown.value(extensionOverwrite);
        }
    }; //LoadImageFile

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Loads a Tiff images to the web server.
        /// </summary>
        /// <returns></returns>*/
    self.LoadTiffFile = function () {
        var modal = $("#tiffeditor-modal");
        var headers = modal.find(".imageeditor-headers");
        headers.css("display", "");
        $("#tiffeditor-acceptbutton").css("display", "none");
        $("#tiffeditor-savetodatabse, #tiffeditor-savetofile").css("display", "");

        var appfunc = $("#tiffeditor-appfunction");
        if (appfunc.length > 0) {
            var dropdownlist = appfunc.data("kendoDropDownList");
            if (dropdownlist) {
                dropdownlist.select(-1);
            } else {
                appfunc.css("width", "200px");
                var dataSource = new kendo.data.DataSource({
            transport: {
                read: function (options) {
                    // Get the filter value from the ComboBox input, not from a separate list
                    var filterValue = "";
                    if (options.data && options.data.filter && options.data.filter.filters.length > 0) {
                        filterValue = options.data.filter.filters[0].value;
                    }

                    var url = VR.Common.GetRootURL("event/edit");
                    VR.Common.SecurePost(
                        url + "data/secfile",
                        filterValue, // Pass the filter value to the server
                        function (result) {
                            if (result.Code == 0) {
                                var data = [];
                                data.push({ text: " ", value: "" });
                                $.each(result.List, function (index, item) {
                                    data.push({ text: item, value: item, key: item });
                                });
                                options.success(data);
                            } else {
                                options.error(result);
                                VR.Common.HandleInvalidResult(result, "Image", true);
                            }
                        },
                        true,
                        undefined,
                        false,
                        false
                    );
                }
            },
            serverFiltering: true,
            schema: {
                data: function (response) {
                    return response; // Return the data array directly
                }
            }
        });

                appfunc.kendoDropDownList({
                    autoBind: false,
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: dataSource,
                    filter: "contains",
                    height: 150
                });

                setupAppFunctionDropdown(appfunc, "tiff");
                VR.Image.SlideBars.SetupTiff();
            }
        }

        $("#tiffeditor-canvassection,#tiffeditor-canvasannote").css(
            "display",
            "none"
        );
        $("#tiffeditor-buttons").css("display", "");
        $("#tiffeditor-editsection").css("display", "");

        $("#tiffeditor-description").val("");

        modal.attr("data-annotation", "");
        modal.modal("show");
    }; //LoadTiffFile

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Performs next paragraph function.
        /// </summary>
        /// <param name="e">The keydown event handler argument.</param>
        /// <returns></returns>*/
    self.PerformNextParagraph = function (e) {
        var model = $(e.target).data("field");
        if (!model) {
            var parent = $(e.target).parents(".edit-field");
            if (parent.length < 1) {
                parent = $(e.target).parents(".edit-group"); //For grid buttons.
            }
            var inputs = parent.find(".input-field");
            $.each(inputs, function (index, input) {
                var id = $(input).attr("id");
                if (id) {
                    var index = id.indexOf("f");
                    if (index == 0) {
                        model = $(input).data("field");
                        return false;
                    }
                }
            });
        }

        if (!model) {
            return;
        }

        var first = null;
        var section = model.Section;
        var count = self.Fields.length;
        var input = $("#f" + model.FieldId);
        var next = model;
        model = null;
        while (count) {
            next = next.Next;
            if (next.Section == section) {
                count--;
                continue;
            }

            if (!next) {
                break;
            }

            if (next.FieldType != "Hidden" && !first) {
                first = next;
            }
            if (
                next.FieldType != "Hidden" &&
                next.FieldType != "Label" &&
                next.FieldType != "Image" &&
                next.FieldType != "Button"
            ) {
                input = $("#f" + next.FieldId);
                if (!input.hasClass("readonly-text")) {
                    model = next;
                    break;
                }
            }
            count--;
        }

        if (!model || !input || input.length < 1) {
            if (!first) {
                return;
            } else {
                VR.Script.FocusField(
                    { input: "#" + first.FieldId, model: first },
                    false
                );
                return;
            }
        } else {
            VR.Script.FocusField({ input: input[0], model: model }, false);
        }
    }; //PerformNextParagraph

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Populate notes from the web service call result.
        /// </summary>
        /// <param name="result">The web call result.</param>
        /// <returns></returns>*/
    self.PopulateNotes = function (result) {
        self.Notes = null;
        var noteslist = $("#notes-list");
        if (!result || !result.List || result.List.length == 0) {
            noteslist.html("<p>No notes to show.</p>");
            self.Notes = [];
        } else {
            self.Notes = result.List;
            self.CreateNotesList();
        }
    }; //PopulateNotes

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Set query location for the field.
        /// </summary>
        /// <param name="target">The target field.</param>
        /// <returns></returns>*/
    self.QueryField = function (target) {
        var text = $("#fieldquery-text");
        text.val("");
        text.data("target", target);
        var dropdown = $("#fieldquery-location").data("kendoDropDownList");
        if (dropdown) {
            dropdown.select(0);
            $("#fieldquery-modal").modal("show");
        } else {
            VR.Common.SecurePost("data/querylocations", null, function (result) {
                if (result.Code == 0) {
                    var data = [];
                    //data.push({ text: "", value: "" });

                    $.each(result.List, function (index, item) {
                        data.push({ text: item, value: item });
                    });

                    $("#fieldquery-location").kendoDropDownList({
                        dataTextField: "text",
                        dataValueField: "value",
                        dataSource: data,
                        "data-testid": "fieldquery-location"
                    });

                    $("#fieldquery-modal").modal("show");
                } else {
                    options.error(result);
                    VR.Common.HandleInvalidResult(result, "Query Locations", true);
                    return [];
                }
            });

            $("#fieldquery-modal").on("shown.bs.modal", function (e) {
                $("#fieldquery-text").focus();
            });

            $("#fieldquery-accept").on("click", function (e) {
                var target = $("#fieldquery-text").data("target");
                if (target) {
                    target = $(target);
                    var message = $("#fieldquery-text").val();
                    var model = target.data("field");
                    var location = "";
                    var dropdown = $("#fieldquery-location").data("kendoDropDownList");
                    if (dropdown) {
                        location = dropdown.value();
                    }

                    self.SetStatus(target, model, "queried", message, location);
                    $(target).focus();
                }

                $("#fieldquery-text").data("target", null);
            });
        }
    }; //QueryField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Removes error field from error field list.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.RemoveErrorField = function (model) {
        self.ErrorPanel.resetError(model.FieldId);
        var index = self.ErrorFields.indexOf(model);
        if (index > -1) {
            self.ErrorFields.splice(index, 1);
            if (VR.Common.IsMobile()) {
                var field = $("#f" + model.FieldId);
                field.css("border", "1px solid rgb(187,220,235)");
                $("#mobileErrorsBtnText").html(`${self.GetFieldErrorCount()}`);
            }
        }
    }; //RemoveErrorField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Resets the field status.
        /// </summary>
        /// <param name="sender">The field.</param>
        /// <param name="keepState">The value to indicate if the previous changed state needs to be preserved.</param>
        /// <returns></returns>*/
    self.ResetField = function (sender, keepState) {
        var field = $(sender);
        var model = field.data("field");
        if (model) {
            if (model.FieldStatus != null) {
                var status = "input-" + model.FieldStatus;
                field.removeClass(status);
                switch (model.FieldType) {
                    case "CheckBox":
                    case "RadioButton":
                        field.removeClass("checkbox-radio-skipped");
                        field.removeClass("checkbox-radio-overridden");
                        field.removeClass("checkbox-radio-queried");
                        break;
                    case "ComboBox":
                    case "NumericTextBox":
                        field
                            .parents(".edit-field")
                            .find("input")
                            .removeClass(status);
                        break;
                    case "MultiSelect":
                        var parent = field.parents(".edit-field");
                        var input = parent.find(".k-multiselect-wrap ");
                        input.removeClass(status);
                        break;
                }
            }

            model.FieldStatus = null;
            model.ErrorMessage = null;
            //model.HasError = false;
            if (!keepState) {
                var curVal = self.GetInputValue(field, true);
                model.HasChange = (curVal == model.OriginalValue) ? false : true;
                model.HasChangeOvrd = null;
            }
            model.QueryLocation = null;

            self.SetStatus(field, model, null, null, null);
        }
    }; //ResetField

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Handles window resize event.
        /// </summary>
        /// <returns></returns>*/
    self.ResizeWindow = function () {
        var display = $("#alert-span").css("display");
        $("body").css("padding-top", 0);
        if (VR.Common.IsNavBurger()) {
            $("#navbar-bottom").css("display", "");
            $("#tab-control").css("display", "none");
            if (display != "none") {
                $("#alert-span").css("display", "block");
                $("#alert-span").css("margin-top", "10px");
            }
        } else {
            $("#navbar-bottom").css("display", "none");
            $("#tab-control").css("display", "");
            if (display != "none") {
                $("#alert-span").css("display", "");
                $("#alert-span").css("margin-top", "");
            }
        }

        var cropper = $("#tiffeditor-modal").find(".cropper-container");
        if (cropper.length > 0 && self.TiffModalHeight) {
            setTimeout(function (e) {
                cropper.css("height", self.TiffModalHeight);
            }, 100);
        }

        var nav = $("nav");
        if (nav.length > 1) {
            nav = nav[0];
        }

        self.NavHeight = $(nav).height();
    }; //ResizeWindow

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// RowChanged event handler.
        /// </summary>
        /// <param name="e">The event argument.</param>
        /// <returns></returns>*/
    self.RowChanged = function (e) {
        var grid = this;
        var selected = this.select();
        if (selected && selected.length > 0) {
            selected = selected[0];
            if (selected) {
                $(selected)
                    .off("dblclick")
                    .on("dblclick", function (e) {
                        if (!grid.IsEditable && !grid.IsDisplayOnly) {
                            return;
                        }
                        self.DisplayEvent({ grid: grid, selected: this });
                    });
            }
        }

        if (grid) {
            var input = $("#f" + grid.FieldId);
            var model = input.data("field");
            if (model) {
                var timeout = 10;
                if (!grid.Initialized) {
                    timeout = 50;
                }
                grid.Initialized = true;
                setTimeout(function () {
                    //$(selected).focus();
                    var value = VR.Script.GetRowValue(model.FieldId, grid.GridKey);
                    VR.Script.SetVar(value, grid.GridKey);
                    if (grid.IsKeyCached) {
                        VR.Common.CreateDocumentsMenu(grid.GridEvent, value);
                    } else {
                        VR.Common.CreateDocumentsMenu();
                    }
                    self.ValidateField(input);
                }, timeout);
            }
        }
    }; //RowChanged

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the save.
        /// </summary>
        /// <param name="hasEdits">The value to indicate if edits needs to be performed.</param>
        /// <param name="isTwinSave">The value to indicate if this is twin save.</param>
        /// <param name="isScript">The value to indicate if this is script save.</param>
        /// <param name="isAsync">The value to indicate if async post should be performed.</param>
        /// <returns></returns>*/
    self.Save = function (
        hasEdits,
        isTwinSave,
        isScript,
        isAsync,
        byPassUpdateSecurity
    ) {
        var currentSave = self.IsSaving();
        var returnValue = null;
        //self.SetupAllControls();

        if (!byPassUpdateSecurity) byPassUpdateSecurity = false;

        nxLoading.start("Saving record. Please wait...");

        var hasError = false;

        var x = function (state) {
            return function (index, model) {
                self.RemoveErrorField(model);
                model.RequiredFlag = false;
                if (model.FieldStatus != "overridden" && model.FieldStatus != "queried" && model.FieldStatus != "literal") {
                    model.FieldStatus = null;
                }
                var input = $("#f" + model.FieldId);
                input.data("state", state);
                // Fields enabled state at the time of save captured in wasprotected var
                if (model.FieldType == "CheckBox") {
                    let curval = $("#f" + model.FieldId)[0].checked ? "Y" : "N";
                    if (model.OriginalValue != curval) {
                        model.FieldValue = curval;
                        model.HasChange = (model.HasChangeOvrd == null) ? true : model.HasChangeOvrd;
                    }
                }
                if (model && model.ShouldRunEdits) {
                    if (hasEdits) {
                        var wasNotEditable = !model.IsEditable;
                        var wasprotected = !model.IsEnabled;
                        if (wasNotEditable) {
                            // Fields must be editable in order for edits to run. This will handle the role protected fields.
                            model.IsEditable = true;
                        }
                        if (model.IsEnabled === false) {
                            // Temporarily enable the field so that validation will run for the field on save
                            model.IsEnabled = true;
                            nx.EnableField(model.FieldId, "f", true);
                        }
                    }
                    var error = !self.ValidateFieldRules(input, model);
                    var index = self.ErrorFields.indexOf(model);
                    error = error || index > -1;
                    if (error == true) {
                        VR.Common.QueueManager.Clear();
                        self.SetFieldHeight(this, model, false);
                        self.AddErrorField(model);
                    } else if (model.FieldType == "Signature" || model.FieldType == "CheckBox") {
                        if (!self.ValidateField(input)) {
                            VR.Common.QueueManager.Clear();
                            self.SetFieldHeight(this, model, false);
                            self.AddErrorField(model);
                        }
                        index = self.ErrorFields.indexOf(model);
                        error = error || index > -1;
                    }
                    hasError = error || hasError;
                    if (wasNotEditable) {
                        // Set the IsEditable property back to false.
                        model.IsEditable = false;
                    }
                    if (wasprotected) {
                        // Set the field back to disabled if it was disabled prior to the user hitting save
                        model.IsEnabled = false;
                        nx.EnableField(model.FieldId, "f", false);
                    }
                }
            }
        };
        var y = x(isScript ? self.State = 3 : self.State = 2);
        try {
            $("#error-popover").popover("hide");

            var requiredFields = self.Fields.filter(ele => !!ele.IsRequired);
            if (requiredFields) {
                $.each(requiredFields, y);
                var requiredFlags = requiredFields.filter(fld => !!fld.RequiredFlag);
                if (requiredFlags.length > 0) {
                    nxLoading.end();
                    return;
                }
            }

            if (hasEdits) {
                try {
                    $.each(self.Fields, y);
                } catch (err) {
                    console.log(err);
                }
            }

            if (hasError && hasEdits) {
                VR.Common.QueueManager.Clear();
            } else {
                var href = VR.Common.GetRootURL("event/edit") + "event/save";
                var event = self.EventName;
                if (event == null) {
                    event = "";
                }
                var eventId = self.EventId;
                var regCode = self.RegTypeCode;
                if (regCode == null) {
                    regCode = "";
                }
                var modTypeid = self.ModTypeId;
                if (modTypeid == null || modTypeid == 0) {
                    modTypeid = "";
                }
                var value = self.GetFieldData().slice(0, -1);
                var overrides = self.GetFieldOverrides().slice(0, -1);
                var errors = self.GetFieldErrors().slice(0, -1);
                var changed = self.GetChangedFields();
                var otherLits = self.GetOtherLiteralFields().slice(0, -1);
                var selection =
                    "hash=" +
                    editWindowHash +
                    "|name=" +
                    event +
                    "|id=" +
                    eventId +
                    "|overrides=" +
                    overrides +
                    "|otherLits=" +
                    otherLits +
                    "|errors=" +
                    errors +
                    "|changed=" +
                    changed +
                    "|hasEdits=" +
                    hasEdits +
                    "|regcode=" +
                    regCode +
                    "|mod=" +
                    modTypeid +
                    "|count=" +
                    self.SaveCount +
                    "|eventYear=" +
                    self.EventYear +
                    "|value=" +
                    value +
                    "|byPassUpdateSecurity=" +
                    byPassUpdateSecurity +
                    "|specialEventId=" +
                    self.SpecialEventId;
                selection = selection.replace(/</g, "[%%LT%%]").replace(/>/g, "[%%GT%%]");
                var data = { selection: selection };
                VR.Common.Ajax({
                    type: "POST",
                    url: href,
                    data: data,
                    success: function (response) {
                        var result = $.parseJSON(response.Json);
                        var values = value;

                        if (result.Code != 0) {
                            if (!isScript) {
                                if (result.Errors && result.Errors.length > 0) {
                                    self.DoAfterSave(result, !hasEdits);
                                    self.ShowSaveError(result.Message, true);
                                } else if (result.Code == 999999) {
                                    VR.Common.HandleInvalidResult(result, "Save", false);
                                } else {
                                    self.ShowSaveError(result.Message, true);
                                }
                                VR.Common.QueueManager.Clear();
                            }
                            returnValue = result.Message;
                        } else {
                            self.DoAfterSave(result, !hasEdits, values);
                            if (result.KeyFieldId != null && result.KeyFieldValue != null) {
                                nx.MoveLit(result.KeyFieldValue, result.KeyFieldId);
                            }
                            var edit = null;
                            if (hasEdits) {
                                edit = self.ExecuteOnSave();
                            }
                            var third = "false";
                            if (!isScript) {
                                if (edit && edit.Message) {
                                    //A message is shown. No message here.
                                } else if (isTwinSave) {
                                    if (window.opener) {
                                        VR.Common.ShowMessageBox(
                                            "The twin record saved successfully.\r\nDo you want to close the current window?",
                                            function (param) {
                                                window.close();
                                            },
                                            true
                                        );
                                    } else {
                                        VR.Script.Alert("The twin record saved successfully.");
                                    }
                                } else {
                                    if (window.opener) {
                                        VR.Common.ShowMessageBox(
                                            "The record saved successfully.\r\nDo you want to close the current window?",
                                            null,
                                            ["yes", "no"],
                                            null,
                                            function (result) {
                                                if (result) {   // Yes
                                                    window.close();
                                                } else {        // No
                                                    if (self.ModTypeId > 0) {
                                                        if (self.SourceEvent && self.SourceEventId && self.SourceEventId > 0) {
                                                            var selection = self.SourceEvent + "-" + self.SourceEventId;
                                                            VR.Common.SetupEditPage(selection, VR.Common.CanOpen);
                                                        } else {
                                                            window.location.href = self.Referrer;
                                                        }
                                                    }
                                                }
                                            }
                                        );
                                    } else {
                                        VR.Common.ShowMessageBox(
                                            "The record saved successfully.",
                                            function (param) {
                                                if (self.ModTypeId > 0) {
                                                    if (self.EventName && self.EventId && self.EventId > 0) {
                                                        var selection = self.EventName + "-" + self.EventId;
                                                        VR.Common.SetupEditPage(selection, VR.Common.CanOpen);
                                                    }
                                                }
                                            },
                                            ["ok"],
                                            null,
                                            null,
                                            "Message from Webpage"
                                        );
                                    }
                                }
                            }
                            //need to push the record id to the url so if we come off the page and come back
                            //we'll know what record id to lookup!
                            if (result.PreloadId && result.PreloadId != "") {
                                third = "preload%25" + result.PreloadId;
                            }
                            //5503 GR. comment the capitalize
                            $("#plugins").text(
                               // capitalizeFirstLetters(editPageData.PageTitle.split(':')[0]) + ": " + result.EventId//original code
                                editPageData.PageTitle.split(':')[0] + ": " + result.EventId
                            );
                            if (typeof(result.NewRecordHash) === "string" && result.NewRecordHash !== "") {
                                history.pushState(
                                    null,
                                    null,
                                    "edit?selection=eventedit%3D" +
                                    result.NewRecordHash
                                );
                            }
                        }
                    },
                    dataType: "json",
                    async: isAsync
                });
            }
        } finally {
            if (currentSave) { // do not reset state until all save operations completed
            } else {
                self.State = 1;
            }
        }

        if (returnValue == null) {
            returnValue = "";
        }

        setTimeout(function () {
            nxLoading.end();
        }, 3000);

        return returnValue;
    }; //Save

    self.PrintShippingLabel = function (userLocationCode, mailFirstName, mailLastname, mailAddress1, mailCity, mailState, mailZip) {
        var returnValue = {
            tracking_number: null,
            amount: null
        };
        var selection = self.GetShippingTabData()
            + "userLocation=" + userLocationCode + "|"
            + "mailToFirstName=" + mailFirstName + "|"
            + "mailToLastname=" + mailLastname + "|"
            + "mailToAddress1=" + mailAddress1 + "|"
            + "mailToCity=" + mailCity + "|"
            + "mailToState=" + mailState + "|"
            + "mailToZip=" + mailZip;

        var data = { selection: selection };
        VR.Common.Ajax({
            type: "POST",
            url: VR.Common.GetRootURL() + "event/printshippinglabel",
            data: data,
            success: function (response) {
                if (response.error_messages == null) {
                    returnValue.tracking_number = response.tracking_number;
                    returnValue.amount = response.amount;
                    window.open(response.print_label_format);
                }
                else {
                    VR.Common.ShowError(response.error_messages, "Shipping Label could not be created");
                }
            },
            dataType: "json",
            async: false
        });
        nx.MoveLit(returnValue.tracking_number, "SHIPPING_LABEL_TRACKING_NUMBER");
        nx.MoveLit(returnValue.amount, "Estimated Cost");
    };


    self.ProcessTrackingNumber = function () {

        var selection = self.GetShipCarrierAndTrackingNumber();

        var data = { selection: selection };
        VR.Common.Ajax({
            type: "POST",
            url: VR.Common.GetRootURL() + "event/processtrackingnumber",
            data: data,
            success: function (response) {
                if (response[0].Key == "error_messages") {
                    VR.Common.ShowError(response[0].Value, "Unable to find Tracking Number");
                }
                else {
                    window.open(response[0].Value);
                }
            },
            dataType: "json",
            async: true
        });
    };

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets the field height.
        /// </summary>
        /// <param name="field">The input field.</param>
        /// <param name="model">The field model.</param>
        /// <param name="isNormal">The value to indicate if the height is the normal height.</param>
        /// <returns></returns>*/
    self.SetFieldHeight = function (field, model, isNormal) {
        if (!field || !model) {
            return;
        }

        var parent = $(field).parents(".edit-field");
        switch (model.FieldType) {
            case "MemoEdit":
            case "RadioButton":
                break;
            default:
                if (isNormal) {
                    parent.css("height", "");
                } else {
                    // Check error state from model instead of Kendo k-invalid-msg elements
                    if (model.HasError || self.ErrorFields.indexOf(model) > -1) {
                        parent.css("height", "inherit");
                    } else {
                        parent.css("height", "");
                    }
                }
                break;
        }
    }; //SetFieldHeight

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets the currrent field status.
        /// </summary>
        /// <param name="field">The input field.</param>
        /// <param name="model">The field model.</param>
        /// <param name="status">The field status.</param>
        /// <param name="message">The error message.</param>
        /// <param name="location">The query location.</param>
        /// <returns></returns>*/
    self.SetFieldStatus = function (field, model, status, message, location) {
        //model.HasError = false;
        model.FieldStatus = null;
        model.QueryLocation = null;
        if (status && status != "rekeyed") {
            model.FieldStatus = status;
            model.ErrorMessage = message;
            model.QueryLocation = location;
        }
        if (status != "alerttrigger") {
            self.SetAlertStatus(model.FieldName, false, null);
        }
        self.SetFieldStatusColor(field, model);
    }; //SetFieldStatus

    self.SyncEventAlertsCount = function (count) {
        if (VR.Common.IsMobile()) {
            if (count === 0) {
                $("#alert-span").css("display", "none");
            } else {
                $("#alert-span").css("display", "inline");
            }
        }
        var alertcountfield = $('input[data-field-name="ALERT_COUNT"]');
        if (!!alertcountfield) {
            // update the alerts count field
            self.SetFieldValue(alertcountfield, count, true);
        }
        $("#alerts-count").text(count);
        var alerts = $("#alerts-dropdown").data("kendoDropDownList");
        if (!!alerts) {
            if (count === 0) {
                $("#alerts-count").addClass("label-default");
                $("#alerts-count").removeClass("label-danger");
                $(".alerts-dropdown > .k-dropdown-wrap.k-state-default").removeClass(
                    "alerts-danger"
                );
                alerts.enable(false);
            } else {
                alerts.enable(true);
                $("#alerts-count").removeClass("label-default");
                $("#alerts-count").addClass("label-danger");
                $(".alerts-dropdown > .k-dropdown-wrap.k-state-default").addClass(
                    "alerts-danger"
                );
            }
        }
    }; //SyncEventAlertsCount

    self.SetAlertStatus = function (fieldName, addNewAlert, alertMessage) {
        if (addNewAlert) {
            // to add alerts - check to see it it already exist priot to adding
            var count = 0;
            for (var i = 0; i < self.Alerts.length; i++) {
                var item = self.Alerts[i];
                if (item.FieldName == fieldName && item.Message == alertMessage) {
                    count++;
                }
            }
            if (count === 0) {
                self.Alerts.push({
                    AlertId: 0,
                    FieldName: fieldName,
                    Message: alertMessage
                });
            }
        } else {
            // remove the item if it exists
            for (var i = 0; i < self.Alerts.length; i++) {
                var item = self.Alerts[i];
                if (!!fieldName && !!alertMessage) {
                    // if fieldname and alert are provided remove specific alert
                    if (item.FieldName == fieldName && item.Message == alertMessage) {
                        self.Alerts.splice(i, 1);
                    }
                } else {
                    if (item.FieldName == fieldName) {
                        // if alert message is not provided remove all alerts for the field
                        self.Alerts.splice(i, 1);
                    }
                }
            }
        }
        // update the dropdowns datasource with the updated alerts object
        var alertsDropdown = $("#alerts-dropdown").data("kendoDropDownList");
        if (alertsDropdown) {
            var dataSource = new kendo.data.DataSource({
                data: self.Alerts
            });
            alertsDropdown.setDataSource(dataSource);
            alertsDropdown.select(0);
            alertsDropdown.trigger("change");
        }
        // update the alerts count field
        self.SyncEventAlertsCount(self.Alerts.length);
    }; //SetAlertStatus

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets the currrent field status color.
        /// </summary>
        /// <param name="field">The input field.</param>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetFieldStatusColor = function (field, model) {
        field = $(field);
        if (field.hasClass("readonly-text")) {
            return;
        }

        var isDark = $("#isdarkgadget").val();
        var status = model.FieldStatus;
        if (status && status != "rekeyed") {
            status = "input-" + status;
            field.addClass(status);
            switch (model.FieldType) {
                case "CheckBox":
                case "RadioButton":
                    status = "checkbox-radio-" + model.FieldStatus;
                    field.addClass(status);
                    break;
                case "ComboBox":
                case "NumericTextBox":
                    field
                        .parents(".edit-field")
                        .find("input")
                        .addClass(status);
                    break;
                case "MultiSelect":
                    var parent = field.parents(".edit-field");
                    var input = parent.find(".k-multiselect-wrap");
                    input.addClass(status);
                    break;
                case "MaskedTextBox":
                    break;
            }
            if (isDark) {
                field.css("color", "black");
            }
        } else {
            if (isDark) {
                field.css("color", "");
            }
            field.removeClass("input-overridden");
            field.removeClass("input-queried");
            field.removeClass("input-skipped");
            switch (model.FieldType) {
                case "CheckBox":
                case "RadioButton":
                    var inputs = field.parents(".edit-field");
                    inputs.removeClass("checkbox-radio-skipped");
                    inputs.removeClass("checkbox-radio-overridden");
                    inputs.removeClass("checkbox-radio-queried");
                    break;
                case "ComboBox":
                case "NumericTextBox":
                    var inputs = field.parents(".edit-field").find("input");
                    inputs.removeClass("input-overridden");
                    inputs.removeClass("input-queried");
                    inputs.removeClass("input-skipped");
                    inputs.removeClass("input-literal");
                    break;
                case "MultiSelect":
                    var parent = field.parents(".edit-field");
                    var inputs = parent.find(".k-multiselect-wrap");
                    inputs.removeClass("input-overridden");
                    inputs.removeClass("input-queried");
                    inputs.removeClass("input-skipped");
                    break;
                case "MaskedTextBox":
                    break;
            }
        }
    }; //SetFieldStatusColor

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets field value.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <param name="value">The field value.</param>
        /// <param name="applyall">The value to indicate if the change is applied to all fields with the same field name.</param>
        /// <returns></returns>*/
    self.SetFieldValue = function (input, value, applyall, runComboBoxFetch) {
        var field = $(input).data("field");
        if (field) {
            switch (field.FieldType) {
                case "CheckBox":
                    $(input).prop("checked", value === true || value == "Y");
                    break;
                case "ComboBox":
                    var comboBox = $(input).data("kendoComboBox");
                    if (comboBox) {
                        let cbDataSource = comboBox.dataSource;
                        if (cbDataSource && VR.Edit.State > 0 && runComboBoxFetch === true) {
                            //VRS-5459 - the combobox data set uses this element to get the value to load the list, so set it before fetching items
                            //the value we get in the method is the SAVE value, but the value typically needed for the server search is the DISPLAY value
                            //find the display value if possible from the existing combobox options, if not, set the lookup type to "value" and use SAVE value passed in to method
                            let dataSourceList = cbDataSource.data();
                            let found = false;
                            for (let i = 0; i < dataSourceList.length && found === false; i++) {
                                let dataItem = dataSourceList[i];
                                if (dataItem.value == value) {
                                    found = true;
                                    $("#f" + field.FieldId).parent().find("input[name='f" + field.FieldId + "_input']").val(dataItem.text);
                                    field.LookupType = "label";
                                }
                            }
                            if (!found) {
                                //we need to set this to have the lookup process use the SAVE value instead of the normal DISPLAY value
                                field.LookupType = "value";
                                $("#f" + field.FieldId).parent().find("input[name='f" + field.FieldId + "_input']").val(value);
                            }
                            cbDataSource.fetch().then(function () {
                                var list = comboBox.list;
                                if (list) {
                                    var selected = false;
                                    //if (!nxLoading.IsLoading()) comboBox.search($(input).val());
                                    comboBox.select(function (dataItem) {
                                        selected = dataItem && dataItem.value == value;
                                        return selected;
                                    });
                                    if (selected == false) {
                                        comboBox.text(value);
                                    }
                                }
                                $(input).data("prevValue", comboBox.value());
                            });
                        }
                        else {
                            var list = comboBox.list;
                            if (list) {
                                var selected = false;
                                //if (!nxLoading.IsLoading()) comboBox.search($(input).val());
                                comboBox.select(function (dataItem) {
                                    selected = dataItem && dataItem.value == value;
                                    return selected;
                                });
                                if (selected == false) {
                                    comboBox.text(value);
                                }
                            }
                            $(input).data("prevValue", comboBox.value());
                        }
                    }
                    break;
                case "RadioButton":
                    var buttons = $(input).find("input");
                    $.each(buttons, function (index, radio) {
                        var val = $(radio).val();
                        if (val == value) {
                            radio.checked = true;
                        } else {
                            radio.checked = false;
                        }
                    });
                    break;
                case "MonthPicker":
                case "DatePicker":
                case "MaskedTextBox":
                    var maskedtextbox = $(input).data("kendoMaskedTextBox");
                    if (!maskedtextbox) {
                        //we may want to set up month and date pickers here as well, but that will be for another ticket
                        if (field.FieldType === "MaskedTextBox") {
                            VR.Edit.SetupMaskedEdit(field);
                            maskedtextbox = $(input).data("kendoMaskedTextBox");
                        }
                    }
                    if (maskedtextbox) {
                        // VRS-6552: Skip Kendo value() if ANY field is validating to prevent focus loop
                        if (self.validatingFieldCount > 0) {
                            field.FieldValue = value;
                            field.HasChange = true;
                            // Update the input element directly without triggering Kendo events
                            $(input).val(value);
                        } else {
                            maskedtextbox.value(value);
                        }
                    }
                    break;
                case "Signature":
                    var model = $(input).data("field");
                    if (model) {
                        model.FieldValue = value;
                    }
                    break;
                case "NumericTextBox":
                    var numbertextbox = $(input).data("kendoNumericTextBox");
                    if (numbertextbox) {
                        numbertextbox.value(value);
                    }
                    break;
                case "TimePicker":
                    var tp = $(input).data("kendoTimePicker");
                    if (tp) {
                        tp.value(value);
                    }
                    break;
            }
            if (
                field.FieldType != "MaskedTextBox" &&
                field.FieldType != "DatePicker" &&
                field.FieldType != "MonthPicker" &&
                field.FieldType != "TimePicker"
            ) {
                $(input).val(value);
            }
            //VRS-5885
            var fieldVal = "";
            if (typeof (field) === "object" && typeof (field.FieldValue) !== "undefined" && field.FieldValue !== null) {
                fieldVal = field.FieldValue;
            }
            var origVal = "";
            if (typeof (field) === "object" && typeof (field.OriginalValue) !== "undefined" && field.OriginalValue !== null) {
                origVal = field.OriginalValue;
            }
            if (fieldVal != value) {
                field.HasChange = (!!field.HasChangeOvrd) ? field.HasChangeOvrd : true;
                field.PreviousValue = fieldVal;
            }
            field.FieldValue = value;

            if (applyall) {
                var fieldName = $(input).attr("data-field-name");
                //var inputs = $("#tab-content").find("input[data-field-name='" + fieldName + "']");
                var inputs = self.GetInputFields(fieldName);
                var id = $(input).attr("id");
                $.each(inputs, function (index, input) {
                    var fieldId = $(input).attr("id");
                    if (fieldId != id) {
                        self.SetFieldValue(input, value);
                    }
                });
            }
        }
    }; //SetFieldValue

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets field value.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <param name="value">The field value.</param>
        /// <param name="applyall">The value to indicate if the change is applied to all fields with the same field name.</param>
        /// <returns></returns>*/
    self.SetFieldValues = function (input, value, applyall) {
        var id = parseInt(input);
        if (!isNaN(id)) {
            self.SetFieldValue("#f" + id, value, applyall);
        } else {
            var inputs = $(input);
            if (inputs.length == 0) {
                //inputs = $("#tab-content").find("input[data-field-name='" + input + "']");
                inputs = self.GetInputFields(input);
            }
            if (inputs.length > 0) {
                self.SetFieldValue(inputs[0], value, applyall);
            }
        }
    }; //SetFieldValues

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets the modal editor size and returns the width and height of cropper object to be created.
        /// </summary>
        /// <param name="modal">The modal object.</param>
        /// <returns>The width and height of cropper object to be created.</returns>*/
    self.SetImageEditorSize = function (modal) {
        var returnValue = { width: 0, height: 0 };
        if (!modal) {
            return returnValue;
        }

        var headers = modal.find(".imageeditor-headers");
        var visible = null;
        if (headers.length > 0) {
            visible = $(headers[0]).css("display");
        }
        var windowwidth = $(window).width();
        var windowheight = $(window).height();
        var width = windowwidth;
        var height = windowheight;
        if (windowwidth < 768) {
            height *= 0.65;
        } else {
            height *= 0.9;
        }
        if (visible == "" || (visible && visible != "none")) {
            var headers = modal.find(".imageeditor-header");
            var headerheight = headers.length * 30;
            height -= headerheight;
        }

        height -= 40; //For sliders and annotation buttons
        height = Math.round(height);
        width *= 0.94;
        width = Math.round(width);
        var content = $(modal).find(".modal-dialog");
        content.css("height", height + "px");
        content.css("width", width + "px");
        content.css("margin-left", Math.round((windowwidth - width) / 2) + "px");

        height -= 150;
        width -= 100;
        if (windowwidth >= 768) {
            height = Math.max(400, height);
            width = Math.max(550, width);
        } else {
            height = Math.max(250, height);
            width = Math.max(280, width);
        }

        returnValue.height = height;
        returnValue.width = width;

        return returnValue;
    }; //SetImageEditorSize

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets read-only status.
        /// </summary>
        /// <param name="input">The input field.</param>
        /// <param name="isReadOnly">The value to indicate if the field is read-only.</param>
        /// <returns></returns>*/
    self.SetReadOnly = function (input, isReadOnly) {
        var model = $(input).data("field");
        if (!model) return;

        var isDark = $("#isdarkgadget").val();
        var intInputId = parseInt(input);

        // Helper function to reinitialize fields after being unprotected
        var reinitializeFieldEvents = function (field, $input) {
            setTimeout(function () {
                self.CreateFieldValidator(field);

                // Force focus to fix input issue
                if ($input.is(':focus')) {
                    $input.blur().focus();
                }
            }, 100);
        };

        // Normalize input to jQuery selector
        if (!isNaN(intInputId)) {
            input = "#f" + intInputId;
        } else if (typeof input === "string" && input.charAt(0) !== "#") {
            input = "#" + input;
        }

        var $input = $(input);
        var field = $input.data("field");
        if (!field) return;

        // Helper function to apply dark mode styles
        function applyDarkModeStyles($element, isReadOnly) {
            if (isDark) {
                $element.css("color", isReadOnly ? "black" : "");
            }
        }

        // Helper function to set background color
        function setBackgroundColor($element, isReadOnly) {
            $element.css("background-color", isReadOnly ? "silver" : "");
            applyDarkModeStyles($element, isReadOnly);
        }

        // Helper function to handle field enable/disable
        function setFieldEnabled(enabled) {
            field.IsEnabled = enabled;
        }

        // Blur focused field before disabling to prevent focus loop
        if (isReadOnly && $input.is(':focus')) {
            field.IsEnabled = false;
            $input.blur();
        }

        // Handle regular input elements first
        if (isReadOnly) {
            $input.addClass("readonly-text").prop("readonly", true);
        } else {
            $input.removeClass("readonly-text").prop("readonly", false);
        }

        switch (field.FieldType) {
            case "MaskedTextBox":
                if (isReadOnly) {
                    $input.addClass("readonly-text").attr("disabled", true);
                    setFieldEnabled(false);
                } else if (field.IsEditable) {
                    $input.removeClass("readonly-text").removeAttr("disabled");
                    $input.parent("span").removeClass("readonly-text k-disabled");
                    reinitializeFieldEvents(field, $input);
                    setFieldEnabled(true);

                    // Initialize masked textbox if not already done
                    if (!$input.data("kendoMaskedTextBox") && !$input.data("masked-setup-complete")) {
                        $input.data("masked-setup-complete", true);
                        $input.kendoMaskedTextBox({
                            mask: field.Mask,
                            unmaskOnPost: false
                        });
                    }
                }
                break;

            case "AutoComplete":
                var autocomplete = $input.data("kendoAutoComplete");
                if (autocomplete) {
                    autocomplete.readonly(isReadOnly);
                    setBackgroundColor($input, isReadOnly);
                    reinitializeFieldEvents(field, $input);
                    setFieldEnabled(true);
                }
                break;

            case "ComboBox":
                var comboBox = $input.data("kendoComboBox");
                if (comboBox) {
                    var fieldId = field.FieldId;
                    var $wrapper = $input.parent("span.k-combobox");
                    var $textBox = $wrapper.find("input[name='f" + fieldId + "_input']");
                    var $span = $input.parent().find("span");
                    var $allElements = $wrapper.find("*").addBack();

                    if (isReadOnly) {
                        comboBox.readonly(true);
                        comboBox.enable(false);
                        setFieldEnabled(false);
                        setBackgroundColor($span.add($textBox), true);
                        $wrapper.addClass("readonly-text");
                        $textBox.addClass("readonly-text");
                        $input.addClass("readonly-text");
                        setBackgroundColor($allElements, true);
                    } else if (field.IsEditable) {
                        comboBox.readonly(false);
                        comboBox.enable(true);
                        setBackgroundColor($span.add($textBox), false);
                        $wrapper.removeClass("readonly-text");
                        $textBox.removeClass("readonly-text");
                        $input.removeClass("readonly-text");
                        setBackgroundColor($allElements, false);
                        reinitializeFieldEvents(field, $input);
                        setFieldEnabled(true);
                    }
                }
                break;

            case "MonthPicker":
            case "DatePicker":
                var datepicker = $input.data("kendoDatePicker");
                var maskedTextBox = $input.data("kendoMaskedTextBox");

                if (datepicker) {
                    var $wrapper = $input.closest(".k-datepicker");
                    var $allElements = $wrapper.find("*").addBack().add($input);

                    if (isReadOnly) {
                        datepicker.readonly(true);
                        datepicker.enable(false);
                        $wrapper.addClass("k-disabled readonly-text");
                        $wrapper.find("span").addClass("readonly-text");
                        $input.attr("aria-disabled", "true").attr("disabled", "disabled");

                        if (maskedTextBox) {
                            maskedTextBox.readonly(true);
                            maskedTextBox.enable(false);
                        }

                        setFieldEnabled(false);
                        setBackgroundColor($allElements, true);
                    } else if (field.IsEditable) {
                        datepicker.readonly(false);
                        datepicker.enable(true);
                        $wrapper.removeClass("k-disabled readonly-text");
                        $wrapper.find("span").removeClass("readonly-text");
                        $input.removeAttr("aria-disabled").removeAttr("disabled");

                        if (maskedTextBox) {
                            maskedTextBox.readonly(false);
                            maskedTextBox.enable(true);
                        }

                        reinitializeFieldEvents(field, $input);
                        setFieldEnabled(true);
                        setBackgroundColor($allElements, false);
                    }
                    setBackgroundColor($input, isReadOnly);
                }
                break;

            case "NumericTextBox":
                var numeric = $input.data("kendoNumericTextBox");
                if (numeric) {
                    var $inputs = $input.closest(".edit-field").find("input");

                    if (isReadOnly) {
                        numeric.readonly(true);
                        $inputs.addClass("readonly-text");
                        setFieldEnabled(false);
                    } else if (field.IsEditable) {
                        numeric.readonly(false);
                        $inputs.removeClass("readonly-text");
                        reinitializeFieldEvents(field, $input);
                        setFieldEnabled(true);
                    }
                    setBackgroundColor($inputs, isReadOnly);
                }
                break;

            case "Button":
            case "Signature":
                if (isReadOnly) {
                    $input.attr("disabled", "disabled");
                    setFieldEnabled(false);
                } else if (field.IsEditable) {
                    $input.removeAttr("disabled");
                    setFieldEnabled(true);
                }
                break;

            case "RadioButton":
                var $radioInputs = $("#f" + field.FieldId + " *");
                var isDisabled = isReadOnly || !field.IsEditable;

                $radioInputs.prop("disabled", isDisabled);
                $input.attr("aria-disabled", isDisabled.toString());
                setFieldEnabled(!isDisabled);
                break;

            case "MultiSelect":
                var multiselect = $input.data("kendoMultiSelect");
                if (multiselect) {
                    multiselect.readonly(isReadOnly);
                    var $text = $input.closest(".edit-field").find(".k-multiselect-wrap");

                    if (isReadOnly) {
                        $input.addClass("readonly-text").attr("disabled", true);
                        setFieldEnabled(false);
                    } else if (field.IsEditable) {
                        $input.removeClass("readonly-text").removeAttr("disabled");
                        reinitializeFieldEvents(field, $input);
                        setFieldEnabled(true);
                    }
                    setBackgroundColor($text, isReadOnly);
                }
                break;

            default:
                // Handle generic text inputs and other field types
                if (isReadOnly) {
                    $input.addClass("readonly-text").attr("disabled", true);
                    setFieldEnabled(false);
                } else if (field.IsEditable) {
                    $input.removeClass("readonly-text").removeAttr("disabled");
                    setFieldEnabled(true);

                    // Fix for date fields with jQuery mask plugin
                    if (field.Mask && (field.Mask.includes("99/99/9999") || field.Mask.includes("00/00/0000") || field.Mask === "99/99/9999")) {
                        var currentValue = $input.val();
                        if (typeof $input.unmask === 'function') {
                            $input.unmask();
                        }
                        $input.val("");
                        if (typeof $input.mask === 'function') {
                            $input.mask("99/99/9999", { placeholder: "mm/dd/yyyy" });
                        }
                        if (currentValue && currentValue.length > 0) {
                            $input.val(currentValue);
                        }
                    }
                }
                break;
        }
    }; //SetReadOnly

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets the currrent field status.
        /// </summary>
        /// <param name="field">The input field.</param>
        /// <param name="model">The field model.</param>
        /// <param name="status">The field status.</param>
        /// <param name="message">The error message.</param>
        /// <param name="location">The query location.</param>
        /// <returns></returns>*/
    self.SetStatus = function (field, model, status, message, location) {
        if (!model) {
            return;
        }

        var inputs = self.GetInputFields(model.FieldName);
        if (status == "skipped" || status == "rekeyed") {
            $.each(inputs, function (index, input) {
                if (status == "rekeyed") {
                    self.DoFieldValueChanged(input);
                }
            });
        }

        self.SetFieldStatus(field, model, status, message, location);
        var errorSection = $("#f" + model.FieldId + "-msg");
        if (errorSection) {
            errorSection.css("display", "none");
        }

        $.each(inputs, function (index, input) {
            var data = $(input).data("field");
            if (data != model) {
                self.SetFieldStatus(input, data, status, message, location);
                //data.FieldStatus = model.FieldStatus;
                //data.ErrorMessage = model.ErrorMessage;
                //data.QueryLocation = model.QueryLocation;
            }
        });

        //self.SetFieldHeight(this, model, true);
        //var inputs = $("#tab-content").find("input[data-field-name='" + model.FieldName + "']");
    }; //SetStatus

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets the current page for the Tiff Image editor.
        /// </summary>
        /// <param name="section">The cropper section.</param>
        /// <param name="page">The page number.</param>
        /// <param name="size">The TIFF page length.</param>
        /// <returns></returns>*/
    self.SetTiffEditorPage = function (section, page, size) {
        if (!size | !section || page < 0 || page >= size) {
            return;
        }
        section.attr("data-page-number", page);
        var canvases = $("#tiffeditor-canvassection,#tiffeditor-canvasannote");
        for (var i = 0; i < size; i++) {
            var tiffpage = $("#tiffeditor-pagesection" + (i + 1));
            if (i != page) {
                tiffpage.css("display", "none");
            } else {
                var cropped = tiffpage.attr("data-cropped");
                if (!cropped) {
                    canvases.css("display", "none");
                    section.css("display", "");
                    $("#tiffeditor-buttons")
                        .find(".btn-cropbutton")
                        .css("visibility", "visible");
                    $("#tiffeditor-slidebars").css("visibility", "visible");
                    tiffpage.css("display", "");
                    var mode = tiffpage.attr("mode");
                    if (mode == "1") {
                        $("#tiffeditor-cropbutton").trigger("click");
                    } else {
                        $("#tiffeditor-dragbutton").trigger("click");
                    }
                } else {
                    canvases.css("display", "");
                    section.css("display", "none");
                    $("#tiffeditor-buttons")
                        .find(".btn-cropbutton")
                        .css("visibility", "hidden");
                    $("#tiffeditor-slidebars").css("visibility", "hidden");
                    for (var i = 0; i < size; i++) {
                        var tiffpage = $("#tiffeditor-canvas" + (i + 1));
                        if (i == page) {
                            tiffpage.css("display", "");
                        } else {
                            tiffpage.css("display", "none");
                        }
                    }
                }
            }
        }

        page++;
        $("#tiffeditor-pagenumber").html("Page " + page + " of " + size);
    }; //SetTiffEditorPage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up all controls.
        /// </summary>
        /// <returns></returns>*/
    self.SetupAllControls = function () {
        if (self.Tabs && self.Tabs.length > 0) {
            for (var i = 0; i < self.Tabs.length; i++) {
                self.SetupControls(i);
            }
            self.InitFields();
        }
    }; //SetupAllControls

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the Action menu.
        /// </summary>
        /// <returns></returns>*/
    self.SetupActionMenus = function () {
        self.SetupScanImage();
        self.SetupFileLoad();
        self.SetupImageEdit();
        self.SetupViewImage();
        self.SetupReviewError();
        self.SetupNumberRecord();
        self.SetupEventActivation();
        self.SetupDocTracking();
        self.SetupTypeFromImage();
        $("#runviews-menu").on("click", function (e) {
            VR.Script.Views();
        });

        $("#action-menu")
            .find("a")
            .on("click", function (e) {
                if (VR.Common.IsNavBurger()) {
                    $("#top-button").trigger("click");
                }
            });
    }; //SetpActionMenus

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the AutoComplete control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupAutoComplete = function (model) {
        var field = $("#f" + model.FieldId);
        if (model.FieldType == "TextBox") {
            field.kendoAutoComplete({
                "data-testid": model.FieldId
            });
        } else {
            var dataSource = [];
            if (model.DropDownList) {
                dataSource = model.DropDownList;
            } else {
                var fieldId = model.FieldId;
                dataSource = new kendo.data.DataSource({
                    transport: {
                        read: function (options) {
                            var input = $("#f" + fieldId);
                            input.attr("autocomplete", "off");
                            var val = $(input).val();
                            var model = $(input).data("field");
                            var filter = self.GetFilterValues(model);
                            var voidVal = "";
                            if (model && model.VoidField) {
                                voidVal = self.GetFieldValue(model.VoidField);
                            }
                            voidVal = encodeURIComponent(voidVal);
                            var valfiltertype = "";
                            if (model && model.ValFilterType) {
                                valfiltertype = model.ValFilterType;
                            }
                            valfiltertype = encodeURIComponent(valfiltertype);
                            var webfiltertype = "";
                            if (model && model.WebFilterType) {
                                webfiltertype = model.WebFilterType;
                            }
                            webfiltertype = encodeURIComponent(webfiltertype);
                            performLookup(
                                fieldId,
                                val,
                                filter,
                                valfiltertype,
                                voidVal,
                                webfiltertype,
                                self.EventYear,
                                function (result) {
                                    if (result.Code == 0) {
                                        var data = [];
                                        if (!result.List || result.List.length == 0) {
                                            //data.push({ text: "", value: "" });
                                        } else {
                                            for (var i = 0; i < result.List.length; i++) {
                                                var value = result.List[i];
                                                var key = null;
                                                if (result.Keys && result.Keys.length > i) {
                                                    key = result.Keys[i];
                                                }
                                                //if (value == model.FieldValue) {
                                                //    index = i;
                                                //}
                                                data.push({ text: value, key: key });
                                            }
                                        }

                                        if (!!options) options.success(data);
                                        return data;
                                    } else {
                                        options.error(result);
                                        VR.Common.HandleInvalidResult(result, "Lookup", false);
                                        return [];
                                    }
                                }
                            );
                        }
                    },
                    serverFiltering: true
                });
            }

            field.kendoAutoComplete({
                dataSource: dataSource,
                dataTextField: "text",
                delay: 200,
                filter: "contains",
                "data-testid": model.FieldId
            });

            // Adjust width for narrow fields
            if (model && model.DisplayWidth <= 10) {
                var currentWidth = parseInt($(input).css('maxWidth'));
                var newWidth = currentWidth + 28;
                $(input).css('max-width', newWidth + 'px');
                var wrapper = $(input).closest('.k-combobox');
                wrapper.css('max-width', newWidth + 'px');
                wrapper.find('input').css('max-width', newWidth + 'px');
            }
        }
        field.attr("spellcheck", model.SpellCheck);
        field.on("keypress", function (e) {
            var model = $(this).data("field");
            if (model && model.FieldStatus != null) {
                self.ResetField(this, true);
            }
            model.HasChange = (model.HasChangeOvrd == null) ? false : model.HasChangeOvrd;
        });

        field.on("keydown", function (e) {
            var value = $(this).val();
            if (!value && e.which == 8) {
                e.preventDefault();
                var autocomplete = $(this).data("kendoAutoComplete");
                if (autocomplete) {
                    autocomplete.search("");
                }
            } else {
                self.FieldKeyDown(e);
            }
        });
        field.on("keyup", self.FieldKeyUp);

        field.on("focus", function (e) {
            // Only select if not already processing to prevent loops
            if (!$(this).data('selecting')) {
                $(this).data('selecting', true);
                try {
                    $(this).select();
                } finally {
                    var $this = $(this);
                    setTimeout(function() {
                        $this.data('selecting', false);
                    }, 100);
                }
            }
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });
    }; //SetupAutoComplete

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the back button.
        /// </summary>
        /// <returns></returns>*/
    self.SetupBackButton = function () {
        if (
            !self.Referrer ||
            self.Referrer.toLowerCase().indexOf("/event/edit") == -1
        ) {
            $("#previouspage-button").css("display", "none");
        }

        $("#previouspage-button").on("click", function () {
            self.CanLeavePage(function () {
                if (self.SourceEvent && self.SourceEventId && self.SourceEventId > 0) {
                    var selection = self.SourceEvent + "-" + self.SourceEventId;
                    VR.Common.SetupEditPage(selection, VR.Common.CanOpen);
                } else {
                    window.location.href = self.Referrer;
                }
            });
        });
    }; //SetupBackButton

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the Button control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupButton = function (model) {
        var input = $("#f" + model.FieldId);
        $(input).attr("data-field-name", model.FieldName);
        $(input).on("click", function (e) {
            self.ErrorPanel.resetError(model.FieldId);
            $.each(model.Edits, function (index, edit) {
                if (model.ShouldRunEdits) {
                    VR.Script.ExecuteScript(input, model, edit);
                }
            });
        });

        $(input).on("focus", function (e) {
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });

        input.on("keydown", self.FieldKeyDown);

        var parent = input.parents(".edit-field");
        $(parent).css("height", "auto");
    }; //SetupButton

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the CheckBox control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <param name="isCreating">The value to indicate if the field is to be created.</param>
        /// <returns></returns>*/
    self.SetupCheckBox = function (model, isCreating) {
        if (isCreating) {
            var html =
                "<input class='k-checkbox' type='checkbox' id='f" +
                VR.Common.HtmlEscape(model.FieldId) +
                "' ";
            if (model.FieldValue == "Y" || model.FieldValue == "T") {
                html += " checked='checked'";
            }
            if (model.IsEnabled != true || model.IsEditable === false) {
                html += " disabled='disabled'";
            }
            html +=
                " /><label class='k-checkbox-label' for='f" +
                VR.Common.HtmlEscape(model.FieldId) +
                "'></label>";

            var section = $("#p" + model.FieldId);
            $(section).html(html);
            $(section).addClass("input-field");
        }

        var input = $("#f" + model.FieldId);
        $(input).prop("checked", ["Y", "T"].includes(model.FieldValue));
        input.on("keydown", self.FieldKeyDown);

        input.on("focus", function (e) {
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });

        input.on("change blur", function (e) {
            if (nx.ValueOf(model.FieldId) == "Y" || nx.ValueOf(model.FieldId) == "T") {
                $(input).attr("checked", "checked");
            } else {
                $(input).removeAttr("checked");
            }
            self.DoFieldValueChanged("#f" + model.FieldId);
            if (model.Edits.length > 0) {
                self.ValidateField(input);
                e.preventDefault();

                self.DoSkipFields(input);
                //self.FocusNextField(model, e.shiftKey);                
            }
        });
    }; //SetupCheckBox
    self.SetupDataSourceForComboBox = function (
        fieldName,
        textProperty,
        valueProperty,
        model,
        fieldValue
    ) {
        if (!fieldValue) fieldValue = "";
        return {
            DropDownList: $.map(model, function (row) {
                return row[textProperty];
            }),
            DropDownValues: $.map(model, function (row) {
                return row[valueProperty];
            }),
            FieldValue: fieldValue,
            FieldId: self.GetFieldIdFromFieldName(fieldName)
        };
    }; //SetupDataSourceForComboBox
    self.SetupDataSourceForDropDownList = function (
        fieldName,
        textProperty,
        valueProperty,
        model
    ) {
        return {
            List: $.map(model, function (row) {
                return row[textProperty];
            }),
            Keys: $.map(model, function (row) {
                return row[valueProperty];
            })
        };
    }; //SetupDataSourceForDropDownList
    self.GetFieldIdFromFieldName = function (fieldName) {
        var escaped = VR.Common.EscapeSelector(fieldName);
        var field = $("input[data-field-name='" + escaped + "']");
        if (!!field && field.length > 0) {
            return field.attr("id").substring(1);
        } else {
            return "";
        }
    }; //GetFieldIdFromName
    self.ComboBoxTimeout = null;
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up ComboBox.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupComboBox = function (model) {
        var dataSource = [];
        var index = -1;
        var autoBind = false;
        model.FieldType = "ComboBox";
        var filter = "";
        var shouldUpdateFieldValue = null;
        var input = $("#f" + model.FieldId);
        var fieldId = model.FieldId;

        function addDataSourceItem(text, value) {
            dataSource.push({ text: text, value: value });
        }

        function getCurrentValue(item) {
            return item.ValueInt === null ? item.ValueString : item.ValueInt;
        }

        if (model.DropDownList && model.DropDownValues) {
            if (model.ValidationDropdownItems) {
                for (var i = 0; i < model.ValidationDropdownItems.length; i++) {
                    var curItem = model.ValidationDropdownItems[i];
                    var curValue = getCurrentValue(curItem);
                    if (curValue == model.FieldValue) {
                        index = i;
                    }
                    else if (model.FieldValue == curItem.Label) {
                        index = i;
                        shouldUpdateFieldValue = curValue;
                    }
                    addDataSourceItem(curItem.Label, curValue);
                }
            }
            else {
                for (var i = 0; i < model.DropDownList.length; i++) {
                    var value = model.DropDownValues[i];

                    if (value == model.FieldValue) {
                        index = i;
                    }
                    if (value.trim() != "") {
                        addDataSourceItem(model.DropDownList[i], value);
                    }
                }
            }
            autoBind = true;
        }
        else {
            filter = "startswith";
            var fieldId = model.FieldId;
            dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (options) {
                        var inputElement = input.parent().find("input[name='f" + fieldId + "_input']");
                        var val = inputElement.val();
                        var fieldModel = input.data("field");
                        var filterValues = self.GetFilterValues(fieldModel);
                        var voidVal = "";
                        if (fieldModel && fieldModel.VoidField) {
                            voidVal = self.GetFieldValue(fieldModel.VoidField);
                        }
                        var valfiltertype = "";
                        if (fieldModel && fieldModel.ValFilterType) {
                            valfiltertype = fieldModel.ValFilterType;
                        }
                        valfiltertype = encodeURIComponent(valfiltertype);
                        var webfiltertype = "";
                        if (fieldModel && fieldModel.WebFilterType) {
                            webfiltertype = fieldModel.WebFilterType;
                        }
                        webfiltertype = encodeURIComponent(webfiltertype);
                        performLookup(
                            fieldId,
                            val,
                            filterValues,
                            valfiltertype,
                            voidVal,
                            webfiltertype,
                            self.EventYear,
                            function (result) {
                                fieldModel.LookupType = null; //reset lookup type so that we don't always use one value over another
                                if (result.Code == 0) {
                                    var data = [];
                                    if (!result.List || result.List.length == 0) {
                                        //data.push({ text: "", value: "" });
                                    } else {
                                        fieldModel.DropDownList = result.List;
                                        fieldModel.DropDownValues = result.Keys;
                                        fieldModel.ValidationDropdownItems = result.DropdownOptions;
                                        for (var i = 0; i < result.DropdownOptions.length; i++) {
                                            var curDropdownOption = result.DropdownOptions[i];
                                            data.push({
                                                text: curDropdownOption.Label,
                                                value: getCurrentValue(curDropdownOption)
                                            });
                                        }
                                    }
                                    if (!!options) options.success(data);
                                    // this is Kendo magic
                                    else {
                                        // we need to apply the changes here if options is not assigned.
                                        input.data("kendoComboBox").setDataSource(data);
                                    }
                                    if (!inputElement.is(":focus")) {
                                        input.data("kendoComboBox").close();
                                    }
                                    return data;
                                } else {
                                    options.error(result);
                                    VR.Common.HandleInvalidResult(result, "Lookup", true);
                                    return [];
                                }
                            }
                        );
                    }
                },
                serverFiltering: true
            });
        }

        var input = $("#f" + model.FieldId);
        if (!model.AllowOther) {
            input.addClass("combobox-no-literals");
        }
        if (model.WebFilterType != "" && model.WebFilterType != null) {
            filter = model.WebFilterType;
        }
        var groupdiv = $("#g" + model.FieldId + ">div>div");
        var combospan = groupdiv.find("div > span.k-combobox");
        $(input).kendoComboBox({
            dataTextField: "text",
            dataValueField: "value",
            dataSource: dataSource,
            delay: 200,
            filter: filter,
            autoBind: autoBind,
            suggest: true,
            open: function (e) {
                var dropDown = $(e.sender.element);
                if (!dropDown.is(":not([readonly])")) {
                    e.preventDefault();
                }
            }
        });

        // Adjust width for narrow fields
        if (model && model.DisplayWidth <= 10) {
            var currentWidth = parseInt(input.css('maxWidth'));
            var newWidth = currentWidth + 28;
            var wrapper = input.closest('.k-combobox');
            input.css('max-width', newWidth + 'px');
            wrapper.css('max-width', newWidth + 'px');
            wrapper.find('input').css('max-width', newWidth + 'px');
        }

        var selectbutton = input.parent().find("button[aria-label='expand combobox']");
        selectbutton.attr("aria-label", model.FieldLabel + " Select");
        selectbutton.attr("data-testid", "f" + model.FieldId + "_Expand");
        $("[name='f" + model.FieldId + "_input']").attr("spellcheck", model.SpellCheck);
        var comboBox = input.data("kendoComboBox");
        // myQA's Select action builds //*[@aria-ownedby="f<FieldId>"] and searches options inside it.
        // Kendo doesn't emit aria-ownedby, so stamp it on the generated listbox <ul>.
        if (comboBox && comboBox.ul) {
            comboBox.ul.attr("aria-ownedby", "f" + model.FieldId);
        }
        var dataSource = comboBox.dataSource.data();
        var index = -1;

        if (shouldUpdateFieldValue !== null) {
            self.SetFieldValue(input, shouldUpdateFieldValue);
        }

        if (model.DefaultValue !== null && model.DropDownList !== null) {
            index = model.DropDownList.indexOf(model.DefaultValue);
        }

        function valueExistsInDataSource(value) {
            return $.grep(dataSource, function (item) { return (item.value ? item.value : item.text) == value }).length == 0;
        }

        if (model.FieldValue !== null && model.FieldValue !== "") {
            if (valueExistsInDataSource(model.FieldValue)) {

                if (index == -1) {
                    if (model.ValidationDropdownItems) {
                        var selectedItem = null;
                        for (var i = 0; i < model.ValidationDropdownItems.length; i++) {
                            var item = model.ValidationDropdownItems[i];
                            if (getCurrentValue(item) == model.FieldValue) {
                                selectedItem = item;
                                break;
                            }
                        }
                        if (selectedItem) {
                            comboBox.dataSource.add({
                                text: selectedItem.Label,
                                value: getCurrentValue(selectedItem)
                            });
                        }
                        else {
                            comboBox.dataSource.add({
                                text: model.FieldValue,
                                value: model.FieldValue
                            });
                        }
                    }
                    else {
                        comboBox.dataSource.add({
                            text: model.FieldValue,
                            value: model.FieldValue
                        });
                    }
                    
                    comboBox.value(model.FieldValue);
                }
                else {
                    comboBox.value(comboBox.text());
                }
            }
        }

        if ((model.FieldValue !== null && model.FieldValue !== "") && (model.DefaultValue !== null && model.DropDownList !== null)) {
            if ($.grep(dataSource, function (item) { return (item.value ? item.value : item.text) == model.FieldValue }).length == 0) {

                comboBox.dataSource.add({
                    text: model.FieldValue,
                    value: model.FieldValue
                });
                comboBox.value(model.FieldValue);

            }
        }

        if (model.FieldName === "" && model.DefaultValue !== null && model.DefaultValue !== "") {
            if (
                $.grep(dataSource, function (item) { return item.text == model.DefaultValue }).length == 0
            ) {
                comboBox.dataSource.add({
                    text: model.DefaultValue,
                    value: model.DefaultValue
                });
            }
            comboBox.value(model.DefaultValue);
        }

        var errorMessage = "";

        if (self.EventId == 0) {
            self.DoFieldValueChanged(input);
            /*if (!!model.DefaultValue && model.DropDownList !== null) {
                model.FieldValue = model.DropDownValues[model.DropDownList.indexOf(model.DefaultValue)];
                if (!!model.FieldValue && model.DropDownList !== null) {
                    model.FieldValue = model.DropDownList[model.DropDownList.indexOf(model.DefaultValue)];
                }
                if (typeof (model.FieldValue) === "undefined") {
                    errorMessage = "The default value specified for " + model.FieldName + "(" + model.FieldId + ") is not an existing value within the " + model.FieldName + " combobox. Select an existing value as a default or change to accept other literal";
                }
            }*/
        }

        /*
        // this is no longer needed with the combobox changes (VRS-4617 and VRS-4711)
        if ((model.FieldValue !== null && model.FieldValue !== "")) {
            if (!!model.DropDownList && !!model.DropDownValues && errorMessage === "" && model.DropDownValues.includes(model.FieldValue)) {
                model.FieldValue = model.DropDownList[model.DropDownValues.indexOf(model.FieldValue)];
            }
        }
        */

        if (self.EventId == 0 && !model.FieldValue) {
            model.FieldValue = model.DefaultValue;
        }

        $(input).data("prevValue", model.FieldValue);

        comboBox.select(function (dataItem) {
            if (errorMessage !== "" && (model.FieldValue.toLowerCase() !== model.DefaultValue.toLowerCase())) {
                /*console.log(errorMessage);*/
                return;
            }
            if (model.FieldValue === null) {
                model.FieldValue = "";
            }

            return dataItem.value.toString().toLowerCase() === model.FieldValue.toString().toLowerCase();
        });

        if (!!model.FieldStatus) {
            self.SetStatus(comboBox.input, model, model.FieldStatus, null, null);
        }

        comboBox.input.on("keydown", function (e) {
            self.FieldKeyDown(e);
        });
        $(input).on("touchstart", function (e) {
            var model = null;
            model = $(e.target).data("field");
            nx.FocusField({ input: e.target, model: model }, true);
        });
        if (filter != "") {
            comboBox.input.attr("maxlength", model.MaxLength);
        }
        comboBox.input.on("keyup", self.FieldKeyUp);
        comboBox.input.attr("data-testid", "f" + model.FieldId);
        comboBox.input.on("focus", function (e) {
            var model = $(
                "#" +
                $(this)
                    .attr("name")
                    .replace("_input", "")
            ).data("field");
            if (model) {
                nx.Model = model;
                model.PreviousValue = this.value;
                // Only select if not already processing to prevent loops
                if (!$(this).data('selecting')) {
                    $(this).data('selecting', true);
                    try {
                        $(this).select();
                    } finally {
                        var $this = $(this);
                        setTimeout(function() {
                            $this.data('selecting', false);
                        }, 100);
                    }
                }
                //model.Validated = false;
                console.log("onfocus model.FieldName=" + model.FieldName);
            } else {
                nx.Model = null;
                /*console.log("onfocus nodata");*/
            }
            VR.Edit.LastFocusedField = model.FieldId;
        });

    }; //SetupComboBox

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the controls.
        /// <param name="fields">The list of fields.</param>
        /// </summary>
        /// <returns></returns>*/
    self.SetupControls = function (index) {
        if (
            index == null ||
            !self.Tabs ||
            self.Tabs.length == 0 ||
            index < -1 ||
            index > self.Tabs.length
        ) {
            return;
        }
        var fields = self.Tabs[index];
        if (!fields || fields.length < 1) {
            return;
        }
        var panelId = "tab-panel" + index.toString();
        var panel = $("#" + panelId);
        var init = $(panel).attr("data-init");
        if (init != "0") {
            return;
        }

        $.each(fields, function (index, model) {
            switch (model.FieldType) {
                case "AutoComplete":
                    self.SetupAutoComplete(model);
                    break;
                case "Button":
                    self.SetupButton(model);
                    break;
                case "CheckBox":
                    self.SetupCheckBox(model);
                    break;
                case "ComboBox":
                    self.SetupComboBox(model);
                    break;
                case "DatePicker":
                    self.SetupDatePicker(model);
                    break;
                case "DateTimePicker":
                    self.SetupDateTimePicker(model);
                    break;
                case "DropDownList":
                    self.SetupComboBox(model);
                    break;
                case "Grid":
                    self.SetupGrid(model);
                    break;
                case "Hidden":
                    break;
                case "Image":
                    self.SetupImage(model);
                    break;
                case "Label": self.SetupLabel(model); break;
                case "MaskedTextBox":
                    self.SetupMaskedEdit(model);
                    break;
                case "MemoEdit":
                    self.SetupMemoBox(model);
                    break;
                case "MonthPicker":
                    self.SetupDatePicker(model);
                    break;
                case "MultiSelect":
                    self.SetupMultiSelect(model);
                    break;
                case "NumericTextBox":
                    self.SetupNumericTextBox(model);
                    break;
                case "RadioButton":
                    self.SetupRadioButton(model);
                    break;
                case "Signature":
                    self.SetupSignatureButton(model);
                    break;
                case "TextBox":
                    self.SetupTextBox(model);
                    break;
                case "TimePicker":
                    self.SetupTimePicker(model);
                    break;
            }

            self.CreateFieldValidator(model);
        });

        //self.InitFields(index);

        $(panel).attr("data-init", "1");
    }; //SetupControls

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
        /// <summary>
        /// Sets up DatePicker.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupDatePicker = function (model) {
        var format = model.InputFormat;
        var input = $("#f" + model.FieldId);

        // Prevent duplicate initialization
        if (input.data("kendoDatePicker")) return;

        input.attr("autocomplete", "off");

        if (model.FieldType === "DatePicker") {
            if (!format) format = "MM/dd/yyyy";

            if (model.FieldValue &&
                model.FieldValue.indexOf("99") < 0 &&
                model.FieldValue.indexOf("88") < 0) {
                model.FieldValue = moment(model.FieldValue, "MM/DD/YYYY").format(format.toUpperCase());
                input.val(model.FieldValue);
            }

            var past = false;
            for (var i = 0; i < model.Edits.length; i++) {
                if (model.Edits[i].SpecialEdit &&
                    model.Edits[i].SpecialEdit.toUpperCase() === "PAST") {
                    past = true;
                    break;
                }
            }

            input.kendoDatePicker({
                max: past ? new Date() : undefined,
                format: format,
                //change: function (e) {
                //    self.DoFieldValueChanged(input);
                //},
                close: function (e) {
                    self.ResetField("#f" + model.FieldId);
                }
            });

            if (!model.CanEdit) {
                var datePicker = input.data("kendoDatePicker");
                if (datePicker) {
                    datePicker.readonly(true);
                    input.attr("data-original-value", model.FieldValue);
                }
            }

            var selectbutton = input.parent().find("button[aria-label='select']");
            selectbutton.attr({
                "aria-label": model.FieldLabel + " Select",
                "data-testid": "f" + model.FieldId + "_Select"
            });

            if (!$(input).data("kendoMaskedTextBox") && !$(input).data("masked-setup-complete")) {
                $(input).data("masked-setup-complete", true);
                $(input).kendoMaskedTextBox({
                    mask: "00/00/0000"
                });
            }
        } else {
            if (!format) format = "MMMM yyyy";

            if (model.FieldValue) {
                model.FieldValue = moment(model.FieldValue).format(format.toUpperCase());
                input.val(model.FieldValue);
            }

            input.kendoDatePicker({
                start: "year",
                depth: "year",
                format: format,
                //change: function (e) {
                //    self.DoFieldValueChanged(input);
                //},
                close: function (e) {
                    self.ResetField("#f" + model.FieldId);
                }
            });

            if (!model.CanEdit) {
                var datePicker = input.data("kendoDatePicker");
                if (datePicker) {
                    datePicker.readonly(true);
                    input.attr("data-original-value", model.FieldValue);
                }
            }

            var selectspan = input.parent().find("span.k-input-button");
            selectspan.attr("aria-label", model.FieldLabel + " Select");
        }

        input.on("keydown", function (e) {
            if (e.which === 9) {
                self.FieldKeyDown(e);
            }
        });

        input.on("keypress", function (e) {
            var datePicker = $(this).data("kendoDatePicker");
            var model = $(this).data("field");

            if (!model || model.FieldType !== "DatePicker") return;

            switch (e.which) {
                case 84:
                case 116: // T
                    e.preventDefault();
                    var date = new Date();
                    date.setHours(0, 0, 0, 0);
                    datePicker.value(date);
                    var maskedTB = $(this).data("kendoMaskedTextBox");
                    if (maskedTB) maskedTB.value($(this).val());
                    this.setSelectionRange(0, 0);
                    //self.DoFieldValueChanged(input);
                    break;

                case 66:
                case 70:
                case 98:
                case 102: // B, F
                    e.preventDefault();
                    var dateString = datePicker.value();
                    if (!dateString) dateString = new Date();

                    var value = new Date(dateString);
                    if (!isNaN(value)) {
                        var add = (e.which === 66 || e.which === 98) ? -1 : 1;
                        var newDate = new Date(value);
                        newDate.setDate(value.getDate() + add);
                        datePicker.value(newDate);
                        var maskedBF = $(this).data("kendoMaskedTextBox");
                        if (maskedBF) maskedBF.value($(this).val());
                        this.setSelectionRange(0, 0);
                        //self.DoFieldValueChanged(input);
                    }
                    break;
                case 85:
                case 117: // U
                    e.preventDefault();
                    $(this).val("99/99/9999");
                    break;

                case 88:
                case 120: // X
                    e.preventDefault();
                    $(this).val("88/88/8888");
            }
        });

        input.on("focus", function (e) {
            self.LastFocusedField = model.FieldId;
        });
    }; //SetupDatePicker

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up DateTimePicker.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupDateTimePicker = function (model) {
        var input = $("#f" + model.FieldId);
        input.attr("autocomplete", "off");
        //var date = new Date(model.FieldValue);
        $(input).kendoDateTimePicker({
            //change: function (e) {
            //    self.DoFieldValueChanged(input);
            //},
            //max: new Date(model.InputMax),
            //min: new Date(model.InputMin),
            value: model.FieldValue ? new Date(model.FieldValue) : ""
        });
        var selectspan = $(input).parent().find("span.k-input-button");
        $(selectspan).attr("aria-label", model.FieldLabel + " Select");
        $(input).data("kendoDateTimePicker").readonly(!model.CanEdit);

        $(input).on("keydown", function (e) {
            if ($(this).hasClass("readonly-text")) {
                if (e.which != 9) {
                    e.preventDefault();
                    return;
                }
            }
            self.FieldKeyDown(e);
        });

        $(input).on("keypress", function (e) {
            var datePicker = $(this).data("kendoDateTimePicker");
            switch (e.which) {
                case 84:
                case 116:
                    e.preventDefault();
                    var date = new Date();
                    date.setHours(0, 0, 0, 0);
                    datePicker.value(date);
                    this.setSelectionRange(0, 0);
                    self.DoFieldValueChanged(input);
                    break;
                case 66:
                case 70:
                case 98:
                case 102:
                    e.preventDefault();
                    var value = new Date(datePicker.value());
                    if (!isNaN(value)) {
                        var add = 1;
                        if (e.which == 66 || e.which == 98) {
                            add = -1;
                        }
                        var newDate = new Date(value);
                        newDate.setDate(value.getDate() + add);
                        datePicker.value(newDate);
                        this.setSelectionRange(0, 0);
                        self.DoFieldValueChanged(input);
                    }
                    break;
                case 85:
                case 117:
                    e.preventDefault();
                    $(this).val("99/99/9999");
                    break;
                case 78:
                case 110:
                    e.preventDefault();
                    $(this).val("88/88/8888");
            }
        });

        $(input).on("keyup", self.FieldKeyUp);

        $(input).on("focus", function (e) {
            // Only select if not already processing to prevent loops
            if (!$(this).data('selecting')) {
                $(this).data('selecting', true);
                try {
                    $(this).select();
                } finally {
                    var $this = $(this);
                    setTimeout(function() {
                        $this.data('selecting', false);
                    }, 100);
                }
            }
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });
    }; //SetupDateTimePicker

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
    /// <summary>
    /// Sets up document tracking.
    /// </summary>
    /// <returns></returns>*/
    self.SetupDocTracking = function () {
        $("#docktrack-menu").on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
            var event = self.EventName;
            var eventId = self.EventId;
            var selection = "doctrack-" + eventId + "|event=" + event;
            selection = "search=" + encodeURIComponent(selection);
            var url =
                VR.Common.GetRootURL("event/edit") +
                "event/search?selection=" +
                encodeURIComponent(selection);
            nxLoading.start("Loading page. Please wait...");
            if (VR.Common.CanOpen) {
                window.open(url);
                nxLoading.end();
            } else {
                window.location.href = url;
            }
        });
    }; //SetupDocTracking
    self.TakeActionOnField = function (key, message, location, field, model) {
        if (key === "rekeyed") {
            VR.Script.FocusField({ input: field, model: model }, true);
            self.RemoveErrorField(model);
            model.FieldStatus = null;
        } else {
            if (key === "queried" || key === "overridden") {
                self.RemoveErrorField(model);
            }
            self.SetStatus(field, model, key, message, location);
        }
    }; //TakeActionOnField

    function capitalizeFirstLetters(str) {
        return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
            return letter.toUpperCase();
        });
    }

    self.BindDropDown = function (data, model, input) {
        var clonedData = data.slice(0);

        var groupdiv = $("#g" + model.FieldId + ">div>div");
        $("#f" + model.FieldId).kendoDropDownList({
            dataTextField: "text",
            dataValueField: "value",
            dataSource: clonedData,
            open: function (e) {
                if (input.attr("readonly")) {
                    e.preventDefault();
                }
            }
        });
        var readonly = input.attr("readonly");
        var parent = $(input).parents(".k-dropdownlist");
        $(parent).on("keydown", function (e) {
            self.FieldKeyDown(e);
        });
        $(parent).on("keypress", function (e) {
            var input = $("#f" + model.FieldId);
            if ($(input).hasClass("readonly-text")) {
                return;
            }
            if (e.key == " ") {
                if (!readonly) {
                    var dropdownlist = $(input).data("kendoDropDownList");
                    if (dropdownlist) {
                        dropdownlist.open();
                        $(input).select();
                    }
                }
            }
        });
        if (readonly) {
            input.data("field", model);
            self.SetReadOnly(input, true);
        }
    }; //BindDropDown

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
    /// <summary>
    /// Sets up event activation.
    /// </summary>
    /// <returns></returns>*/
    self.SetupEventActivation = function () {
        $(function () {
            $("#deleterecs-menu").on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
                VR.Edit.changeRecordActiveStatus(e, true);
            });
            $("#activaterec-menu").on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
                VR.Edit.changeRecordActiveStatus(e, false);
            });
        });
    }; //SetupEventActivation

    self.changeRecordActiveStatus = function(e, deleteRecord) {
        var isactive = self.GetIsActive();
        var event = self.EventName;
        var eventId = self.EventId;
        var recordAction;
        if (isactive == 'T') {
            recordAction = (deleteRecord ? 'delete' : 'inactivate');
        } else {
            recordAction = (deleteRecord ? 'delete' : 'activate')
        }
        if (!eventId || eventId == 0) {
            VR.Common.ShowError("The new record cannot be activated/inactivated.");
            return;
        }
        if (deleteRecord) {
            isactive = "";
        }
        let params = { deleteRecord, isactive, event, eventId, recordAction };
        VR.Common.ShowDeleteRecordMessageBox("Are you sure you want to " + recordAction + " this record?", null, ["yes", "no"], params, deleteEventRecord, "Record Confirmation");
        
    }

    function deleteEventRecord(params) {
        nxLoading.start("Posting. Please wait...");
        VR.Common.SecurePost(
            "event/activate",
            {
                request: {
                    name: params.event,
                    id: params.eventId,
                    active: params.isactive,
                    hide: params.deleteRecord ? "T" : "F"
                }
            },
            function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Activate/Inactivate", true);
                } else {
                    params.isactive = params.isactive == "T" || params.deleteRecord ? "F" : "T";
                    var inputs = self.GetInputFields("ISACTIVE");
                    $.each(inputs, function (index, input) {
                        self.SetFieldValue(input, params.isactive);
                        var model = $(input).data("field");
                        if (model) {
                            model.HasChange = false;
                            model.OriginalValue = params.isactive;
                        }
                    });

                    self.Isactive = params.isactive;
                    if (params.isactive == "T") {
                        $("#hidden-record").css("display", "none");
                        VR.Common.ShowInfo("The record was " + params.recordAction + "d.");
                    } else {
                        $("#hidden-record").css("display", "");
                        VR.Common.ShowInfo("The record was " + params.recordAction + "d.");
                    }
                }
            }
        ).always(function () {
            nxLoading.end();
        });
    }
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
    /// <summary>
    /// Sets up fields.
    /// </summary>
    /// <param name="result">The result from the web service.</param>
    /// <returns></returns>*/
    self.SetupFields = function (result) {
        self.Tabs = [];
        if (result.Tabs && result.Tabs.length > 0) {
            var firstTab = 0;
            var lastTab = result.Tabs.length - 1;
            var first = null;
            var last = null;
            var formOrder = 0; // VRS-6693: monotonic form-order index (tab->section->field)
            $.each(result.Tabs, function (index, tab) {
                var fields = [];
                if (tab.Sections) {
                    $.each(tab.Sections, function (index, section) {
                        $.each(section.Fields, function (index, model) {
                            model.Tab = tab.Name;
                            model.Section = section.Name;
                            model.FormOrder = formOrder++; // VRS-6693: stable Validation Panel ordering

                            if (model.isRetained && editPageData.CRUDType == "Create") {
                                let tempStickyVal = getStickyValue(model.FieldId);
                                if (tempStickyVal === "") {
                                    setStickyValue(model.FieldId, model.FieldValue);
                                }
                                else {
                                    model.FieldValue = tempStickyVal;
                                }
                            }

                            model.FieldValue = VR.Common.ToFormattedValue(model.FieldValue);
                            model.OriginalValue = VR.Common.ToFormattedValue(
                                model.OriginalValue
                            );
                            if (!!model.FieldValue && model.FieldValue == model.OriginalValue) {
                                model.PreviousValue = model.OriginalValue;
                            } else {
                                model.PreviousValue = "";
                            }
                            model.HasChange = false;
                            model.HasChangeOvrd = null;
                            if (model.FieldValue && self.EventId == 0) {
                                model.HasChange = true;
                            }
                            fields.push(model);
                            self.Fields.push(model);
                            $("#f" + model.FieldId).data("field", model);
                            if (!first) {
                                first = model;
                            }
                            if (last) {
                                last.Next = model;
                                model.Prev = last;
                            }
                            last = model;
                        });
                    });

                    self.Tabs.push(fields);
                }
            });

            if (first) {
                first.Prev = last;
                last.Next = null;
            }

            $("#bottom-menu")
                .find("a")
                .on("click", function (e) {
                    var id = $(e.target).attr("data-target");
                    $("#tabs")
                        .find("a[aria-controls=" + id + "]")
                        .trigger("click");
                    $("#bottom-button").trigger("click");
                });

            if (self.Tabs.length > 0) {
                self.SetupControls(0);
                $("#tab-content").css("display", "");

                if (VR.Common.IsMobile()) {
                    $("#tab-content").css({
                        "overflow-y": "scroll",
                        "-webkit-overflow-scrolling": "touch",
                        "max-height": "65vh"
                    });
                }
            }

            $(".tab").on("click", function (e) {
                var prevTabList = $("#tabs").find("a[aria-expanded=true]");
                if (prevTabList.length > 0) {
                    $(prevTabList[0]).attr("tabindex", "-1");
                }
                var id = $(this).attr("data-index");
                $(this).attr("tabindex", "0");
                id = parseInt(id, 10);
                self.SetupControls(id);
                $("#tab-content").scrollTop(0);
            });
            $(".tab").on("keydown", function (e) {
                var id = $(this).attr("data-index");
                var indexTab = parseInt(id, 10);
                var currentIndexTab = indexTab;
                var flag = false;

                switch (e.key) {
                    case 'ArrowLeft':
                        if (currentIndexTab === firstTab) {
                            indexTab = lastTab;
                        } else {
                            indexTab = indexTab - 1;
                        }
                        flag = true;
                        break;
                    case 'ArrowRight':
                        if (currentIndexTab === lastTab) {
                            indexTab = firstTab;
                        } else {
                            indexTab = indexTab + 1;
                        }
                        flag = true;
                        break;
                    case 'Home':
                        if (currentIndexTab !== firstTab) {
                            indexTab = firstTab;
                            flag = true;
                        }
                        break;
                    case 'End':
                        if (currentIndexTab !== lastTab) {
                            indexTab = lastTab;;
                            flag = true;
                        }
                        break;
                    default:
                        break;
                }

                if (flag) {
                    id = "tab-panel" + indexTab;
                    var tabList = $("#tabs").find("a[aria-controls=" + id + "]:not([aria-expanded=true])");
                    if (tabList.length > 0) {
                        e.stopPropagation();
                        e.preventDefault();
                        $(tabList[0]).trigger("click");
                        tabList.focus();
                    }
                }
            });
        }

        var isactive = self.GetIsActive();
        if (!isactive || isactive.toUpperCase() == "T") {
            $("#hidden-record").css("display", "none");
        } else {
            $("#hidden-record").css("display", "");
        }
    }; //SetupFields

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up loading of files.
        /// </summary>
        /// <returns></returns>*/
    self.SetupFileLoad = function () {
        $("#loadfile-menu").on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
            if (!self.EventId || self.EventId == 0) {
                VR.Common.ShowError("Please save this record first.");
                return;
            }

            $("#imagefile-title").html("Load File");
            $("#image-file-group").attr("data-file-type", "1");
            $("#imagefile-button").attr("accept", "*");
            $("#imagename-text").val("");
            $("#image-file").val("");
            $("#image-data").prop("data-src", "");
            $("#image-file-error").html("");
            $("#imageedit-isactive").attr("checked", true);
            $("#imagefile-modal").modal("show");
        });

        $("#loadimage-menu").on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
            if (!self.EventId || self.EventId == 0) {
                VR.Common.ShowError("Please save this record first.");
                return;
            }

            $("#imagefile-title").html("Load Image");
            $("#image-file-group").attr("data-file-type", "0");
            $("#imagefile-button").attr("accept", "image/*");
            $("#imagename-text").val("");
            $("#image-file").val("");
            $("#image-data").prop("data-src", "");
            $("#image-file-error").html("");
            $("#imageedit-isactive").attr("checked", true);
            $("#imagefile-modal").modal("show");
        });

        self.SetupLoadFile();
    }; //SetupFileLoad

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up Grid.
        /// </summary>
        /// <param name="model">The result from the web service.</param>
        /// <returns></returns>*/
    self.SetupGrid = function (model) {
        var field = model;
        var section = $("#p" + model.FieldId);
        var grid = $(section).data("kendoGrid");
        if (grid) {
            return;
        }

        var input = $("#f" + model.FieldId);
        input.removeData("field");

        $(section).html("");
        $(section).addClass("input-field");

        var eventId = self.EventId;
        var url = VR.Common.GetRootURL("event/edit") + "data/grid";
        var selection = "eventId=" + eventId + "|fieldId=" + model.FieldId;
        VR.Common.SecurePost(
            url,
            selection,
            function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Grid", true);
                    return;
                }

                var columns = [];
                if (result.Columns) {
                    for (var i = 0; i < result.Columns.length; i++) {
                        var model = result.Columns[i];
                        columns[i] = {
                            field: model.FieldName,
                            format: model.Format,
                            title: model.Title,
                            width: model.Width
                        };
                    }
                }

                var dataSource = result.Result;
                if (!dataSource) {
                    dataSource = [];
                }

                $.each(dataSource, function (index, row) {
                    if (result && result.Columns) {
                        for (var i = 0; i < result.Columns.length; i++) {
                            var column = result.Columns[i];
                            row[column.FieldName] = VR.Common.ToDate(row[column.FieldName]);
                            if (column.Type === "string" && typeof row[column.FieldName] === "string" && row[column.FieldName].toLowerCase() === "null") {
                                row[column.FieldName] = row[column.FieldName] + " ";
                            }
                        }
                    }
                });

                var dataFields = {};
                if (result && result.Columns) {
                    for (var i = 0; i < result.Columns.length; i++) {
                        var column = result.Columns[i];
                        dataFields[column.FieldName] = { type: column.Type };
                    }
                }

                var dataModel = {
                    fields: dataFields
                };

                $(section).kendoGrid({
                    change: self.RowChanged,
                    dataSource: {
                        data: dataSource,
                        schema: {
                            model: dataModel
                        }
                    },
                    columns: columns,
                    height: 300,
                    mobile: false, //by setting the mobile option to false the grids will render properly on mobile devices today.
                    sortable: true,
                    reorderable: true,
                    scrollable: {
                        virtual: false
                    },
                    resizable: true,
                    toolbar: ["search"],
                    search: {
                        fields: Object.keys(dataFields)
                    },
                    pageable: { pageSize: 10000 },
                    selectable: "row",
                    navigatable: true,
                    dataBound: function(e) {
                        var grid = e.sender;
                        
                        // Add CSS class for scrollbar styling
                        grid.element.addClass('edit-page-grid');
                        
                        // Remove Kendo's calculated height on grid-content to allow natural scrolling
                        grid.element.find('.k-grid-content').css('height', 'auto');
                        
                        // Add data-testid to table
                        grid.table.attr('data-testid', 'table_' + field.FieldId);
                        
                        // Add data-testid to rows and cells
                        grid.tbody.find('tr').each(function(rowIndex) {
                            var $row = $(this);
                            $row.attr('data-testid', 'row_' + field.FieldId + '_' + rowIndex);
                            
                            $row.find('td.k-table-td[role="gridcell"]').each(function(cellIndex) {
                                var $cell = $(this);
                                var columnIndex = $cell.index();
                                
                                // Add data-field attribute
                                if (grid.columns[columnIndex] && grid.columns[columnIndex].field) {
                                    $cell.attr('data-field', grid.columns[columnIndex].field);
                                }
                                
                                // Add data-testid attribute
                                $cell.attr('data-testid', 'cell_' + field.FieldId + '_' + rowIndex + '_' + cellIndex);
                            });
                        });
                        
                        // Add direct click handler for rows to handle re-clicking selected row
                        grid.tbody.on("click", "tr", function () {
                            var clickedRow = $(this);
                            var currentlySelected = grid.select();

                            // If clicking the already-selected row, manually trigger RowChanged
                            if (currentlySelected.length > 0 && clickedRow[0] === currentlySelected[0]) {
                                self.RowChanged.call(grid, { sender: grid });
                            }
                        });
                    }
                });
                // Removed fixed height on k-grid-content to allow scrollbars to appear
                $(section).css("width", "90%");
                $(section).css("height", "300px");
                $("#g" + field.FieldId).css("padding-left", "17px");
                $("#l" + field.FieldId).css("padding-left", "0");
                if (field.IsEditable || field.IsDisplayOnly) {
                    var bottom = $("#f" + field.FieldId + "-msg");
                    bottom.removeClass("invalid-msg");
                    var fieldid = VR.Common.HtmlEscape(field.FieldId);
                    var html = "<br> ";
                    if (columns.length > 0) {
                        html +=
                            "<button id='d" +
                            fieldid +
                            "' class='btn btn-primary grid-button'>Display</button>";
                    }

                    if (result.CanAdd && field.IsEditable && !field.IsDisplayOnly) {
                        html +=
                            "<button id='a" +
                            fieldid +
                            "'class='btn btn-success grid-button' >Add New</button>";
                    }
                    if (result.ShowDocumentButton) {
                        html += "<button id='o" + fieldid + "' class='btn btn-primary grid-button'>Documents</button>";
                    }
                    bottom.html(html);
                    bottom.css("display", "");
                    var buttons = bottom.find(".grid-button");
                    buttons.on("click", function (e) {
                        var id = $(this).attr("id");
                        var header = "";
                        if (id && id.length > 1) {
                            header = id.substring(0, 1);
                            id = id.substring(1);
                        }

                        if (header == "a") {
                            if (self.EventId == 0) {
                                VR.Common.ShowError("Please save this event record first.");
                                return;
                            }
                            self.CanLeavePage(self.AddNewRecord, this);
                        }
                        else if (header == "d") {
                            var gridfield = $("#p" + id);
                            var grid = gridfield.data("kendoGrid");
                            var row = grid.select();
                            if (row) {
                                self.CanLeavePage(self.DisplayGridEvent, {
                                    grid: grid,
                                    selected: row
                                });
                            }
                        }
                        else if (header == "o") {
                            var gridfield = $("#p" + id);
                            var grid = gridfield.data("kendoGrid");
                            var row = grid.select();
                            if (row) {
                                let item = grid.dataItem(row);
                                if (item == null) {
                                    return;
                                }
                                let eventId = item[result.Key];
                                if (eventId) {
                                    let docSelection = "name=" + result.EventName + "|id=" + eventId.toString() + "|year=" + VR.Edit.GetEventYear();
                                    nxLoading.start("Loading documents. Please wait...");
                                    VR.Common.SecurePost("report/documents", docSelection, function (resultDocs) {
                                        nxLoading.end();
                                        $("#griddocs-modal").modal("show");
                                        if (resultDocs.Code === 0 && Array.isArray(resultDocs.Documents)) {
                                            let tableHtml = "";
                                            for (let i = 0; i < resultDocs.Documents.length; i++) {
                                                tableHtml += "<tr><td>" + resultDocs.Documents[i].Name + "</td><td>" + (resultDocs.Documents[i].IsFax == true ? "Yes" : "No") +
                                                    "</td><td><button id='gdb-" + resultDocs.Documents[i].Id.toString() +
                                                    "' class='btn btn-primary griddocs-table-btn'>Print Document</button></td></tr>";
                                            }
                                            var gridDocBody = $("#griddocs-table-body");
                                            if (tableHtml.length == 0) {
                                                tableHtml = "<p>No documents</p>";
                                            }
                                            gridDocBody.html(tableHtml);
                                            gridDocBody.find(".griddocs-table-btn").on("click", function (e) {
                                                let id = $(this).attr("id");
                                                id = id.substring(4);
                                                let windowValue = $("#footer-data").attr("data-window");
                                                let canPrintSelection = "name=" + result.EventName + "|id=" + id + "|eventid=" + eventId + "|year=|number=|window=" + windowValue +
                                                    "|cas=" + VR.Edit.IsCasEvent.toString();
                                                VR.Doc.SendPrintDocumentRequest(canPrintSelection);
                                            });
                                        }
                                    });
                                }
                            }
                        }
                    });

                    buttons.on("keydown", self.FieldKeyDown);
                }

                var grid = $(section).data("kendoGrid");

                //6004
                $(section).on("keydown", function (e) {
                    if (e.key === "Enter") {
                        e.preventDefault(); // Prevent default form submission
                        var row = grid.select();
                        self.CanLeavePage(self.DisplayGridEvent, {
                            grid: grid,
                            selected: row
                        });
                    }
                });
                // VRS-6691 Remove Delay TWB 08/21/2026 run synchronous
                var located = false;
                if (result.KeyValue) {
                    located = VR.Script.SelectRow(
                        field.FieldId,
                        result.Key,
                        result.KeyValue
                    );
                }

                if (!located) {
                    var row = grid.tbody.find("tr:eq(0)");
                    grid.select(row);
                }

                grid.GridKey = result.Key;
                grid.GridEvent = result.EventName;
                grid.FieldId = field.FieldId;
                grid.IsEditable = field.IsEditable;
                grid.IsDisplayOnly = field.IsDisplayOnly;
                grid.IsKeyCached = result.IsKeyCached;

                var table = $(section).find("table");
                if (table && table.length > 0) {
                    table = table[0];
                }
                $(table).attr("id", "f" + field.FieldId);
                $(table).attr("data-field-name", field.FieldName);
                $(table).addClass("input-field");
                $(table).data("field", field);
                $(table).data("grid", result);
                $(table).on("keydown", self.FieldKeyDown);
            },
            false,  // VRS-6691 TWB 08/21/2026 run synchronous
            undefined,
            false,
            false
        );
        if (!self.GridDocsRefreshCreated) {
            $("#griddocs-close-refresh").on("click", function () {
                location.reload();
            });
            self.GridDocsRefreshCreated = true;
        }
    }; //SetupGrid

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up image.
        /// </summary>
        /// <param name="model">The result from the web service.</param>
        /// <returns></returns>*/
    self.SetupImage = function (model) {
        var field = $("#f" + model.FieldId);
        field.data("field", model);
        var button = $("#b" + model.FieldId);
        button.on("change", function () {
            var val = $(this).val();
            var inputFiles = this.files;
            if (inputFiles == undefined || inputFiles.length == 0) {
                return;
            }

            var inputFile = inputFiles[0];

            var reader = new FileReader();
            reader.onload = function (event) {
                if (!event || !event.target || !event.target.result) {
                    VR.Common.ShowError(
                        "Could not load file. This is possibly the file is too large.",
                        "Error"
                    );
                } else if (event.target.result.length > self.MaxImageUpload) {
                    VR.Common.ShowError("The image exceeds the limit (" + editPageData.MaxImageUpload +"MB)", "Error");
                    return;
                }
                field.prop("src", event.target.result);
                field.attr("field-changed", "1");
                var model = field.data("field");
                if (model) {
                    model.HasChange = (model.HasChangeOvrd == null) ? false : model.HasChangeOvrd;
                }
            };
            reader.onerror = function (event) {
                VR.Common.ShowError(
                    "Could not load file. This is possibly the file is too large.",
                    "Error"
                );
                field.prop("src", null);
                field.prop("alt", "Load error");
                var model = field.data("field");
                if (model) {
                    model.HasChange = (model.HasChangeOvrd == null) ? false : model.HasChangeOvrd;
                }
            };
            reader.readAsDataURL(inputFile);
        });

        var parent = field.parents(".edit-field");

        parent.find(".btn-danger").on("click", function (e) {
            field.prop("src", "");
            field.attr("field-changed", "1");
            var model = field.data("field");
            if (model) {
                model.HasChange = (model.HasChangeOvrd == null) ? false : model.HasChangeOvrd;
            }
        });

        $(parent).css("height", "auto");
        var buttons = $(parent).find(".btn");
        buttons.on("keydown", self.FieldKeyDown);
    }; //SetupImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the the image editors.
        /// </summary>
        /// <returns></returns>*/
    self.SetupImageEdit = function () {
        var modal = $("#imageeditor-modal");

        modal.on("show.bs.modal", function (e) {
            var editor = $("#imageedit-editor");
            editor.attr("data-scaleX", "");
            editor.attr("data-scaleY", "");
            $("#imageedit-annotetoggle, #imageedit-editannot").css("display", "");
        });

        modal.on("shown.bs.modal", function (e) {
            $(document).off("focusin.modal"); //Fix for KendoDropDownList closes immediately when the dopdown is opened. http://stackoverflow.com/questions/14795035/twitter-bootstrap-modal-blocks-text-input-field
            var fileload = $(this).attr("data-fileload");
            if (!fileload) {
                var annotation = $(this).attr("data-annotation");
                var width = $(this).attr("data-annotewidth");
                var height = $(this).attr("data-annoteheight");
                VR.Image.Annotation.InitEditorImage(
                    $("#imageedit-editsection"),
                    $("#imageedit-annotationsection"),
                    { annote: annotation, width: width, height: height }
                );
            }
            $("#imageedit-dragbutton").trigger("click");
        });

        self.SetupImageEditButtons();
        self.SetupImageEditAccept();
        self.SetupImageSaveButtons();

        modal = $("#tiffeditor-modal");

        modal.on("show.bs.modal", function (e) { });

        modal.on("shown.bs.modal", function (e) {
            $(document).off("focusin.modal"); //Fix for KendoDropDownList closes immediately when the dopdown is opened. http://stackoverflow.com/questions/14795035/twitter-bootstrap-modal-blocks-text-input-field
            $("#tiffeditor-dragbutton").trigger("click");
            var annotation = $(this).attr("data-annotation");
            var width = $(this).attr("data-annotewidth");
            var height = $(this).attr("data-annoteheight");
            VR.Image.Annotation.InitTiffEditorImage(
                $("#tiffeditor-editsection"),
                $("#tiffeditor-annotationsection"),
                { annote: annotation, width: width, height: height }
            );
        });

        self.SetupTiffEditorButtons();
        self.SetupTiffEditAccept();
        self.SetupTiffSaveButtons();
    }; // SetupImageEdit

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the accept button for the image editor.
        /// </summary>
        /// <returns></returns>*/
    self.SetupImageEditAccept = function () {
        $("#imageedit-acceptbutton").on("click", function () {
            var imagedit = $("#imageedit-editor");
            var id = imagedit.attr("data-editor");
            var editor = $("#" + id);
            var image = editor.find(".edit-image");
            var section = $("#imageedit-canvassection");
            var data = null;
            var display = section.css("display");
            if (display != "none") {
                var canvas = section.children("img");
                if (canvas.length > 0) {
                    data = canvas.attr("src");
                } else {
                    data = "";
                }
            }

            if (data == null) {
                data = $("#image-data").prop("data-src");
            }

            image.attr("src", data);
            var changed = editor.attr("data-changed");
            if (!changed) {
                changed = "";
            }

            if (changed.indexOf("image") == -1) {
                changed += "|image";
            }

            id = id.replace("editor", "canvas");
            if (display != "none") {
                VR.Image.Annotation.RecreateAnnote(image, "imageedit-canvasannote", id);
            } else {
                VR.Image.Annotation.CopyObjects("imageedit-annotationsection", id);
            }
            var parent = $("#" + id).parent();
            var canvas = parent.data("canvas");
            var json = canvas.toJSON([
                "order",
                "originalText",
                "originalWidth",
                "originalHeight"
            ]);
            json = JSON.stringify(json);
            var width = canvas.getWidth();
            var height = canvas.getHeight();
            editor.attr("annotation", json);
            editor.attr("annote-width", width);
            editor.attr("annote-height", height);

            if (changed.indexOf("annote") == -1) {
                changed += "|annote";
            }

            editor.attr("data-changed", changed);
            $("#imageeditor-modal").modal("hide");
        });
    }; //SetupImagEditAccept

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up buttons for image editor.
        /// </summary>
        /// <returns></returns>*/
    self.SetupImageEditButtons = function () {
        $("#imageedit-buttons")
            .find(".btn-imageedit")
            .tooltip({
                container: "body",
                trigger: "hover"
            });

        $("#imageedit-dragbutton").on("click", function (e) {
            var section = $("#imageedit-editsection");
            var item = section.find(".cropper-modal");
            item.css("opacity", "0");
            item = section.find(".cropper-crop-box");
            item.css("display", "none");
            $("#imageedit-editor").cropper("setDragMode", "move");
            $("#imageedit-dragbutton").addClass("active");
            $("#imageedit-cropbutton").removeClass("active");
        });

        $("#imageedit-cropbutton").on("click", function (e) {
            var section = $("#imageedit-editsection");
            var item = section.find(".cropper-modal");
            item.css("opacity", "0.5");
            item = section.find(".cropper-crop-box");
            item.css("display", "");
            $("#imageedit-editor").cropper("setDragMode", "crop");
            $("#imageedit-dragbutton").removeClass("active");
            $("#imageedit-cropbutton").addClass("active");
            VR.Image.Annotation.HideAnnotation();
        });

        $("#imageedit-getimagebutton").on("click", function (e) {
            var section = $("#imageedit-editsection");
            var item = section.find(".cropper-crop-box");
            var display = item.css("display");
            if (display == "none") {
                return;
            }

            section.css("display", "none");
            //var editor = $("#imageedit-editor");
            //var width;
            //var height;
            //if ($(window).width() >= 768) {
            //    var imageData = editor.cropper('getImageData');
            //    width = Math.round(imageData.naturalWidth) + "px";
            //    height = Math.round(imageData.naturalHeight) + "px";
            //} else {
            //    var modal = $("#imageeditor-modal");
            //    var size = self.SetImageEditorSize(modal);
            //    width = size.width + "px";
            //    height = size.height + "px";
            //}
            //var canvas = editor.cropper("getCroppedCanvas");
            //$(canvas).css("max-height", height);
            //$(canvas).css("max-width", width);
            var editor = $("#imageedit-editor");
            var annote = $("#imageedit-annotation");
            var cropped = $("#imageedit-canvassection");
            var cropannote = $("#imageedit-canvasannote");
            var cropbox = $(".cropper-crop-box")
            VR.Image.CreateCroppedImage(section, editor, annote, cropped, cropannote, cropbox);
            //section.html(canvas);
            cropped.css("display", "");
            cropannote.css("display", "");
            $("#imageedit-buttons")
                .find(".btn-cropbutton")
                .css("visibility", "hidden");
            $("#imageedit-slidebars").css("visibility", "hidden");
            //$("#imageedit-annotetoggle, #imageedit-editannot, #imageedit-slidebars").css("display", "none");
        });

        $("#imageedit-resetbutton").on("click", function (e) {
            var editor = $("#imageedit-editor");
            editor.cropper("reset");
            editor.attr("data-scaleX", "");
            editor.attr("data-scaleY", "");
            $("#imageedit-canvassection, #imageedit-canvasannote").css(
                "display",
                "none"
            );
            $("#imageedit-editsection, #imageedit-annotationsection").css(
                "display",
                ""
            );
            $("#imageedit-buttons")
                .find(".btn-cropbutton")
                .css("visibility", "visible");
            $("#imageedit-slidebars").css("visibility", "visible");
            $("#imageedit-dragbutton").trigger("click");
            VR.Image.SlideBars.Reset();
            $(
                "#imageedit-annotetoggle, #imageedit-editannot, #imageedit-slidebars"
            ).css("display", "");
        });

        $("#imageedit-annotetoggle").on("click", function () {
            var cropped = $("#imageedit-canvassection");
            var display = cropped.css("display");
            if (display == "none") {
                if (VR.Image.Annotation.IsHidden()) {
                    $("#imageedit-resetbutton").trigger("click");
                    VR.Image.Annotation.ShowAnnotation();
                } else {
                    VR.Image.Annotation.HideAnnotation();
                }
            } else {
                var cropannote = $("#imageedit-canvasannote");
                var display = cropannote.css("display");
                if (display == "none") {
                    cropannote.css("display", "");
                } else {
                    cropannote.css("display", "none");
                }
            }
        });

        $("#imageedit-editannot").on("click", function () {
            var cropped = $("#imageedit-canvassection");
            var display = cropped.css("display");
            if (display == "none") {
                $("#imageedit-resetbutton").trigger("click");
                VR.Image.Annotation.ShowAnnotation();
                VR.Image.Annotation.ShowAnnotationEditor(
                    "imageedit-editsection",
                    "imageedit-annotationsection"
                );
            } else {
                VR.Image.Annotation.ShowCroppedAnnoteEditor(
                    "imageedit-canvassection",
                    "imageedit-canvasannote"
                );
            }
        });
    }; //SetupImageEditButtons

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the image save buttons.
        /// </summary>
        /// <returns></returns>*/
    self.SetupImageSaveButtons = function () {
        $("#imageedit-savetodatabse, #imageedit-savetofile").on("click", function (
            e
        ) {
            var modal = $("#imageeditor-modal");
            modal.modal("hide");
            var location = "D";
            var id = $(this).attr("id");
            if (id == "imageedit-savetofile") {
                location = "P";
            }

            var event = self.EventName;
            var appfunc = $("#imageedit-appfunction");
            if (appfunc.length == 0) {
                appfunc = "";
            } else {
                appfunc = appfunc.val();
            }
            var isactive = $("#imageedit-isactive");
            if (isactive.length == 0) {
                isactive = true;
            } else {
                isactive = isactive.attr("checked");
                if (isactive == "checked") {
                    isactive = true;
                }
            }
            var description = $("#imageedit-description").val();
            var fileType = $("#image-file-group").attr("data-file-type");
            var data = null;
            var display = "";
            if (fileType == "0") {
                var section = $("#imageedit-canvassection");
                display = section.css("display");
                if (display != "none") {
                    var image = section.children("img");
                    if (image.length > 0) {
                        data = image.attr("src");
                    } else {
                        data = "";
                    }
                }
            }

            if (data == null) {
                data = $("#image-data").prop("data-src");
            }

            if (data && data != "") {
                if (data.length > self.MaxImageUpload) {
                    VR.Common.ShowError("The file size exceeds the limit (" + editPageData.MaxImageUpload+"MB).");
                    return;
                }
                data = data.replace(/\+/g, "#");
            } else {
                data = "";
            }

            var year = self.GetFieldValue("EVENT_YEAR");
            var number = self.GetFieldValue("STATE_FILE_NUMBER", true);
            var extension = $("#image-data").prop("data-extension");
            if (extension) {
                extension = extension.toLowerCase();
                switch (extension) {
                    case "jpg":
                        extension = "jpeg";
                        break;
                    case "tif":
                        extension = "tiff";
                        break;
                }
            }

            var newext;
            if ($("#imageeditor-filetype").css("display") == "none") {
                var imageextension = $("#imageeditor-extension");
                var dropdown = imageextension.data("kendoDropDownList");
                if (dropdown) {
                    newext = dropdown.value();
                } else {
                    newext = imageextension.val();
                }
            } else {
                newext = extension;
            }

            var annote = { json: "", width: "", height: "" };
            var fileload = modal.attr("data-fileload");
            if (!fileload) {
                if (display != "none") {
                    annote = VR.Image.Annotation.JsonString(
                        "imageedit-canvasannote-canvas"
                    );
                } else {
                    annote = VR.Image.Annotation.JsonString("imageedit-annotation");
                }
            }
            var url = VR.Common.GetRootURL("event/edit") + "data/imageload";
            var selection = {
                EventGroup: event,
                eventId: self.EventId,
                appfunc: appfunc,
                isactive: isactive,
                description: description,
                location: location,
                extension: extension,
                newext: newext,
                year: year,
                number: number,
                annote: annote.json,
                width: annote.width,
                height: annote.height,
                data: data,
                filename: $("#imageedit-filename").val()
            };
            VR.Common.SecurePost(
                url,
                { imageLoad: selection },
                function (result) {
                    if (result.Code != 0 || result.Image == null) {
                        VR.Common.HandleInvalidResult(result, "File Load", false);
                    } else {
                        var list = $("#image-list");
                        list.find(".image").off("dblclick");
                        var images = self.ImageDataSource.data();
                        if (images.length == 0) {
                            images = [];
                        }
                        images.push(result.Image);
                        self.ImageDataSource.data(images);

                        var pager = $("#image-pager").data("kendoPager");
                        if (pager) {
                            pager.refresh();
                        }
                        var kendoList = list.data("kendoListView");
                        if (kendoList) {
                            kendoList.refresh();

                            $("#image-list .image").on("dblclick", function (e) {
                                var imageId = this.id;
                                if (imageId.indexOf("image-") > -1) {
                                    imageId = imageId.substring("image-".length);
                                }
                                var urlParams = new URLSearchParams(window.location.search);
                                var eventEditParam = urlParams.get('selection') || "";
                                var url = VR.Common.GetRootURL();
                                window.open(url + "event/imagewindow?" + eventEditParam + "&vrsimageid=" + imageId, "_blank", "popup=1,menubar=no,toolbar=no,status=no,resizable=yes,fullscreen=yes");
                            });
                        }

                        self.ImageCount++;
                        if (VR.Common.IsMobile()) {
                            $("#mobileImagesBtnText").html(VR.Common.HtmlEscape(self.ImageCount));
                        }
                        else {
                            $("#images-count").html("Image count: " + VR.Common.HtmlEscape(self.ImageCount));
                        }
                    }
                },
                true,
                undefined,
                false,
                false
            );
        });
    }; //SetupImageSaveButtons

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the errors button and count.
        /// </summary>
        /// <returns></returns>*/
    self.SetupErrorCount = function () {
        if (VR.Common.IsMobile()) {
            let errorBtn = $("#errors-count");
            errorBtn.show();
            $('#validation-panel').hide();
            errorBtn.removeClass();
            errorBtn.addClass("glyphicon glyphicon-warning-sign");
            errorBtn.html(`<span id="mobileErrorsBtnText">${self.GetFieldErrorCount()}</span>`);
            errorBtn.css({ "font-size": "30px", "display": "inline", "padding": "10px 8px" });
            $("#mobileErrorsBtnText").css({ "font-size": "30px", "position": "relative", "top": "-5px", "left": "5px", "color": "black", "font-weight": "bold" });
            errorBtn.on("touchend", function (e) {
                $("#validation-panel").toggle();
            });
        }
    }; //SetupErrorCount

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up Label.
        /// </summary>
        /// <param name="model">The result from the web service.</param>
        /// <returns></returns>*/
    self.SetupLabel = function (model) {
        let startHtml = $("#p" + model.FieldId + " > label").html();
        $("#p" + model.FieldId + " > label").html(startHtml.replaceAll("\n", "<br />"));
    }; //SetupLabel

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up linking.
        /// </summary>
        /// <returns></returns>*/
    self.SetupLinking = function () {
        $(".linking-menu").on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
            var openNew = $(this).attr("data-opennew");
            $(this).removeAttr("data-opennew");
            var target = $(this).attr("data-target");
            if (!target) {
                target = "";
            }
            $(this).removeAttr("data-target");
            var event = self.EventName;
            var eventId = self.EventId;
            var value = self.GetFieldData();
            var selection = "event=" + event + "|id=" + eventId + "|value=" + value;
            var url = VR.Common.GetRootURL("event/edit") + "event/linking";
            VR.Common.SecurePost(
                url,
                selection,
                function (result) {
                    if (!result || result.Code != 0) {
                        VR.Common.HandleInvalidResult(result, "Linking", true);
                    } else {
                        nxLoading.start("Loading page. Please wait...");
                        var href = VR.Common.GetRootURL();
                        var selection =
                            e.target.id +
                            "|" +
                            result.LinkingSetupId +
                            "|" +
                            self.IsCasEvent +
                            "|" +
                            target;
                        selection = "search=" + encodeURIComponent(selection);
                        href +=
                            "event/search?selection=" +
                            encodeURIComponent(selection);
                        if (VR.Common.CanOpen || openNew) {
                            window.open(href);
                            nxLoading.end();
                        } else {
                            window.location.href = href;
                        }
                    }
                },
                true,
                undefined,
                false,
                false
            );
        });
    }; //SetupLinking

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the load file dialog box.
        /// </summary>
        /// <returns></returns>*/
    self.SetupLoadFile = function () {
        $("#imagefile-modal").on("shown.bs.modal", function (e) {
            $("#imagename-text").focus();
        });
        var uploadLength = null
        $("#imagefile-button").on("change", function (e) {
            var val = $(this).val();
            if (val == "") {
                return;
            }
            $("#image-file").val(val);
            var inputFiles = this.files;
            if (inputFiles == undefined || inputFiles.length == 0) {
                return;
            }
            var inputFile = inputFiles[0];
            var filename = "";
            if (inputFile) {
                filename = inputFile.name;
            }

            $("#imageedit-filename").html(filename);

            var reader = new FileReader();
            reader.onload = function (event) {
                if (!event || !event.target || !event.target.result) {
                    VR.Common.ShowError(
                        "Could not load file. This is possibly the file is too large.",
                        "Error"
                    );
                    $("#image-data").prop("data-src", "");
                }
                uploadLength = event.target.result.length
                $("#image-data").prop("data-src", event.target.result);
                $("#imagefile-button").val("");
            };

            reader.onerror = function (event) {
                VR.Common.ShowError(
                    "Could not load file. This is possibly the file is too large.",
                    "Error"
                );
                $("#image-data").prop("data-src", "");
            };
            reader.readAsDataURL(inputFile);
        });

        $("#loadfile-button").on("click", function (e) {
            var val = $("#image-file").val();
            if (!val || val == "") {
                $("#image-file-error").html("Please select a file");
                return;
            }

            if (uploadLength > self.MaxImageUpload) {
                VR.Common.ShowError("The image exceeds the limit (" + editPageData.MaxImageUpload + "MB)", "Error", null, 7500);
                $("#image-data").prop("data-src", "");
                return;
            } else {
                $("#image-file-error").html("");
                $("#imagefile-modal").modal("hide");
                self.LoadImageFile();
            }

            
        });
    }; //SetupLoadFile

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up fields.
        /// </summary>
        /// <param name="model">The result from the web service.</param>
        /// <returns></returns>*/
    self.SetupMaskedEdit = function (model) {
        var input = $("#f" + model.FieldId);

        // Prevent duplicate setup
        if (input.data("masked-setup-complete")) return;
        input.data("masked-setup-complete", true);

        var maskedtextbox = input.data("kendoMaskedTextBox");

        // Initialize masked textbox if not already done
        if (!maskedtextbox && !input.data("masked-initialized")) {
            input.attr("autocomplete", "off");
            input.data("masked-initialized", true);
            input.kendoMaskedTextBox({
                mask: model.Mask,
                unmaskOnPost: false
            });
        }

        // Focus event: select text and track last focused field
        input
            .off("focus.maskededit")
            .on("focus.maskededit", function () {
                var el = this;
                setTimeout(function() { el.select(); }, 0);
                VR.Image.TypeFromImage.SetField(model, this);
                VR.Edit.LastFocusedField = model.FieldId;
            })

            // Keydown event: block input if readonly, except Tab
            .off("keydown.maskededit")
            .on("keydown.maskededit", function (e) {
                if (
                    input.hasClass("readonly-text") &&
                    !input.is("[role='listbox']") &&
                    e.which != 9
                ) {
                    e.preventDefault();
                    return;
                }
                self.FieldKeyDown(e);
            })

            // Keyup event: delegate to shared handler
            .off("keyup.maskededit")
            .on("keyup.maskededit", self.FieldKeyUp)

            // Keypress event: handle date shortcuts
            .off("keypress.maskededit")
            .on("keypress.maskededit", function (e) {
                var maskedEdit = input.data("kendoMaskedTextBox");
                var fieldModel = input.data("field");

                // Only apply shortcuts for date fields with specific mask
                if (!fieldModel || (maskedEdit.options && maskedEdit.options.mask != "00/00/0000")) {
                    return;
                }

                var key = e.which;
                var date;

                switch (key) {
                    case 84: case 116: // T/t = Today
                        e.preventDefault();
                        date = new Date();
                        date.setHours(0, 0, 0, 0);
                        maskedEdit.value(VR.Common.ToDateString(date));
                        this.setSelectionRange(0, 0);
                        break;

                    case 66: case 70: case 98: case 102: // B/F/b/f = Back/Forward one day
                        e.preventDefault();
                        date = new Date(maskedEdit.value());
                        if (!isNaN(date.getTime())) {
                            var add = (key == 66 || key == 98) ? -1 : 1;
                            date.setDate(date.getDate() + add);
                            maskedEdit.value(VR.Common.ToDateString(date));
                            this.setSelectionRange(0, 0);
                        }
                        break;

                    case 85: case 117: // U/u = Unknown
                        e.preventDefault();
                        maskedEdit.value("99/99/9999");
                        break;

                    case 78: case 110: // N/n = Not applicable
                        e.preventDefault();
                        maskedEdit.value("88/88/8888");
                        break;
                }
            });
    };

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the Button control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupMemoBox = function (model) {
        //var value = VR.Common.HtmlEscape(model.FieldValue);
        //var html = "<textarea id='f" + VR.Common.HtmlEscape(model.FieldId) + "' >" + value + "</textarea>";
        //$("#p" + model.FieldId).html(html);
        var panel = $("#p" + model.FieldId);
        panel.css("height", "auto");
        var input = $("#f" + model.FieldId);
        $(input).val(model.FieldValue);
        input.attr("autocomplete", "off");
        input.attr("spellcheck", model.SpellCheck);
        input.attr("maxlength", model.MaxLength);
        input.attr("rows", model.MemoBoxRows);
        input.on("keydown", self.FieldKeyDown);
        input.on("keyup", self.FieldKeyUp);
        input.on("focus", function (e) {
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });
    }; //SetupMemoBox

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the MultiSelect control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupMultiSelect = function (model) {
        var input = $("#f" + model.FieldId);
        input.attr("autocomplete", "off");
        input.removeData("field");
        var disabled = input.attr("disabled");
        var value = VR.Common.HtmlEscape(model.FieldValue);
        var html =
            "<select id='f" +
            VR.Common.HtmlEscape(model.FieldId) +
            "' multiple >" +
            value +
            "</select>";
        var panel = $("#p" + model.FieldId);
        $(panel).html(html);

        var dataSource = [];
        if (model.DropDownList && model.DropDownValues) {
            if (model.DropDownList && model.DropDownValues) {
                for (var i = 0; i < model.DropDownList.length; i++) {
                    dataSource.push({
                        text: model.DropDownList[i],
                        value: model.DropDownValues[i]
                    });
                }
            }
        } else {
            var fieldId = model.FieldId;
            dataSource = new kendo.data.DataSource({
                transport: {
                    read: function (options) {
                        var input = $("#f" + fieldId)
                            .parent()
                            .find("input");
                        var val = $(input).val();
                        val = encodeURIComponent(val);
                        var model = $(input).data("field");
                        var filter = self.GetFilterValues(model);
                        var voidVal = "";
                        if (model && model.VoidField) {
                            voidVal = self.GetFieldValue(model.VoidField);
                        }
                        performLookup(
                            fieldId,
                            val,
                            filter,
                            "",
                            voidVal,
                            "",
                            self.EventYear,
                            function (result) {
                                if (result.Code == 0) {
                                    var data = [];
                                    if (result.List) {
                                        for (var i = 0; i < result.List.length; i++) {
                                            var value = result.List[i];
                                            data.push({ text: value, value: value });
                                        }
                                    }

                                    if (!!options) options.success(data);
                                    else {
                                        // we need to apply the changes here if options is not assigned.
                                        $("#f" + fieldId)
                                            .data("kendoComboBox")
                                            .setDataSource(data);
                                    }
                                    if (!input.is(":focus")) {
                                        $("#f" + fieldId)
                                            .data("kendoComboBox")
                                            .close();
                                    }
                                    return data;
                                } else {
                                    options.error(result);
                                    VR.Common.HandleInvalidResult(result, "Lookup", true);
                                    return [];
                                }
                            }
                        );
                    }
                },
                serverFiltering: true
            });
        }

        var list = null;
        if (model.FieldValue && model.FieldValue != "") {
            list = model.FieldValue.split("*");
        }

        var values = [];
        if (list && list.length > 0) {
            for (var i = 0; i < list.length; i++) {
                var val = list[i];
                values.push({ text: val, value: val });
            }
        }

        input = $("#f" + model.FieldId);
        $(input).kendoMultiSelect({
            autoBind: false,
            dataTextField: "text",
            dataValueField: "value",
            dataSource: dataSource,
            deley: 2000,
            filter: "contains",
            value: values
        });

        input.addClass("input-field");
        input.attr("data-field-name", model.FieldName);
        input.data("field", model);
        if (disabled) {
            self.SetReadOnly(input, true);
        }
        var multiSelect = panel.find(".k-input");
        multiSelect.on("keydown", self.FieldKeyDown);
        multiSelect.on("focus", function (e) {
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });
    }; //SetupMultiSelect

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the next button.
        /// </summary>
        /// <returns></returns>*/
    self.SetupNextButtons = function () {
        $("#tab-content")
            .find(".btn-next")
            .on("click", function (e) {
                var target = $(this).attr("data-target");
                var model = $("#f" + target).data("field");
                if (model) {
                    var index = self.Fields.indexOf(model);
                    for (var i = 0; i < self.Fields.length; i++) {
                        index = (index + 1) % self.Fields.length;
                        model = self.Fields[index];
                        if (
                            model.FieldType != "Hidden" &&
                            model.FieldType != "Label" &&
                            model.IsEnabled &&
                            model.IsEditable
                        ) {
                            break;
                        }
                    }

                    if (model && model.FieldId) {
                        VR.Script.FocusField(
                            { input: "#f" + model.FieldId, model: model },
                            false
                        );
                    }
                }
            });
    }; //SetupNextButtons

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up record numbering.
        /// </summary>
        /// <returns></returns>*/
    self.SetupNumberRecord = function () {
        $("#numberrec-menu").on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
            var isactive = self.GetIsActive();
            var event = self.EventName;
            var eventId = self.EventId;
            if (!eventId || eventId == 0) {
                VR.Common.ShowError("The new record cannot be numbered.");
                return;
            }
            //var inputs = $("#tab-content").find("input[data-field-name='STATE_FILE_NUMBER']");
            var fields = self.GetInputFields("STATE_FILE_NUMBER");
            if (fields.length == 0) {
                VR.Common.ShowError("The state file number field not found.");
                return;
            }

            var value = self.GetFieldValue("STATE_FILE_NUMBER");
            if (value && !self.CanNumberOverride) {
                VR.Common.ShowError("The state file number field already exists.");
                return;
            }

            var isNumberReady = false;
            //inputs = $("#tab-content").find("input[data-field-name='OK_TO_NUMBER']");
            var inputs = self.GetInputFields("OK_TO_NUMBER");
            if (inputs.length == 0) {
                isNumberReady = true;
            } else {
                value = self.GetFieldValue("OK_TO_NUMBER");
                if (value == "Y") {
                    isNumberReady = true;
                }
            }

            if (isNumberReady) {
                //inputs = $("#tab-content").find("input[data-field-name='REGISTER_READY']");
                inputs = self.GetInputFields("REGISTER_READY");
                if (inputs.length == 0) {
                    isNumberReady = true;
                } else {
                    value = self.GetFieldValue("REGISTER_READY");
                    if (value == "Y") {
                        isNumberReady = true;
                    }
                }
            }

            if (!isNumberReady) {
                VR.Common.ShowError(
                    "The indicator field on the form in the event record indicates that the record is not " +
                    "ready to number because of errors or incomplete entries. Please complete the record " +
                    "properly and try again."
                );
                return;
            }

            var regCode = self.GetFieldValue("REG_TYPE_CODE", true);
            var eventYear = self.GetFieldValue("EVENT_YEAR", true);
            var modTypeid = self.ModTypeId;
            if (modTypeid == null || modTypeid == 0) {
                modTypeid = "";
            }

            var selection =
                "name=" +
                event +
                "|id=" +
                eventId +
                "|regtype=" +
                regCode +
                "|year=" +
                eventYear +
                "|modtype=" +
                modTypeid;
            nxLoading.start("Posting. Please wait...");
            VR.Common.SecurePost(
                "event/number",
                selection,
                function (result) {
                    if (result.Code != 0) {
                        VR.Common.HandleInvalidResult(result, "Number", false);
                    } else {
                        var inputs = $("#tab-content").find(
                            "input[data-field-name='STATE_FILE_NUMBER']"
                        );
                        if (inputs.length > 0) {
                            $.each(inputs, function (index, input) {
                                self.SetFieldValue(input, result.Number);
                                var model = $(input).data("field");
                                if (model) {
                                    model.HasChange = false;
                                    model.OriginalValue = result.Number;
                                }
                            });
                        }

                        if (result.ChangedFields && result.ChangedFields.length > 0) {
                            $.each(result.ChangedFields, function (index, field) {
                                var inputs = $("#tab-content").find(
                                    "input[data-field-name='" + VR.Common.EscapeSelector(field.FieldName) + "']"
                                );
                                $.each(inputs, function (i, input) {
                                    self.SetFieldValue(input, field.Value);
                                    var model = $(input).data("field");
                                    if (model) {
                                        model.HasChange = false;
                                        model.OriginalValue = field.Value;
                                    }
                                });
                            });
                        }

                        VR.Common.ShowInfo("The record numbered.");
                        if (!self.CanDeleteWithSFN) {
                            $("#deleterecs-menu").hide();
                        }
                    }
                },
                false
            ).always(function () {
                nxLoading.end();
            });
        });
    }; //SetupNumberRecord

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the NumericTextBox control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupNumericTextBox = function (model) {
        var format = model.InputFormat;
        if (!format || format == "") {
            format = "c";
        }

        var input = $("#f" + model.FieldId);
        input.attr("autocomplete", "off");
        var settings = {
            format: format,
            decimals: 3,
            display: "initial"
        };
        var max = parseFloat(model.InputMax);
        if (!isNaN(max)) settings.max = max;
        var min = parseFloat(model.InputMin);
        if (!isNaN(min)) settings.min = min;
        var step = parseFloat(model.InputStep);
        if (!isNaN(step) && step !== 0) settings.step = step;
        input.kendoNumericTextBox(settings);
        input.data("kendoNumericTextBox").value(model.FieldValue);

        input.on("keydown", self.FieldKeyDown);
        input.on("keyup", self.FieldKeyUp);
        input.prop("type", "number");
        input.on("focus", function (e) {
            // Only select if not already processing to prevent loops
            if (!$(this).data('selecting')) {
                $(this).data('selecting', true);
                try {
                    $(this).select();
                } finally {
                    var $this = $(this);
                    setTimeout(function() {
                        $this.data('selecting', false);
                    }, 100);
                }
            }
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });

        // Remove native browser spinners by removing spinbutton role
        input.parent().find('input[type="number"]').removeAttr('role');

        // Add CSS to hide native browser spinners
        var style = document.createElement('style');
        style.textContent = `
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
            input[type="number"] {
                -moz-appearance: textfield;
            }
        `;
        if (!document.querySelector('style[data-spinner-hide]')) {
            style.setAttribute('data-spinner-hide', 'true');
            document.head.appendChild(style);
        }
    }; //SetupNumericTextBox

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the notes.
        /// </summary>
        /// <returns></returns>*/
    self.SetupNotes = function () {
        var dataVal = $("#data-value");
        var value = dataVal.attr("data-note");
        if (value != "") {
            self.CanNotes =
                value && value.length == 5 && value.substring(0, 1) == "1";
            self.CanSaveNotes =
                value && value.length == 5 && value.substring(1, 2) == "1";
            self.CanNewNotes =
                value && value.length == 5 && value.substring(2, 3) == "1";
            self.CanDeleteNotes =
                value && value.length == 5 && value.substring(3, 4) == "1";
            self.IsNotesAdmin =
                value && value.length == 5 && value.substr(4, 1) == "1";
        }
        var menu = $("#shownotes-menu");
        var recordid = self.EventId;
        if (!self.CanNotes || recordid == 0) {
            menu.css("display", "none");
            if (VR.Common.IsMobile()) {
                $("#notes-count").css("display", "none");
            }
        } else {
            menu.css("display", "block");
            menu.on(VR.Common.IsNavBurger() ? "touchend" : "click", function (e) {
                self.ShowNotes("0");
            });
            let notesBtn = $("#notes-count");
            if (VR.Common.IsMobile()) {
                notesBtn.removeClass();
                notesBtn.addClass("glyphicon glyphicon-comment");
                notesBtn.html(`<span id="mobileNotesBtnText">${self.NotesCount}</span>`);
                notesBtn.css({ "font-size": "30px", "display": "inline", "padding": "10px 8px" });
                $("#mobileNotesBtnText").css({ "font-size": "30px", "position": "relative", "top": "-5px", "left": "5px", "color": "black", "font-weight": "bold" });
                notesBtn.on("touchend", function (e) {
                    self.ShowNotes("0");
                });
            } else {
                notesBtn.on("dblclick", function (e) {
                    self.ShowNotes("0");
                });
                notesBtn.on("keydown", function (e) {
                    if (e.which === 13 || e.which === 32)
                        self.ShowNotes("0");
                });
            }
        }
        dataVal.attr("data-note", "");
    }; //SetupNotes

    /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up onbeforeunload.
        /// </summary>
        /// <returns></returns> */
    self.SetupOnBeforeUnload = function () {
        var unloading = false;
        $(window).on("beforeunload", function (e) {
            if (self.IsDisplayOnly) {
                return;
            }
            if (self.CanLeaveValidated == true) {
                self.CanLeaveValidated = false;
                return;
            }
            var returnValue = "";
            if (
                (!self.CanSaveWithEdits && !self.CanSaveWithoutEdits) ||
                !self.CanSave ||
                self.CanClose
            ) {
                return;
            }

            $.each(self.Fields, function (index, model) {
                if (model.HasChange) {
                    returnValue = "You have unsaved changes. ";
                }
            });
            setTimeout(function () {
                if (!unloading) {
                    nxLoading.end();
                }
            }, 4000);
            if (returnValue) {
                return returnValue;
            }
            return true;
        });
        $(window).on("unload", function () {
            unloading = true;
        });
    }; //SetupOnBeforeUnload

    /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up on unload event handler.
        /// </summary>
        /// <returns></returns> */
    self.SetupOnUnload = function () {
        if (self.IsDataCached && self.EventId > 0) {
            var selection = "event=" + self.EventName + "|id=" + self.EventId;
            VR.Common.SecurePost("data/eventcache", selection, function (result) {
                if (result.Code == 1460) {
                    var url = self.Referrer;
                    var footer;
                    if (url && url.indexOf("/event/edit") < 0) {
                        footer =
                            "This page will go back to one of previously visited pages where you can go safely.";
                        url = self.Referrer;
                    } else {
                        footer = "\n This page will go back to the home page.";
                        url = VR.Common.GetRootURL();
                    }
                    self.CanLeaveValidated = true;
                    VR.Common.ShowErrorMessage(result, "Data Check", footer, function () {
                        window.location.href = url;
                    });
                } else if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Data Check", false);
                }
            });
        }

        $(window).on("unload", function () {
            if (self.EventId == 0) {
                return;
            }
            var windowId = $("#footer-data").attr("data-window");
            var selection =
                "window=" +
                windowId +
                "|event=" +
                self.EventName +
                "|id=" +
                self.EventId;
            VR.Common.SecurePost("home/close", selection, function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Close", true);
                }
            });
        });
    }; //SetupOnUnload

    /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up general popup menu.
        /// </summary>
        /// <returns></returns> */
    self.SetupPopupMenu = function () {
        $(document).on("contextmenu", function (event) {
            self.ShowPopupMenu(event);
        });

        $(document).on("mousedown", function (event) {
            if (!$(event.target).parents(".custom-menu").length > 0) {
                $(".custom-menu").hide(100);
            }
        });

        if (VR.Common.IsIOS()) {
            $("#undofieldmenu-popupmenu").html("Hide Field Popup Menu");

            $(document).on("touchstart", function (event) {
                var display = $(".custom-menu").css("display");
                if (display != "none") {
                    return;
                }
                if (event.originalEvent.touches.length < 1) {
                    return;
                }
                var touchobj = event.originalEvent.touches[0];
                var startx = touchobj.pageX;
                var starty = touchobj.pageY;
                self.PopupTimeout = setTimeout(function (e) {
                    self.ShowPopupMenu({
                        target: event.target,
                        pageX: startx,
                        pageY: starty
                    });
                }, 2000);
            });
        }

        if (VR.Common.IsIOS()) {
            $(document).on("touchend", function (event) {
                if (self.PopupTimeout) {
                    clearTimeout(self.PopupTimeout);
                    self.PopupTimeout = null;
                } else if (!$(event.target).parents(".custom-menu").length > 0) {
                    $(".custom-menu").hide(100);
                }
            });
        }

        $(".custom-menu li").on("click", function () {
            var action = $(this).attr("data-action");
            var id = $(self.PopupTarget).attr("id");
            var model = $(self.PopupTarget).data("field");
            switch (action) {
                case "about":
                    VR.Common.ShowWebSiteInfo();
                    break;
                case "field":
                    VR.Common.ShowFieldInfo(self.PopupTarget);
                    break;
                case "js-editor":
                    VR.Common.ShowFieldJEditor(self.PopupTarget);
                    VR.Script.FocusField({ input: id, model: model }, true);
                    break;
                case "notes":
                    var prefix = null;
                    if (id && id.toString().length > 0) {
                        prefix = id.toString().substring(0, 1);
                    }
                    if (prefix == "f" || prefix == "p" || prefix == "g") {
                        id = id.substring(1);
                    }
                    self.ShowNotes(id);
                    break;
                case "undo":
                    VR.Common.UndoPopupMenu();
                   // $("#showbrowserpopup-menu").css("display", "none");//6256
                    //$("#showfieldpopup-menu").css("display", "");
                    $("#showbrowserpopup-menu").text("Show Field Popup Menu");
                    break;
                case "query":
                    self.QueryField(self.PopupTarget);
                    break;
                case "reset":
                    self.ResetField(self.PopupTarget);
                    break;
                case "page":
                    $("#pageinfo-modal").modal("show");
                    break;
                case "date":
                case "clear":
                case "default":
                    var value = "";
                    if (action == "date") {
                        var d = new Date();
                        value = VR.Common.ToDateString(d);
                    } else if (action == "default") {
                        var model = $(self.PopupTarget).data("field");
                        if (model) {
                            value = model.DefaultValue;
                        }
                    }

                    self.SetFieldValue(self.PopupTarget, value, true);
                    VR.Script.FocusField({ input: id, model: model }, true);
                    break;
                case "casing":
                    var casing = "keep";
                    var model = $(self.PopupTarget).data("field");
                    if ($(self.PopupTarget).data("casing") != "ignore") {
                        casing = "ignore";
                    } else {
                        switch (model.Case) {
                            case "capitalize":
                            case "upper":
                            case "lower":
                                casing = "keep";
                                break;
                            default:
                                casing = "ignore";
                                break;
                        }
                    }
                    var fields = self.GetInputFields(model.FieldName);
                    for (var i = 0; i < fields.length; i++) {
                        $(fields[i]).data("casing", casing);
                    }
                    if (casing != "ignore") {
                        switch (model.Case) {
                            case "capitalize":
                            case "upper":
                            case "lower":
                                $(self.PopupTarget).val(
                                    self.GetFieldValue(model.FieldName, true)
                                );
                                break;
                        }
                    }
                    VR.Script.FocusField({ input: id, model: model }, true);
                    break;
                default:
                    VR.Image.Annotation.HandlePopupMenu(action);
                    break;
            }
            $(".modal-x").click(function () {
                VR.Script.FocusField({ input: id, model: model }, true);
            });
            $(".custom-menu").hide(100);
        });
    }; //SetupPopupMenu

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the RadioButton control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupRadioButton = function (model) {
        var panel = $("#p" + model.FieldId);
        panel.css("height", "auto");

        var input = $("#f" + model.FieldId);
        input.on("keydown", function (e) {
            self.FieldKeyDown(e);
            if (e.key === "Tab") {
                self.ValidateField(input);
                VR.Image.TypeFromImage.SetField(model, input);
            }
        });
        input.on("focus", function (e) {
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });

        input.find("input[type=radio]").on("change", function () {
            self.DoFieldValueChanged("#f" + model.FieldId);
            if (model.Edits.length > 0) {
                self.ValidateField(input);
                self.DoSkipFields(input);
            }
        });
    }; //SetupRadioButton

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the review error/query.
        /// </summary>
        /// <returns></returns>*/
    self.SetupReviewError = function () {
        $("#reviewerror-modal").on("show.bs.modal", function (e) {
            var html = "";
            $.each(self.Fields, function (index, model) {
                if (
                    !$("#f" + model.FieldId).hasClass("readonly-text") &&
                    model.FieldStatus &&
                    model.FieldStatus != "alerttrigger" &&
                    model.FieldStatus != "skipped" &&
                    model.FieldStatus != "literal"
                ) {
                    html +=
                        "<tr><td class='reviewerror-thead'>" +
                        model.FieldName +
                        "</td><td class='reviewerror-thead'>" +
                        VR.Common.HtmlEscape(model.FieldLabel) +
                        "</td><td class='reviewerror-status input-" +
                        model.FieldStatus +
                        "'>" +
                        model.FieldStatus +
                        "</td><td><button class='btn btn-success review-btn' id='review-" +
                        model.FieldId +
                        "'>Go</button></td></tr>";
                }
            });

            var list = $("#reviewerror-list");
            list.html(html);

            if (html.length > 0) {
                $("#reviewerror-section").css("display", "");
                $("#reviewerror-noerror").css("display", "none");
            } else {
                $("#reviewerror-section").css("display", "none");
                $("#reviewerror-noerror").css("display", "");
            }

            list.find(".review-btn").on("click", function (e) {
                var link = $(this).attr("id");
                if (!link || link.length < 7) {
                    return;
                }

                link = "#f" + link.substring(7);
                link = $(link);
                if (link.length < 1) {
                    return;
                }
                var model = link.data("field");
                if (!model) {
                    return;
                }

                switch (model.FieldType) {
                    case "ComboBox":
                    case "MultiSelect":
                        var parent = link.parents(".edit-field");
                        if (parent.length < 1) {
                            return;
                        }
                        link = parent.find(".k-input");
                        if (link.length < 1) {
                            return;
                        }
                        break;
                }

                var tab = link.parents("[role=tabpanel]");
                var id = tab.attr("id");
                $("#tabs")
                    .find("a[aria-controls=" + id + "]")
                    .trigger("click");
                var position = link.offset();
                var offset = $("nav").height();
                offset = VR.Common.ToFloat(offset);
                if (isNaN(offset)) {
                    offset = 50;
                }
                offset -= 50;

                $("#reviewerror-modal").modal("hide");
                window.scrollTo(0, position.top - 70 - offset);
                $(link).focus();
            });
        });

        $("#reviewerror-modal").on("shown.bs.modal", function (e) {
            var dialog = $("#reviewerror-modal .modal-content");
            var table = $("#reviewerror-table");
            var height = $(dialog).height();
            var winheight = $(window).height();

            if (height > winheight - 250) {
                height = winheight - 250;
                $(table).css("max-height", height + "px");
            }
        });

        if (VR.Common.IsNavBurger()) {
            $("#reviewoverridesqueries-menu").on("touchend", function (e) {
                /*console.log("inside review error mobile");*/
                $("#reviewerror-modal").modal("show");
            });
        }
    }; //SetupReviewError

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the save.
        /// </summary>
        /// <param name="target">The target object.</param>
        /// <param name="hasEdits">The value to indicate if edits need to run.</param>
        /// <param name="isTwinSave">The value to indicate if this is twin save.</param>
        /// <returns></returns>*/
    self.SetupSave = function (target, hasEdits, isTwinSave) {
        $("#" + target).on(VR.Common.IsNavBurger() ? "touchend" : "click", function () {
            if (!isTwinSave) {
                self.Save(hasEdits, isTwinSave, false, true);
            } else {
                var selection = "name=" + self.EventName;
                VR.Common.SecurePost(
                    "event/twinsave",
                    selection,
                    function (result) {
                        if (result.Code != 0 || !result.List) {
                            if (!result.List) {
                                result = null;
                            }
                            VR.Common.HandleInvalidResult(result, "Twin Save", false);
                        } else {
                            $.each(result.List, function (i, field) {
                                //var inputs = $("#tab-content").find("input[data-field-name='" + field.FieldName + "']");
                                var inputs = self.GetInputFields(field.FieldName);
                                $.each(inputs, function (index, input) {
                                    self.SetFieldValue(
                                        input,
                                        field.Value == null ? "" : field.Value
                                    );
                                });
                            });
                            if (!result.CanSaveTwinWithSFN) {
                                var stateFileNumber = self.GetStateFileNumber();
                                if (stateFileNumber) {
                                    var message =
                                        "Cannot create a twin after record has been assigned a state file number.";
                                    if (result.List.length > 0) {
                                        message +=
                                            "\nThe field values on the form were changed due to the setting in the twin save table.";
                                    }
                                    self.ShowSaveError(message);
                                    return;
                                }
                            }
                            //var inputs = $("#tab-content").find("input[data-field-name='STATE_FILE_NUMBER']");
                            var inputs = self.GetInputFields("STATE_FILE_NUMBER");
                            $.each(inputs, function (index, input) {
                                self.SetFieldValue(input, "");
                            });
                            //inputs = $("#tab-content").find("input[data-field-name='LOCAL_FILE_NUMBER']");
                            inputs = self.GetInputFields("LOCAL_FILE_NUMBER");
                            $.each(inputs, function (index, input) {
                                self.SetFieldValue(input, "");
                            });
                            if (result.KeyFields) {
                                $.each(result.KeyFields, function (i, field) {
                                    //var inputs = $("#tab-content").find("input[data-field-name='" + field + "']");
                                    var inputs = self.GetInputFields(field);
                                    $.each(inputs, function (index, input) {
                                        self.SetFieldValue(input, 0);
                                    });
                                });
                            }
                            self.EventId = 0;
                            var title = $("#main-container").attr("event-title");
                            title = title + " : Twin Save";
                            $("#plugins").html(VR.Common.HtmlEscape(title));
                            self.Save(hasEdits, true, false, true);
                        }
                    },
                    true,
                    "eventname="
                );
            }
        });
    }; //SetupSave

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the image scanning.
        /// </summary>
        /// <returns></returns>*/
    self.SetupScanImage = function () {
        var menu = $("#scanimage-menu");
        if (VR.Common.IsMobile()) {
            menu.css("display", "none");
            return;
        }

        var modal = $("#scanimage-modal");
        menu.on("click", function () {
            if (!self.EventId || self.EventId < 1) {
                VR.Common.ShowError(
                    "Cannot attach an image until you save the record."
                );
                return;
            }
            var buttons = $("#scanimage-buttons");
            if (!self.DWObject) {
                self.InitScanImage();
            } else {
                self.DWObject.RemoveAllImages();
            }

            buttons.css("visibility", "hidden");
            modal.modal("show");
        });

        modal.on("shown.bs.modal", function (e) { });

        modal.on("hidden.bs.modal", function () {
            if (self.DWObject) {
                Dynamsoft.DWT.Unload();
                self.DWObject = null;
            }
        });

        var button = modal.find(".btn-success");
        button.on("click", function (e) {
            if (!self.DWObject) {
                return;
            }

            self.DWObject.IfDisableSourceAfterAcquire = true;
            var dropdown = $("#scanner-source").data("kendoDropDownList");
            if (dropdown) {
                var selected = dropdown.select();
                self.DWObject.SelectSourceByIndex(selected);
            }
            self.DWObject.OpenSource();
            self.DWObject.AcquireImage({ IfCloseSourceAfterAcquire: true });
        });

        button = modal.find(".btn-default");
        button.on("click", function (e) {
            if (!self.DWObject || self.DWObject.HowManyImagesInBuffer < 1) {
                return;
            }

            self.DWObject.RemoveAllImages();
            $("#scanimage-pagenumber").html("");
        });
        function uuidv4() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
                c
            ) {
                var r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
        $("#scanimage-acceptbutton").on("click", function (e) {
            $("#scanimage-modal").modal("hide");
            var size = self.DWObject.HowManyImagesInBuffer;
            if (!size || size < 1) {
                return;
            }
            self.DWObject.SelectedImagesCount = 1;
            if (size == 1) {
                var imagesize = self.DWObject.GetSelectedImagesSize(
                    Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG
                );
                //the function SaveSelectedImagesToBase64Binary is listed as a deprecated method in Dynamsoft documentation, but seems to work as expected in this version
                //if we update the Dynamsoft library in the future, this method may not work as expected
                //https://www.dynamsoft.com/web-twain/docs-archive/v17.2.1/info/schedule/deprecated.html?ver=17.2.1#related-to-input-and-output
                //the new recommended method is ConvertToBase64, which is an async method, which would likely require quite a few changes for multi-page scans
                //https://www.dynamsoft.com/web-twain/docs-archive/v17.2.1/info/api/WebTwain_IO.html?ver=17.2.1#converttobase64
                var imagedata = self.DWObject.SaveSelectedImagesToBase64Binary();
                if (!imagedata) {
                    return;
                }
                imagedata = "data:image/png;base64," + imagedata;
                $("#image-data").prop("data-src", imagedata);
                $("#image-file-group").attr("data-file-type", "0");
                $("#image-file").val("scanned.png");
                $("#imageedit-isactive").attr("checked", true);
                $("#imageedit-filename").val(uuidv4());
                self.LoadImageFile("TIFF");
            } else {
                var modal = $("#tiffeditor-modal");
                var modalsize = self.SetImageEditorSize(modal);

                var canvases = $("#tiffeditor-canvassection,#tiffeditor-canvasannote");
                canvases.css("display", "none");
                var section = $("#tiffeditor-editsection");
                section.attr("data-image-size", size);
                section.attr("data-page-number", 0);
                $("#tiffeditor-pagenumber").html("Page 1 of " + size);
                var html = "";
                for (var i = 0; i < size; i++) {
                    self.DWObject.SelectedImagesCount = 1;
                    //self.DWObject.SetSelectedImageIndex(0, i); //deprecated in Dynamsoft v17.2.1, replaced with SelectImages
                    self.DWObject.SelectImages([i]);
                    var imagesize = self.DWObject.GetSelectedImagesSize(
                        Dynamsoft.DWT.EnumDWT_ImageType.IT_PNG
                    );
                    //see note above about SaveSelectedImagesToBase64Binary
                    var imagedata = self.DWObject.SaveSelectedImagesToBase64Binary();
                    if (!imagedata) {
                        return;
                    }
                    imagedata = "data:image/png;base64," + imagedata;
                    var style = " display : none;";
                    if (i == 0) {
                        style = "";
                    }
                    html +=
                        "<div id='tiffeditor-pagesection" +
                        (i + 1) +
                        "' style='" +
                        style +
                        "'>" +
                        "<img id='tiffeditor-page" +
                        (i + 1) +
                        "' src='" +
                        imagedata +
                        "' style='" +
                        style +
                        "' /></div>";
                }
                section.html(html);
                for (var i = 0; i < size; i++) {
                    var imageedit = $("#tiffeditor-page" + (i + 1));
                    imageedit.cropper({
                        minCanvasWidth: modalsize.width,
                        minCanvasHeight: modalsize.height,
                        minContainerHeight: modalsize.height,
                        minContainerWidth: modalsize.width,
                        crop: function (e) { }
                    });
                    if (i == 0) {
                        $("#tiffeditor-pagesection" + (i + 1)).css("display", "");
                        var cropper = modal.find(".cropper-container");
                        if (cropper.length > 0) {
                            self.TiffModalHeight = cropper.css("height");
                        }
                    }
                }
                $("#tiffeditor-buttons")
                    .find(".btn-cropbutton")
                    .css("visibility", "visible");
                $("#tiffeditor-slidebars").css("visibility", "visible");
                $("#tiffeditor-dragbutton").addClass("active");
                $("#tiffeditor-cropbutton").removeClass("active");
                html = "";
                for (var i = 0; i < size; i++) {
                    html +=
                        "<div id='tiffeditor-canvas" +
                        (i + 1) +
                        "' style=' display : none; '></div>";
                }
                $("#tiffeditor-canvassection").html(html);
                var annote = $("#tiffeditor-annotationsection");
                var annotes = annote.data("canvas");
                if (annotes) {
                    $.each(annotes, function (index, canvas) {
                        canvas.dispose();
                        $(canvas.wrapperEl).remove();
                    });
                }
                html = "";
                for (var i = 0; i < size; i++) {
                    var style = "style='display:none;'";
                    if (i == 0) {
                        style = "";
                    }
                    html +=
                        "<canvas id='tiffeditor-annotate" +
                        (i + 1) +
                        "' " +
                        style +
                        " ></canvas>";
                }
                annote.html(html);

                annote = $("#tiffeditor-canvasannote");
                annotes = annote.data("canvas");
                if (annotes) {
                    $.each(annotes, function (index, canvas) {
                        canvas.dispose();
                        $(canvas.wrapperEl).remove();
                    });
                }
                html = "";
                for (var i = 0; i < size; i++) {
                    var style = "style='display:none;'";
                    var id = "tiffeditor-canvasannote" + (i + 1);
                    html +=
                        "<div id='" +
                        id +
                        "' " +
                        style +
                        " ><canvas id='" +
                        id +
                        "-canvas'></canvas></div>";
                }
                annote.html(html);

                $("#tiffeditor-isactive").attr("checked", true);
                self.LoadTiffFile();
            }
        });
    }; //SetupScanImage

    self.TopazNumberOfTabletPoints = function () {
        try {
            return NumberOfTabletPoints();
        } catch (e) {
            return 0;
        }
    }; //TopazNumberOfTabletPoints

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the Signature Button control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupSignatureButton = function (model) {
        if (!self.SignaturePad) {
            var canvas = $("#signaturepad-canvas");

            if (canvas.length > 0) {
                self.SignaturePad = new SignaturePad(canvas[0]);
                self.SignaturePad.minWidth = 2.5;
                self.SignaturePad.maxWidth = 2.5;
                self.SignaturePad.penColor = "rgb(24, 24, 128)";
                self.SignaturePad.backgroundColor = "rgb(255, 255, 255)";
                self.SetSignatureButtonColor(model);
                $("#signature-clear").on("click", function (e) {
                    model.Cleared = true;
                    try {
                        self.ClearTopazDisplay();
                    } catch (e) { }
                    self.SignaturePad.clear();
                });

                $("#signature-cancel").on("click", function (e) {
                    try {
                        self.StopTopazInput();
                    } catch (e) { }
                    self.SignaturePad.off();
                });

                $("#signature-mouse").on("click", function (e) {
                    self.SignaturePad.on();
                    $("#signature-mouse").css("display", "none");
                });

                $("#signature-save").on("click", function (e) {
                    model = self.CurrentSignatureField;
                    var emptyPad =
                        self.SignaturePad.isEmpty() &&
                        self.TopazNumberOfTabletPoints() == 0;
                    var url = VR.Common.GetRootURL("event/edit") + "data/sign";
                    var data = self.SignaturePad.toDataURL();
                    if (
                        data &&
                        data != "" &&
                        data.indexOf("data:image/") > -1 &&
                        emptyPad == false
                    ) {
                        data = data.replace(/\+/g, "#");
                    } else {
                        data = null;
                    }
                    if (self.CurrentSignatureField != null) {
                        var event = self.EventName;
                        var eventId = self.EventId;
                        var selection =
                            "event=" +
                            event +
                            "|eventId=" +
                            eventId +
                            "|fieldId=" +
                            model.FieldId +
                            "|sign=" +
                            data;

                        VR.Common.SecurePost(
                            url,
                            selection,
                            function (result) {
                                if (result.Code == 0) {
                                    model.FieldValue = result.SigId;
                                    self.ValidateField($("#f" + model.FieldId)[0]);
                                    var input = "#f" + model.FieldId;
                                    var field = $(input);
                                    self.SetFieldValue(field, result.SigId, true);
                                    if (!!field) {
                                        nx.ResetField(field);
                                        if (!!model.FieldValue && !emptyPad) {
                                            self.ToggleSignatureFocus(field, true);
                                        } else {
                                            self.ToggleSignatureFocus(field, false);
                                        }
                                    }
                                } else {
                                    VR.Common.HandleInvalidResult(result, "Signature", false);
                                }

                                $("#signature-modal").modal("hide");
                            },
                            true,
                            undefined,
                            false,
                            false
                        );
                        self.SetSignatureButtonColor(model);
                        alert(
                            "Warning, your signature will not get saved until you save the record."
                        );
                    }
                    try {
                        self.StopTopazInput();
                    } catch (e) { }
                    self.CurrentSignatureField = null;
                });
            }
        }

        var field = $("#f" + model.FieldId);
        self.SetSignatureButtonColor(model);
        if (!!field) {
            if (!!model.FieldValue) {
                self.ToggleSignatureFocus(field, true);
            } else {
                self.ToggleSignatureFocus(field, false);
            }
        }

        $(field).data("field", model);
        $(field).on("click", function (e) {
            self.CurrentSignatureField = $(this).data("field");
            self.ShowSignature(this, false);
            self.SignaturePad.off();
        });
        field.on("keydown", self.FieldKeyDown);
        field.on("focus", function (e) {
            VR.Image.TypeFromImage.SetField(model, this);
        });
    }; //SetupSignatureButton
    self.ToggleSignatureFocus = function (field, signed) {
        if (signed == true) {
            field.removeClass("btn-signature-unsigned");
            field.addClass("btn-signature-signed");
            field.text("Signed");
        } else {
            field.addClass("btn-signature-unsigned");
            field.removeClass("btn-signature-signed");
            field.text("Sign");
        }
    }; //ToggleSignatureFocus

    self.SetSignatureButtonColor = function (model) {
        var emptyPad =
            self.SignaturePad.isEmpty() && self.TopazNumberOfTabletPoints() == 0;
        var fieldValue = model.Cleared || !model.FieldValue;
        if (emptyPad && fieldValue) {
            $("#f" + model.FieldId).css("background", "#22B3FC");
            $("#f" + model.FieldId).css("color", "#FFFFFF");
        } else {
            $("#f" + model.FieldId).css("background", "#FFFFFF");
            $("#f" + model.FieldId).css("color", "#555555");
        }
    }; //SetSignatureButtonColor
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up the text box control.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupTextBox = function (model) {
        var field = $("#f" + model.FieldId);
        field.attr("autocomplete", "off");
        field.attr("spellcheck", model.SpellCheck);
        $(field).val(model.FieldValue);
        $(field).on("keypress", function (e) {
            var model = $(this).data("field");
            if (model && model.FieldStatus != null) {
                self.ResetField(this, true);
            }
        });

        $(field).on("keydown", self.FieldKeyDown);
        $(field).on("keyup", self.FieldKeyUp);

        $(field).on("focus", function (e) {
            // Only select if not already processing to prevent loops
            if (!$(this).data('selecting')) {
                $(this).data('selecting', true);
                try {
                    $(this).select();
                } finally {
                    var $this = $(this);
                    setTimeout(function () {
                        $this.data('selecting', false);
                    }, 100);
                }
            }
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });

        if ($(field).val() != model.FieldValue) {
            $(this).data("casing", "ignore"); // Does this line do anything calls (_this_) not (_field_)
            // should this line be removed?
        }
    }; //SetupTextBox

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the TIFF image editor accept button.
        /// </summary>
        /// <returns></returns>*/
    self.SetupTiffEditAccept = function () {
        $("#tiffeditor-acceptbutton").on("click", function () {
            var imagedit = $("#tiffeditor-editsection");
            var id = imagedit.attr("data-editor");
            var editor = $("#" + id);
            var images = editor.find("img");
            var size = images.length;
            var changed = false;
            size = parseInt(size);
            for (var i = 0; i < size; i++) {
                var tiffpage = $("#tiffeditor-pagesection" + (i + 1));
                var imageedit = $("#tiffeditor-page" + (i + 1));
                var croped = tiffpage.attr("mode");
                if (croped == "1") {
                    var canvas = $("#tiffeditor-canvas" + (i + 1));
                    if (canvas.length > 0) {
                        var canvas = canvas.find("img");
                        if (canvas.length > 0) {
                            var data = $(canvas).attr("src");
                            if (data) {
                                var image = editor.find("img[data-page-number='" + i + "']");
                                image.attr("src", data);
                                changed = true;
                            }
                        }
                    }
                }
            }

            var changed = editor.attr("data-changed");
            if (!changed) {
                changed = "";
            }
            if (changed.indexOf("image") == -1) {
                changed += "|image";
            }

            var canvases = $("#tiffeditor-annotationsection").data("canvas");
            var parent = editor.parents(".k-window");
            parent = parent.find("canvas");
            if (parent.length > 1) {
                parent = $(parent[0]);
            }
            parent = parent.parent();
            var targets = parent.data("canvas");
            if (targets && targets.length > 0) {
                $.each(canvases, function (index, canvas) {
                    if (index < targets.length) {
                        var target = targets[index];
                        var cropped = $("#tiffeditor-pagesection" + (index + 1)).attr(
                            "mode"
                        );
                        if (cropped == "1") {
                            var image = editor.find("img[data-page-number='" + index + "']");
                            var canvasid = id.replace("-editor", "-canvas");
                            VR.Image.Annotation.RecreateTiffAnnote(
                                index,
                                image,
                                "tiffeditor-canvasannote",
                                canvasid
                            );
                        } else {
                            VR.Image.Annotation.Copy(canvas, target);
                        }
                    }
                });
            }

            var jsons = "";
            $.each(canvases, function (index, canvas) {
                var object;
                var cropped = $("#tiffeditor-pagesection" + (index + 1)).attr("mode");
                if (cropped == "1") {
                    var annote = $("#tiffeditor-canvasannote" + (index + 1));
                    object = annote.data("canvas");
                } else {
                    object = canvas;
                }

                var json = "";
                if (object) {
                    json = object.toJSON([
                        "order",
                        "originalText",
                        "originalWidth",
                        "originalHeight"
                    ]);
                    json = JSON.stringify(json);
                }
                jsons += json + "|";
            });

            if (jsons.length > 0) {
                jsons = jsons.substring(0, jsons.length - 1);
            }

            var width = "";
            var height = "";
            if (canvases && canvases.length > 0) {
                for (var i = 0; i < canvases.length; i++) {
                    var cropped = $("#tiffeditor-pagesection" + (i + 1)).attr("mode");
                    if (cropped == "1") {
                        var annote = $("#tiffeditor-canvasannote" + (i + 1));
                        var object = annote.data("canvas");
                        width += object.getWidth() + "|";
                        height += object.getHeight() + "|";
                    } else {
                        width += canvases[i].getWidth() + "|";
                        height += canvases[i].getHeight() + "|";
                    }
                }
            }

            editor.attr("annotation", jsons);
            editor.attr("annote-width", width);
            editor.attr("annote-height", height);

            if (changed.indexOf("annote") == -1) {
                changed += "|annote";
            }
            editor.attr("data-changed", changed);

            $("#tiffeditor-modal").modal("hide");
        });
    }; //SetupTiffEditAccept

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the TIFF image editor buttons.
        /// </summary>
        /// <returns></returns>*/
    self.SetupTiffEditorButtons = function () {
        $("#tiffeditor-buttons")
            .find(".btn-imageedit")
            .tooltip({
                container: "body",
                trigger: "hover"
            });

        $("#tiffeditor-dragbutton").on("click", function (e) {
            var tiffpage = self.GetCurrentTiffEditorPage();
            var item = tiffpage.find(".cropper-modal");
            item.css("opacity", "0");
            item = tiffpage.find(".cropper-crop-box");
            item.css("display", "none");
            var editor = self.GetCurrentTiffEditor();
            editor.cropper("setDragMode", "move");
            $("#tiffeditor-dragbutton").addClass("active");
            $("#tiffeditor-cropbutton").removeClass("active");
            tiffpage.attr("mode", "0");
        });

        $("#tiffeditor-cropbutton").on("click", function (e) {
            var tiffpage = self.GetCurrentTiffEditorPage();

            var item = tiffpage.find(".cropper-modal");
            item.css("opacity", "0.5");
            item = tiffpage.find(".cropper-crop-box");
            item.css("display", "");
            var editor = self.GetCurrentTiffEditor();
            editor.cropper("setDragMode", "crop");
            $("#tiffeditor-dragbutton").removeClass("active");
            $("#tiffeditor-cropbutton").addClass("active");
            tiffpage.attr("mode", "1");
            VR.Image.Annotation.HideAnnotation(true);
        });

        $("#tiffeditor-getimagebutton").on("click", function (e) {
            var section = $("#tiffeditor-editsection");
            var size = section.attr("data-image-size");
            var page = section.attr("data-page-number");
            size = parseInt(size);
            page = parseInt(page);
            if (isNaN(page) || page < 0 || page >= size) {
                return;
            }

            var tiffpage = $("#tiffeditor-pagesection" + (page + 1));
            var item = tiffpage.find(".cropper-crop-box");
            var display = item.css("display");
            if (display == "none") {
                return;
            }

            //var editor = $("#tiffeditor-page" + (page + 1));
            //var width;
            //var height;
            //if ($(window).width() >= 768) {
            //    var imageData = editor.cropper('getCanvasData');
            //    var width = Math.round(imageData.width) + "px";
            //    var height = Math.round(imageData.height) + "px";
            //} else {
            //    var modal = $("#tiffeditor-modal");
            //    var size = self.SetImageEditorSize(modal);
            //    var width = size.width + "px";
            //    var height = size.height + "px";
            //}
            //var canvas = editor.cropper("getCroppedCanvas");
            //$(canvas).css("max-height", height);
            //$(canvas).css("max-width", width);
            //var canvassection = $("#tiffeditor-canvas" + (page + 1));
            //canvassection.html(canvas);
            //canvassection.css("display", "");
            for (var i = 1; i <= size + 1; i++) {
                if (i !== page + 1) {
                    $("#tiffeditor-canvas" + i).css("display", "none");
                    $("#tiffeditor-canvasannote" + i).css("display", "none");
                }
            }

            var editor = $("#tiffeditor-page" + (page + 1));
            var annote = $("#tiffeditor-annotate" + (page + 1));
            var cropped = $("#tiffeditor-canvas" + (page + 1));
            var cropannote = $("#tiffeditor-canvasannote" + (page + 1));
            var cropbox = $(".cropper-crop-box");
            VR.Image.CreateCroppedImage(
                tiffpage,
                editor,
                annote,
                cropped,
                cropannote,
                cropbox
            );

            $("#tiffeditor-buttons")
                .find(".btn-cropbutton")
                .css("visibility", "hidden");
            $("#tiffeditor-slidebars").css("visibility", "hidden");
            tiffpage.attr("data-cropped", "1");
            tiffpage.css("display", "none");
            var canvases = $("#tiffeditor-canvassection,#tiffeditor-canvasannote");
            canvases.css("display", "");
            section.css("display", "none");
        });

        $("#tiffeditor-resetbutton").on("click", function (e) {
            var section = $("#tiffeditor-editsection");
            var size = section.attr("data-image-size");
            for (var i = 0; i < size; i++) {
                var tiffpage = $("#tiffeditor-pagesection" + (i + 1));
                if (i == 0) {
                    tiffpage.css("display", "");
                } else {
                    tiffpage.css("display", "none");
                }
                var editor = $("#tiffeditor-page" + (i + 1));
                editor.cropper("reset");
                editor.attr("data-scaleX", "");
                editor.attr("data-scaleY", "");
                tiffpage.attr("data-cropped", "");
                var canvassection = $("#tiffeditor-canvas" + (i + 1));
                canvassection.css("display", "none");

                var item = tiffpage.find(".cropper-modal");
                item.css("opacity", "0");
                item = tiffpage.find(".cropper-crop-box");
                item.css("display", "none");
                editor.cropper("setDragMode", "move");
                tiffpage.attr("mode", "0");
            }

            section.css("display", "").attr("data-page-number", "0");
            $("#tiffeditor-canvassection,#tiffeditor-canvasannote").css(
                "display",
                "none"
            );
            $("#tiffeditor-buttons")
                .find(".btn-cropbutton")
                .css("visibility", "visible");
            $("#tiffeditor-slidebars").css("visibility", "visible");
            $("#tiffeditor-dragbutton").trigger("click");
            VR.Image.Annotation.ShowAnnotation(true);
            VR.Image.SlideBars.ResetTiff();
        });

        $("#tiffeditor-prevbutton").on("click", function (e) {
            var section = $("#tiffeditor-editsection");
            var size = section.attr("data-image-size");
            var page = section.attr("data-page-number");
            size = parseInt(size);
            page = parseInt(page);
            if (isNaN(page) || page < 1) {
                return;
            }
            page--;
            self.SetTiffEditorPage(section, page, size);
            VR.Image.Annotation.SetTiffEditorPage(page);
        });

        $("#tiffeditor-nextbutton").on("click", function (e) {
            var section = $("#tiffeditor-editsection");
            var size = section.attr("data-image-size");
            var page = section.attr("data-page-number");
            size = parseInt(size);
            page = parseInt(page);
            if (isNaN(page) || page + 1 >= size) {
                return;
            }
            page++;
            self.SetTiffEditorPage(section, page, size);
            VR.Image.Annotation.SetTiffEditorPage(page);
        });

        $("#tiffeditor-firstbutton").on("click", function (e) {
            var section = $("#tiffeditor-editsection");
            var size = section.attr("data-image-size");
            size = parseInt(size);
            if (isNaN(size)) {
                return;
            }
            self.SetTiffEditorPage(section, 0, size);
            VR.Image.Annotation.SetTiffEditorPage(0);
        });

        $("#tiffeditor-lastbutton").on("click", function (e) {
            var section = $("#tiffeditor-editsection");
            var size = section.attr("data-image-size");
            size = parseInt(size);
            if (isNaN(size)) {
                return;
            }
            self.SetTiffEditorPage(section, size - 1, size);
            VR.Image.Annotation.SetTiffEditorPage(size - 1);
        });

        $("#tiffeditor-annotetoggle").on("click", function () {
            var page = VR.Image.GetCurrentEditorPage();
            var tiffpage = $("#tiffeditor-pagesection" + (page + 1));
            var cropped = tiffpage.attr("data-cropped");
            if (cropped) {
                var page = $("#tiffeditor-canvasannote" + (page + 1));
                var display = page.css("display");
                if (display != "none") {
                    page.css("display", "none");
                } else {
                    page.css("display", "");
                }
            } else if (VR.Image.Annotation.IsHidden(true)) {
                $("#tiffeditor-resetbutton").trigger("click");
            } else {
                VR.Image.Annotation.HideAnnotation(true);
            }
        });

        $("#tiffeditor-editannot").on("click", function () {
            var page = VR.Image.GetCurrentEditorPage();
            var tiffpage = $("#tiffeditor-pagesection" + (page + 1));
            var cropped = tiffpage.attr("data-cropped");
            if (!cropped) {
                var section = $("#tiffeditor-editsection");
                var size = section.attr("data-image-size");
                size = parseInt(size);
                $("#tiffeditor-resetbutton").trigger("click");
                self.SetTiffEditorPage(section, page, size);
                VR.Image.Annotation.SetTiffEditorPage(page);
                VR.Image.Annotation.ShowAnnotationEditor(
                    "tiffeditor-editsection",
                    "tiffeditor-annotationsection"
                );
            } else {
                page++;
                var annote = "tiffeditor-canvasannote" + page;
                var cropped = "tiffeditor-canvas" + page;
                VR.Image.Annotation.ShowCroppedAnnoteEditor(cropped, annote);
            }
        });
    }; //SetupTiffEditorButtons

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the TIFF image viewer buttons.
        /// </summary>
        /// <returns></returns>*/
    self.SetupTiffViewerButtons = function (windowHost) {
        var buttons = windowHost.find(
            ".imageviewer-firstbutton, .imageviewer-prevbutton, .imageviewer-nextbutton, .imageviewer-lastbutton"
        );
        buttons.tooltip({
            container: "body",
            placement: "bottom",
            trigger: "hover"
        });

        buttons.on("click", function (e) {
            var section = windowHost.find(".imageviewer-imagesection");
            var pagenum = section.attr("data-page-number");
            var size = section.attr("data-pages");
            pagenum = parseInt(pagenum);
            size = parseInt(size);
            if (isNaN(pagenum) || isNaN(size)) {
                return;
            }

            if ($(this).hasClass("imageviewer-firstbutton")) {
                pagenum = 0;
            } else if ($(this).hasClass("imageviewer-lastbutton")) {
                pagenum = size - 1;
            } else if ($(this).hasClass("imageviewer-prevbutton")) {
                pagenum--;
                if (pagenum < 0) {
                    pagenum = 0;
                }
            } else {
                pagenum++;
                if (pagenum >= size) {
                    pagenum = size - 1;
                }
            }

            var images = section.find("img");
            $.each(images, function (index, image) {
                var num = $(image).attr("data-page-number");
                num = parseInt(num);
                if (isNaN(num)) {
                    return;
                }

                if (num == pagenum) {
                    $(image).css("display", "");
                } else {
                    $(image).css("display", "none");
                }
            });

            var canvases = windowHost.find("canvas");
            $.each(canvases, function (index, canvas) {
                var display = "none";
                if (index == pagenum) {
                    display = "";
                }
                $(canvas).css("display", display);
            });

            section.attr("data-page-number", pagenum);
            var page = section.find(".imageviewer-pagenumber");
            page.html("Page " + (pagenum + 1) + " of " + size);
        });
    }; //SetupTiffViewerButtons

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the TIFF image editor save buttons.
        /// </summary>
        /// <returns></returns>*/
    self.SetupTiffSaveButtons = function () {
        $("#tiffeditor-savetodatabse, #tiffeditor-savetofile").on("click", function (
            e
        ) {
            $("#tiffeditor-modal").modal("hide");
            var location = "D";
            var id = $(this).attr("id");
            if (id == "tiffeditor-savetofile") {
                location = "P";
            }

            var event = self.EventName;
            var appfunc = $("#tiffeditor-appfunction");
            if (appfunc.length == 0) {
                appfunc = "";
            } else {
                appfunc = appfunc.val();
            }
            var isactive = $("#tiffeditor-isactive");
            if (isactive.length == 0) {
                isactive = true;
            } else {
                isactive = isactive.attr("checked");
                if (isactive == "checked") {
                    isactive = true;
                }
            }
            var description = $("#tiffeditor-description").val();
            var section = $("#tiffeditor-editsection");
            var size = section.attr("data-image-size");
            size = parseInt(size);
            var data = "";
            for (var i = 0; i < size; i++) {
                var tiffpage = $("#tiffeditor-pagesection" + (i + 1));
                var cropped = tiffpage.attr("data-cropped");
                if (cropped && cropped == "1") {
                    var canvas = $("#tiffeditor-canvas" + (i + 1) + " > img");
                    if (canvas.length > 0) {
                        data += "!" + canvas.attr("src");
                    }
                } else {
                    var page = $("#tiffeditor-page" + (i + 1));
                    data += "!" + page.attr("src");
                }
            }

            if (data) {
                data = data.substring(1).replace(/\+/g, "#");
            }

            var annote = VR.Image.Annotation.TiffJsonString(
                "tiffeditor-annotationsection"
            );

            var year = self.GetFieldValue("EVENT_YEAR");
            var number = self.GetFieldValue("STATE_FILE_NUMBER", true);

            var url = VR.Common.GetRootURL("event/edit") + "data/tifffilesave";
            var selection = {
                EventGroup: event,
                eventId: self.EventId,
                appfunc: appfunc,
                isactive: isactive,
                description: description,
                location: location,
                size: size,
                year: year,
                number: number,
                annote: annote.jsons,
                width: annote.widths,
                height: annote.heights,
                data: data
            };
            VR.Common.SecurePost(
                url,
                { imageLoad: selection },
                function (result) {
                    if (result.Code != 0 || result.Image == null) {
                        VR.Common.HandleInvalidResult(result, "Tiff File Load", false);
                    } else {
                        var list = $("#image-list");
                        list.find(".image").off("dblclick");
                        var images = self.ImageDataSource.data();
                        if (images.length == 0) {
                            images = [];
                        }
                        images.push(result.Image);
                        self.ImageDataSource.data(images);

                        var pager = $("#image-pager").data("kendoPager");
                        if (pager) {
                            pager.refresh();
                        }
                        var kendoList = list.data("kendoListView");
                        if (kendoList) {
                            kendoList.refresh();

                            $("#image-list .image").on("dblclick", function (e) {
                                var imageId = this.id;
                                if (imageId.indexOf("image-") > -1) {
                                    imageId = imageId.substring("image-".length);
                                }
                                var urlParams = new URLSearchParams(window.location.search);
                                var eventEditParam = urlParams.get('selection') || "";
                                var url = VR.Common.GetRootURL();
                                window.open(url + "event/imagewindow?" + eventEditParam + "&vrsimageid=" + imageId, "_blank", "popup=1,menubar=no,toolbar=no,status=no,resizable=yes,fullscreen=yes");
                            });
                        }

                        self.ImageCount++;
                        if (VR.Common.IsMobile()) {
                            $("#mobileImagesBtnText").html(VR.Common.HtmlEscape(self.ImageCount));
                        }
                        else {
                            $("#images-count").html("Image count: " + VR.Common.HtmlEscape(self.ImageCount));
                        }
                    }
                },
                true,
                undefined,
                false,
                false
            );
        });
    }; //SetupTiffSaveButtons

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the timer picker.
        /// </summary>
        /// <param name="model">The field model.</param>
        /// <returns></returns>*/
    self.SetupTimePicker = function (model) {
        var format = model.InputFormat;
        if (!format || format == "") {
            format = "HH:mm";
        }

        var input = $("#f" + model.FieldId);
        input.attr("autocomplete", "off");
        input.kendoTimePicker({
            format: format
        });
        $(input).data("kendoTimePicker").readonly(!model.CanEdit);

        input.on("keydown", self.FieldKeyDown);
        input.on("keyup", self.FieldKeyUp);
        input.on("focus", function (e) {
            // Only select if not already processing to prevent loops
            if (!$(this).data('selecting')) {
                $(this).data('selecting', true);
                try {
                    $(this).select();
                } finally {
                    var $this = $(this);
                    setTimeout(function() {
                        $this.data('selecting', false);
                    }, 100);
                }
            }
            VR.Image.TypeFromImage.SetField(model, this);
            VR.Edit.LastFocusedField = model.FieldId;
        });
    }; //SetupTimePicker

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the type from image.
        /// </summary>
        /// <returns></returns>*/
    self.SetupTypeFromImage = function () {
        VR.Image.TypeFromImage.Setup();
    }; //SetupTypeFromImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Setsup the view images.
        /// </summary>
        /// <returns></returns>*/
    self.SetupViewImage = function () {
        // Create image list window dynamically if it doesn't exist
        if ($("#imagelist-window").length === 0) {
            $("body").append('<div id="imagelist-window" style="display:none;"><div><p class="edit-header" style="text-align:right;"><button id="image-button-refresh" type="button" class="btn btn-info">Refresh</button><button id="view-new-window-button" type="button" class="btn btn-success">View in New Window</button><button type="button" class="btn btn-warning">Inactivate</button><button type="button" class="btn btn-danger">Delete</button><button type="button" class="btn btn-primary">Close</button></p><p><div id="image-list"></div><div id="image-pager" class="k-pager-wrap" data-testid="image-pager"></div></p></div></div>');
        }

        var eventHandler = function (e) {
            var kendoWindow = $("#imagelist-window").data("kendoWindow");
            if (!kendoWindow) {
                var height = self.NavHeight;
                height = VR.Common.ToFloat(height) + 10;
                var top = height + "px";

                var listWindow = $("#imagelist-window");
                listWindow.kendoWindow({
                    animation: false,
                    position: {
                        top: top,
                        left: "10%"
                    },
                    width: "80%",
                    title: "Images/Documents",
                    actions: ["Pin", "Close"],
                    close: function (e) {
                        setTimeout(function () {
                            $(".k-window").css("z-index", "1000");
                        }, 1000);
                    },
                    open: function (e) {
                        var elemenet = listWindow.parents(".k-window");
                        elemenet.css("z-index", "1000");
                    },
                    visible: false
                });

                listWindow.find(".btn-success").on("click", function (e) {
                    var listview = $("#image-list").data("kendoListView");
                    var selected = listview.select();
                    if (selected.length > 0) {
                        self.ShowImageWindow(selected[0].id);
                    }
                });

                var button = listWindow.find(".btn-danger");
                if (!self.ImageSecurity || !self.ImageSecurity.CanDelete) {
                    button.css("display", "none");
                } else {
                    button.on("click", function () {
                        var listview = $("#image-list").data("kendoListView");
                        var selected = listview.select();
                        if (selected.length > 0) {
                            self.ImageId = selected[0].id;
                            VR.Common.ShowMessageBox(
                                "Do you want to delete this item?",
                                self.DeleteImage,
                                true
                            );
                        }
                    });
                }

                button = listWindow.find(".btn-warning");
                if (!self.ImageSecurity || !self.ImageSecurity.CanInactivate) {
                    button.css("display", "none");
                } else {
                    button.on("click", function () {
                        var listWindow = $("#image-list").data("kendoListView");
                        var selected = listWindow.select();
                        if (selected.length > 0) {
                            self.InactivateImage(selected[0].id);
                        }
                    });
                }

                // Setup View in New Window button
                $("#view-new-window-button").on("click", function () {
                    var listview = $("#image-list").data("kendoListView");
                    if (listview) {
                        var selected = listview.select();
                        if (selected.length > 0) {
                            var imageId = selected[0].id;
                            if (imageId.indexOf("image-") > -1) {
                                imageId = imageId.substring("image-".length);
                            }

                            // Get eventedit parameter from current URL
                            var urlParams = new URLSearchParams(window.location.search);
                            var eventEditParam = urlParams.get('selection') || "";
                            var url = VR.Common.GetRootURL();
                            window.open(url + "event/imagewindow?" + eventEditParam + "&vrsimageid=" + imageId, "_blank", "popup=1,menubar=no,toolbar=no,status=no,resizable=yes,fullscreen=yes");
                        } else {
                            alert("Please select an image first.");
                        }
                    }
                });        

                // Setup refresh button
                $("#image-button-refresh").on("click", function () {
                    nxLoading.start("Refreshing images/documents. Please wait...");
                    // Properly close and destroy Kendo windows for image viewers
                    $(".image-window").each(function () {
                        var kendoWindow = $(this).data("kendoWindow");
                        if (kendoWindow) {
                            kendoWindow.destroy();
                        }
                    });

                    // Clear the container
                    $("#image-windows").empty();

                    nxLoading.end();
                });

                listWindow.find(".btn-primary").on("click", function () {
                    $("#imagelist-window")
                    .data("kendoWindow")
                    .close();
                });

                if (VR.Common.IsMobile()) {
                    var parents = listWindow.parents(".k-window");
                    var handle = parents.find(".k-resize-se");
                    handle.css("opacity", "1");
                    handle.css("background-color", "#66f");
                    handle.css("z-index", "1010");
                    handle.css("width", "32px");
                    handle.css("height", "32px");
                }

                $("#image-pager").kendoPager({
                    dataSource: self.ImageDataSource,
                    dataBound: function(e) {
                        var pager = $("#image-pager");
                        if (pager.length > 0) {
                            pager.attr('id', 'image-list-pager').attr('data-testid', 'image-list-pager');
                            
                            // Add IDs to pager buttons
                            pager.find('.k-pager-first').attr('id', 'image-pager-first-btn').attr('data-testid', 'image-pager-first-btn');
                            pager.find('.k-pager-prev').attr('id', 'image-pager-prev-btn').attr('data-testid', 'image-pager-prev-btn');
                            pager.find('.k-pager-next').attr('id', 'image-pager-next-btn').attr('data-testid', 'image-pager-next-btn');
                            pager.find('.k-pager-last').attr('id', 'image-pager-last-btn').attr('data-testid', 'image-pager-last-btn');
                            
                            // Add IDs to page number buttons
                            pager.find('.k-link[data-page]').each(function(index) {
                                var pageNum = $(this).attr('data-page');
                                $(this).attr('id', 'image-pager-page-' + pageNum).attr('data-testid', 'image-pager-page-' + pageNum);
                            });
                            
                            // Add IDs to page size dropdown components
                            var pageSizes = pager.find('.k-pager-sizes');
                            if (pageSizes.length > 0) {
                                pageSizes.attr('id', 'image-pager-sizes-container').attr('data-testid', 'image-pager-sizes-container');
                                
                                // Add IDs to the dropdown picker
                                pageSizes.find('.k-picker').attr('id', 'image-pager-sizes-picker').attr('data-testid', 'image-pager-sizes-picker');
                                
                                // Add IDs to the input inner span
                                pageSizes.find('.k-input-inner').attr('id', 'image-pager-sizes-input').attr('data-testid', 'image-pager-sizes-input');
                                
                                // Add IDs to the dropdown button
                                pageSizes.find('.k-input-button').attr('id', 'image-pager-sizes-button').attr('data-testid', 'image-pager-sizes-button');
                                
                                // Add IDs to the select element
                                pageSizes.find('select').attr('id', 'image-pager-page-size').attr('data-testid', 'image-pager-page-size');
                            }
                            
                            // Add ID to page info
                            pager.find('.k-pager-info').attr('id', 'image-pager-info').attr('data-testid', 'image-pager-info');
                        }
                    }
                });

                $("#image-list").kendoListView({
                    dataSource: self.ImageDataSource,
                    selectable: true,
                    template: "<div id='image-#= ImageId #' class='image' role='button' tabindex='0' aria-label='Image: #= Description #. Status: #= IsActive ? 'Active' : 'Inactive' #. Double-click to open.' data-testid='image-item-#= ImageId #'><img id='thumbnail-#= ImageId #' class='list-image' src='#= ImageSource #' alt='#= Description #' role='img' data-testid='thumbnail-#= ImageId #' /><div><label id='desc-label-#= ImageId #' for='thumbnail-#= ImageId #' data-testid='desc-label-#= ImageId #'>#= Description #</label></div><div><label id='status-label-#= ImageId #' data-testid='status-label-#= ImageId #'>Active: #= IsActive #</label></div><div><label id='date-label-#= ImageId #' data-testid='date-label-#= ImageId #'>Created: #= DateCreated ? kendo.toString(kendo.parseDate(DateCreated), 'MM/dd/yyyy') : 'N/A' #</label></div></div>",
                    dataBound: function(e) {
                        var listView = e.sender;
                        if (listView.dataSource.total() > 0) {
                            setTimeout(function() {
                                listView.select(listView.element.find(".k-listview-item:first"));
                            }, 100);
                        }
                    }
                });

                // Add click handler to ensure selection works with Playwright
                $(document).on('click', '#image-list .image', function(e) {
                    var listView = $("#image-list").data("kendoListView");
                    if (listView) {
                        listView.select($(this));
                    }
                });
                // Add event delegation for double-click on images
                $(document).on('dblclick', '#image-list .image', function(e) {
                    var imageId = this.id;
                    if (imageId.indexOf("image-") > -1) {
                        imageId = imageId.substring("image-".length);
                    }
                    var urlParams = new URLSearchParams(window.location.search);
                    var eventEditParam = urlParams.get('selection') || "";
                    var url = VR.Common.GetRootURL();
                    window.open(url + "event/imagewindow?" + eventEditParam + "&vrsimageid=" + imageId, "_blank", "popup=1,menubar=no,toolbar=no,status=no,resizable=yes,fullscreen=yes");
                });

                // Background color now handled in CSS

                var parent = $("#image-list").parents(".k-window");
                parent.css("z-index", "1000");

                $("#imagelist-window").css("display", "");
            }
            self.ShowImageList();
        };

        // Set up event handler for available trigger elements
        var triggerElements = $("#images-count, #imagelist-menu, [data-action='images']");
        if (triggerElements.length > 0) {
            triggerElements.on(VR.Common.IsNavBurger() ? "touchend" : "click", eventHandler);
        } else {
            // Fallback: create a temporary trigger and expose the function globally
            window.showImageList = eventHandler;
        }
        let imagesBtn = $("#images-count");
        if (VR.Common.IsMobile()) {
            if (self.EventId === 0) {
                imagesBtn.css("display", "none");
            } else {
                imagesBtn.removeClass();
                imagesBtn.addClass("glyphicon glyphicon-picture");
                imagesBtn.html(`<span id="mobileImagesBtnText">${self.ImageCount}</span>`);
                imagesBtn.css({ "font-size": "30px", "display": "inline", "padding": "10px 8px 10px 12px", "margin-right": "10px" });
                $("#mobileImagesBtnText").css({ "font-size": "30px", "position": "relative", "top": "-5px", "left": "5px", "color": "black", "font-weight": "bold" });
                imagesBtn.on("touchend", eventHandler);
            }
        }
        else {
            imagesBtn.on("dblclick", eventHandler);
            imagesBtn.on("keydown", function (e) {
                if (e.which === 13 || e.which === 32)
                    eventHandler(e);
            });
        }
        
        // Expose function globally for testing
        window.testImageViewer = eventHandler;
    }; //SetupViewImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Sets up window key down event handler.
        /// </summary>
        /// <returns></returns>*/
    self.SetupWindowKeyDown = function () {
        if ("onhelp" in window) {
            window.onhelp = function (e) {
                return false;
            };
        }

        $(window).on("keydown", function (e) {
            VR.Common.ShowFieldHelp(e);
        });
    }; //SetupWindowKeyDown

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Shows image/document window.
        /// </summary>
        /// <param name="id">The element Id.</param>
        /// <returns></returns>*/
    self.ShowImage = function (id) {
        if (id.indexOf("image-") > -1) {
            id = id.substring("image-".length);
            id = parseInt(id);
        }
        var selected = null;
        $.each(self.ImageDataSource.data(), function (index, model) {
            if (model.ImageId == id) {
                selected = model;
                return false;
            }
        });

        if (!selected) {
            return;
        }

        var type = selected.Extension;
        if (type) {
            type = type.toLowerCase();
        }

        var isImage = false;
        switch (type) {
            case "bmp":
            case "gif":
            case "tiff":
            case "jpeg":
            case "png":
                isImage = true;
                break;
        }

        var windowHost = $("#" + id + "-window");
        if (windowHost.length > 0) {
            var editor = $("#" + id + "-editor");
            editor.attr("data-changed", "");
            if (!isImage && type != "pdf") {
                var html = editor.html();
                editor.html(html);
            }
            var imageWindow = windowHost.data("kendoWindow");
            var elemenet = windowHost.parents(".k-window");
            elemenet.css("z-index", "1000");
            imageWindow.open();
        } else {
            $("#imagelist-message").html("Loading image/document. Please wait...");

            var url = VR.Common.GetRootURL("event/edit") + "data/image";
            VR.Common.SecurePost(
                url,
                "image-" + id,
                function (result) {
                    if (result.Code != 0) {
                        $("#imagelist-message").html("");
                        VR.Common.HandleInvalidResult(result, "Image", false);
                    } else if (result.Images) {
                        $("<div id='" + id + "-window' class='image-window'/>").appendTo(
                            "#image-windows"
                        );

                        windowHost = self.CreateImageWindow(id, result);
                        var html = self.CreateImageViewer(result, selected);

                        // Insert images into the proper display area
                        var imageDisplayArea = windowHost.find('.image-display-area #' + id + '-editor');
                        if (imageDisplayArea.length > 0) {
                            imageDisplayArea.html(html);
                        } else {
                            // Fallback to editor if display area not found
                            var editor = $("#" + id + "-editor");
                            editor.html(html);
                        }

                        /* Insert the standard pager  */
                        if (result.Images.length > 1) {
                            setTimeout(function () {
                                var pagerElement = $("#imageviewer-pager-" + id);
                                if (pagerElement.length > 0) {
                                    var imageDataSource = new kendo.data.DataSource({
                                        data: result.Images,
                                        pageSize: 1,
                                        page: 1
                                    });

                                    pagerElement.kendoPager({
                                        dataSource: imageDataSource,
                                        buttonCount: 5,
                                        info: true,
                                        previousNext: true,
                                        dataBound: function (e) {
                                            var pager = $("#imageviewer-pager-" + id);
                                            pager.find('.k-pager-first').attr('id', 'imageviewer-first-btn-' + id);
                                            pager.find('.k-pager-prev').attr('id', 'imageviewer-prev-btn-' + id);
                                            pager.find('.k-pager-next').attr('id', 'imageviewer-next-btn-' + id);
                                            pager.find('.k-pager-last').attr('id', 'imageviewer-last-btn-' + id);
                                        },
                                        change: function (e) {
                                            var currentPage = e.sender.page();
                                            $("[id^='page-image-" + id + "-']").hide();
                                            $("#page-image-" + id + "-" + (currentPage - 1)).show();
                                        }
                                    });

                                    // Force the dataSource to read
                                    imageDataSource.read();
                                }
                            }, 100);
                        }

                        var editor = $("#" + id + "-editor");
                        editor.attr("data-changed", "");

                        self.SetupTiffViewerButtons(windowHost);

                        windowHost.find(".btn-warning").on("click", function () {
                            VR.Print.PrintDialog(function (args) {
                                if (args.isCancelled) {
                                    return;
                                }
                                var printImages = VR.Image.Generate(id, args, function (images) {
                                    //VR.Print.ImagePrint(images, args);
                                });
                                VR.Print.ImagePrint(printImages, args);
                            });
                        });

                        windowHost.find(".btn-default").on("click", function () {
                            VR.Image.Annotation.ToggleAnnotation(windowHost);
                        });

                        windowHost.find(".imageviewer-closebutton").on("click", function () {
                            var editor = $("#" + id + "-editor");
                            var changed = editor.attr("data-changed");
                            var backup = $("#" + id + "-backup");
                            if (changed && changed != "") {
                                var image = windowHost.data("Image");
                                var input = windowHost.find("input[type='search']");
                                var combobox = input.data("kendoComboBox");
                                if (combobox != null) {
                                    if (!image.ApplicationFunction) {
                                        combobox.value("");
                                    } else {
                                        combobox.value(image.ApplicationFunction);
                                    }
                                }

                                var isactive = windowHost.find(
                                    ".imagedit-input[type='checkbox']"
                                );
                                isactive.prop("checked", image.IsActive);
                                var description = windowHost.find(
                                    ".imagedit-input[type='text']"
                                );
                                description.val(image.Description);
                                if (changed.indexOf("image") > 0) {
                                    var html = backup.html();
                                    editor.html(html);
                                    self.SetupTiffViewerButtons(windowHost);
                                }
                            }
                            editor.attr("data-changed", "");
                            backup.html("");
                            windowHost.data("kendoWindow").close();
                        });

                        windowHost.find(".btn-info").on("click", function () {
                            var editor = $("#" + id + "-editor");
                            var backup = $("#" + id + "-backup");
                            var html = backup.html();
                            if (!html) {
                                html = editor.html();
                                backup.html(html);
                            }
                            var section = windowHost.find(".imageviewer-imagesection");
                            var annote = editor.attr("annotation");
                            var width = editor.attr("annote-width");
                            var height = editor.attr("annote-height");
                            if (!annote) {
                                var parentWindow = windowHost.data("kendoWindow");
                                annote = parentWindow.Annotation;
                                width = parentWindow.AnnotationWidth;
                                height = parentWindow.AnnotationHeight;
                            }
                            if (section.length == 0) {
                                $("#imageeditor-modal")
                                    .attr("data-annotation", annote)
                                    .attr("data-annotewidth", width)
                                    .attr("data-annoteheight", height);
                                self.EditImage(editor);
                            } else {
                                $("#tiffeditor-modal")
                                    .attr("data-annotation", annote)
                                    .attr("data-annotewidth", width)
                                    .attr("data-annoteheight", height);
                                self.EditTiffImage(editor);
                            }
                        });

                        windowHost.find(".btn-success").on("click", function () {
                            self.UpdateImage(windowHost);
                            var backup = $("#" + id + "-backup");
                            backup.html("");
                            $("#" + id + "-window").remove();
                        });

                        var info = windowHost.find(".btn-info");
                        if (isImage) {
                            info.css("display", "");
                        } else {
                            info.css("display", "none");
                        }

                        var width = "100%";  // VRS-6112 use full width of window // $(window).width() * 0.6;
                        var height = "100%";
                        var frame = windowHost.find("iframe");
                        frame.width(width);
                        frame.height(height);
                        var imageWindow = windowHost.data("kendoWindow");
                        imageWindow.open();
                        $("#imagelist-message").html("");
                    }
                },
                true,
                undefined,
                false,
                false
            ).fail(function (e) {
                $("#imagelist-message").html("");
                var message = "Get failed.";
                if (e && e.responseText) {
                    message = e.responseText;
                }
                var result = { Code: 999999, Message: message, StackInfo: "" };
                VR.Common.HandleInvalidResult(result, "Image", true);
            });
        }
    }; //ShowImage

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Shows image/document list window.
        /// </summary>
        /// <returns></returns>*/
    self.ShowImageList = function () {
        if (self.ImageListWindow != null) {
            self.ImageListWindow.open();
        } else {
            nxLoading.start("Loading images/documents. Please wait...");

            $("#image-list").html("");
            var event = self.EventName;
            var eventid = self.EventId;
            var selection = event + "-" + eventid;
            var url = VR.Common.GetRootURL("event/edit") + "data/images";
            VR.Common.SecurePost(
                url,
                selection,
                function (result) {
                    nxLoading.end();

                    // Parse the double-encoded JSON response
                    var parsedResult = result;
                    
                    if (parsedResult && parsedResult.Code != 0) {
                        VR.Common.HandleInvalidResult(parsedResult, "Images", true);
                    } else if (!parsedResult.Images || parsedResult.Images.length < 1) {
                        VR.Common.ShowInfo("No images/documents to show.");
                    } else {
                        // Process images to ensure proper data URL format
                        var processedImages = parsedResult.Images.map(function (image) {
                            if (image.ImageSource && !image.ImageSource.startsWith('data:')) {
                                image.ImageSource = 'data:;base64,' + image.ImageSource;
                            }
                            return image;
                        });
                        self.ImageDataSource.data(processedImages);


                        $("#image-pager")
                            .data("kendoPager")
                            .refresh();
                        $("#image-list")
                            .data("kendoListView")
                            .refresh();

                        // Event delegation is handled in SetupViewImage - no direct binding needed

                        // Recreate ListView to fix template rendering in new Kendo version
                        $("#image-list").kendoListView({
                            dataSource: self.ImageDataSource,
                            selectable: true,
                            template: "<div id='image-#= ImageId #' class='image'><img class='list-image' src='#= ImageSource #' alt='#= Description #' /><div><label>#= Description #</label></div><div><label>Created: #= DateCreated ? kendo.toString(kendo.parseDate(DateCreated), 'MM/dd/yyyy') : 'N/A' #</label></div><div><label>Active: #= IsActive #</label></div></div>"
                        });;

                        self.ImageListWindow = $("#imagelist-window").data("kendoWindow");
                        self.ImageListWindow.open();
                    }
                },
                true,
                undefined,
                false,
                false
            );
        }
    }; //ShowImageList

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Shows image window.
        /// </summary>
        /// <param name="id">The image Id.</param>
        /// <returns></returns>*/
    self.ShowImageWindow = function (id) {
        var selectedid = id;
        if (id && id.indexOf("image-") > -1) {
            id = id.substring("image-".length);
        }

        id = parseInt(id);
        if (isNaN(id)) {
            return;
        }

        var selected = null;
        $.each(self.ImageDataSource.data(), function (index, model) {
            if (model.ImageId == id) {
                selected = model;
                return false;
            }
        });

        if (
            selected &&
            self.ImageSecurity &&
            !selected.IsActive &&
            !self.ImageSecurity.CanDisplayInactive
        ) {
            VR.Common.ShowError("Cannot show hidden image/document.");
            return;
        }

        self.ShowImage(selectedid);
    }; //ShowImageWindow

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Shows notes.
        /// </summary>
        /// <param name="fieldId">The field Id.</param>
        /// <returns></returns>*/
    self.ShowNotes = function (fieldId) {
        $("#notes-list-body").attr("data-field-id", fieldId);
        if (self.Notes) {
            self.CreateNotesList();
            $("#noteslist-modal").modal("show");
        } else {
            nxLoading.start("Loading notes. Please wait...");

            var event = self.EventName;
            var url = VR.Common.GetRootURL("event/edit") + "data/notes";
            var selection =
                "event=" + event + "|eventId=" + self.EventId + "|field=0";
            VR.Common.SecurePost(
                url,
                selection,
                function (result) {
                    nxLoading.end();
                    if (result.Code == 0) {
                        self.CreateNotesEditor();
                        self.PopulateNotes(result);
                        $("#noteslist-modal").modal("show");
                    } else {
                        VR.Common.HandleInvalidResult(result, "Notes", false);
                    }
                },
                true,
                undefined,
                false,
                false
            );
        }
    }; //ShowNotes

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Shows popup menu.
        /// </summary>
        /// <param name="event">The event object.</param>
        /// <returns></returns>*/
    self.ShowPopupMenu = function (event) {
        if ($(event.target).attr("spellcheck") == "true" && event.which != 113)
            return;
        if (event.preventDefault) {
            event.preventDefault();
        }
        var pageInfo = "";
        if (VR.Image.Annotation.ShowPopupMenu(event)) {
            pageInfo = "none";
        }

        if (!pageInfo) {
            var parent = $(event.target).parents(".k-window");
            var pageInfo = parent.length > 0 ? "none" : ""; //Disable for k-window - treated as modal.
        }

        var isField = false;
        var isDataField = false;
        var isSign = false;
        var canNote = false;
        var hasValue = false;

        var parent = $(event.target).parents(".modal");
        var modal = parent.length > 0 ? "none" : "";
        var parent = $(event.target).parents(".edit-field");
        var target = null;
        var inputs = parent.find(".input-field");
        $.each(inputs, function (index, input) {
            var id = $(input).attr("id");
            if (id) {
                var index = id.indexOf("f");
                if (index == 0) {
                    target = input;
                    isField = true;
                    isDataField = true;
                    if (self.CanNotes && self.EventId > 0) {
                        canNote = true;
                    }
                    return false;
                }
            }
        });

        self.PopupTarget = target;
        var model = $(target).data("field");
        if ((!model || model.IsEnabled === false) && !event.target.className.includes("upper-canvas")) {
            return;
        }
        if (model && model.Case && model.Case != "" && model.Case != "normal") {
            $("#overwrite-casing-popupmenu").show();
            if ($(target).data("casing") != "ignore") {
                $("#overwrite-casing-popupmenu").text("Ignore Casing Rules");
                $(target).data("casing", "keep");
            } else {
                $("#overwrite-casing-popupmenu").text("Keep Casing Rules");
            }
        } else {
            $("#overwrite-casing-popupmenu").hide();
        }
        if (model && model.FieldType == "Signature") {
            isSign = true;
            if (model.FieldValue) {
                hasValue = true;
            }
        }

        if (
            model &&
            (model.FieldType == "hidden" ||
                model.FieldType == "Button" ||
                model.FieldType == "Grid" ||
                model.FieldType == "Image" ||
                model.FieldType == "Label" ||
                model.FieldType == "Signature")
        ) {
            isDataField = false;
        }

        if (isField) {
            isField = "";
        } else {
            isField = "none";
        }

        $("#fieldinfo-popupmenu").css("display", isField);
        if (
            isDataField &&
            ($(target).attr("readonly") ||
                $(target).hasClass("readonly-text") ||
                $(target).hasClass("aria-readonly") ||
                !model.IsEditable)
        ) {
            isDataField = false;
        }

        if (isDataField) {
            isDataField = "";
        } else {
            isDataField = "none";
        }

        $("#fieldquery-popupmenu").css("display", isDataField);
        $("#fieldreset-popupmenu").css("display", isDataField);
        $("#clearfield-popupmenu").css("display", isDataField);
        $("#defaultvalue-popupmenu").css("display", isDataField);

        if (
            model &&
            (model.FieldType == "CheckBox" || model.FieldType == "RadioButton")
        ) {
            isDataField = "none";
        }

        $("#currentdate-popupmenu").css("display", isDataField);

        if (canNote) {
            canNote = "";
        } else {
            canNote = "none";
        }

        $("#notes-popupmenu").css("display", canNote);

        if (isSign) {
            isSign = "";
        } else {
            isSign = "none";
        }

        $("#editsign-popupmenu").css("display", isSign);

        if (hasValue) {
            hasValue = "";
        } else {
            hasValue = "none";
        }
        $("#viewsign-popupmenu").css("display", hasValue);
        var top = event.pageY;
        var left = event.pageX;
        if (!top) top = $(event.target).offset().top;
        if (!left) left = $(event.target).offset().left;
        if (event.target.className.includes("upper-canvas")) {
            $("#scripteditor-popupmenu").css("display", "none");
        }
        else {
            $("#scripteditor-popupmenu").css("display", "");
        }
        $(".custom-menu")
            .finish()
            .toggle(100)
            .css({ top: top + "px", left: left + "px" });
    }; //ShowPopupMenu

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Shows save error messsage.
        /// </summary>
        /// <param name="message">The error message.</param>
        /// <param name="noescape">The value to indicate if message should not be escaped.</param>
        /// <returns></returns>*/
    self.ShowSaveError = function (message, noescape) {
        if (!noescape) {
            message = VR.Common.HtmlEscape(message);
        }

        message = message.replace(/\n/g, "<br />");

        VR.Common.ShowError(
            "<p>Error(s) occured during save.</p>" + message,
            "Save Error",
            noescape
        );
    }; //ShowSaveError

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Initializes Topaz signature device.
        /// </summary>
        /// <param name="canvas">The drawing canvas.</param>
        /// <returns></returns>*/
    self.StartTopazInput = function (context) {
        try {
            var retmod = 0;
            self.SignaturePad.TopazTmr = null;
            SetTabletState(1);
            retmod = TabletModelNumber();
            SetTabletState(0);
            if (retmod == 11 || retmod == 12 || retmod == 15) {
                self.SignaturePad.TopazTmr =
                    SetTabletState(1, context, 50) || self.SignaturePad.TopazTmr;
                SetLCDCaptureMode(2);
                LcdRefresh(0, 0, 0, 500, 100);
                LCDSetWindow(0, 0, 500, 100);
                SetJustifyMode(0);
                KeyPadClearHotSpotList();
                ClearSigWindow(0);
                ClearSigWindow(1);
                SetDisplayXSize(context.canvas.width);
                SetDisplayYSize(context.canvas.height);
                SetImageXSize(context.canvas.width);
                SetImageYSize(context.canvas.height);
                SetLCDCaptureMode(2);
            }
        } catch (e) { }
    }; // StartTopazInput

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Stops input for Topaz signature device.
        /// </summary>
        /// <returns></returns>*/
    self.StopTopazInput = function () {
        self.ClearTopazDisplay();
        if (self.SignaturePad.TopazTmr != null) {
            SetLCDCaptureMode(1);
            SetTabletState(0, self.SignaturePad.TopazTmr);
        }
    }; //StopTopazInput

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Stops input for Topaz signature device.
        /// </summary>
        /// <returns></returns>*/
    self.ClearTopazDisplay = function () {
        if (self.SignaturePad.TopazTmr != null) {
            LcdRefresh(0, 0, 0, 500, 100);
            LCDSetWindow(0, 0, 500, 100);
            SetSigWindow(1, 0, 0, 500, 100);
            KeyPadClearHotSpotList();
            ClearSigWindow(0);
        }
    }; //ClearTopazDisplay

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
        /// <summary>
        /// Shows signature dialog window.
        /// </summary>
        /// <param name="button">The button that initiated.</param>
        /// <param name="isDisplay">The value to indcate if the dialgo window is to view the signature.</param>
        /// <returns></returns>*/
    self.ShowSignature = function (button, isDisplay) {
        var model = $(button).data("field");
        if (!!model.FieldValue) {
            isDisplay = true;
        }
        if (isDisplay) {
            if (!model || !model.FieldValue) {
                return;
            }

            var url = VR.Common.GetRootURL("event/edit") + "data/signature";
            VR.Common.SecurePost(
                url,
                model.FieldValue,
                function (result) {
                    if (result.Code == 0) {
                        self.SignaturePad.clear();

                        self.SignaturePad.fromDataURL(result.Signature);
                        $("#signature-mouse").css("display", "");
                        $("#signature-clear").css("display", "");
                        $("#signature-cancel").css("display", "");
                        $("#signature-save").css("display", "");
                        $("#signature-ok").css("display", "none");

                        self.StartTopazInput(self.SignaturePad._ctx);

                        $("#signature-modal").modal("show");
                    } else {
                        VR.Common.HandleInvalidResult(result, "Signture", false);
                    }
                },
                true,
                "signatureid=",
                false,
                false
            );
        } else {
            if (self.EventId == 0) {
                VR.Common.ShowError(
                    "Cannot enter signature for a new event. Please save first.",
                    "Error"
                );
                return;
            }

            self.SignaturePad.clear();
            $("#signature-mouse").css("display", "");
            $("#signature-clear").css("display", "");
            $("#signature-cancel").css("display", "");
            $("#signature-save").css("display", "");
            $("#signature-ok").css("display", "none");

            self.StartTopazInput(self.SignaturePad._ctx);

            $("#signature-modal").modal("show");
        }
    }; //ShowSignature

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Updates the current image.
        /// </summary>
        /// <param name="host">The host of image editor window.</param>
        /// <returns></returns>*/
    self.UpdateImage = function (host) {
        var imageWindow = host.data("kendoWindow");
        imageWindow.close();

        var editor = host.find(".editor-image");
        var id = editor.attr("id");

        var index = id.indexOf("-editor");
        if (index > -1) {
            id = id.substring(0, index);
        }

        index = id.indexOf("image-");
        if (index > -1) {
            id = id.substring("image-".length);
        }

        var changed = editor.attr("data-changed");
        if (!changed) {
            return;
        }

        var input = host.find("input[type='search']");
        var appfunc = input.data("kendoDropDownList");
        if (appfunc != null) {
            appfunc = appfunc.value();
        }

        var isactive = host.find(".imagedit-input[type='checkbox']");
        if (isactive.length == 0) {
            isactive = null;
        } else {
            var isactive = isactive.prop("checked");
        }

        var description = host.find(".imagedit-input[type='text']");
        description = description.val();
        var data = "";
        if (changed.indexOf("image") > -1) {
            var images = editor.find("img");
            $.each(images, function (index, image) {
                data += "!" + $(image).attr("src");
            });
        }

        if (data && data != "") {
            if (data.indexOf("!") == 0) {
                data = data.substring(1);
            }
            data = data.replace(/\+/g, "#");
        }

        var annote = editor.attr("annotation");
        var width = editor.attr("annote-width");
        var height = editor.attr("annote-height");
        if (!annote) {
            var parentWindow = $("#" + id + "-window").data("kendoWindow");
            annote = parentWindow.Annotation;
            width = parentWindow.AnnotationWidth;
            height = parentWindow.AnnotationHeight;
        }
        if (annote) {
            annote = annote
                .replace(/\[/g, "%%_OPENBRACKET_%%")
                .replace(/\]/g, "%%_CLOSEBRACKET_%%")
                .replace(/\{/g, "%%_OPENCURL_%%")
                .replace(/\}/g, "%%_CLOSECURL_%%");
        }
        else {
            annote = "";
        }

        var url = VR.Common.GetRootURL("event/edit") + "data/imageupdate";
        var selection =
            "id=" +
            id +
            "|appfunc=" +
            appfunc +
            "|isactive=" +
            isactive +
            "|description=" +
            description +
            "|changed=" +
            changed +
            "|annote=" +
            annote +
            "|width=" +
            width +
            "|height=" +
            height +
            "|data=" +
            data;
        VR.Common.SecurePost(
            url,
            selection,
            function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, "Image Update", false);
                } else {
                    result.Annotations = result.Image.Annotations;
                    result.AnnotateWidth = result.Image.AnnotateWidth;
                    result.AnnotateHeight = result.Image.AnnotateHeight;
                    host.data("Image", result);

                    var list = $("#image-list");
                    list.find(".image").off("dblclick");
                    var index = -1;
                    var images = self.ImageDataSource.data();
                    if (images.length == 0) {
                        images = [];
                    } else {
                        $.each(images, function (i, image) {
                            if (image.ImageId == result.Image.ImageId) {
                                index = i;
                                return false;
                            }
                        });
                    }

                    if (index == -1) {
                        images.push(result.Image);
                    } else {
                        images.splice(index, 1, result.Image);
                    }

                    self.ImageDataSource.data(images);

                    var pager = $("#image-pager").data("kendoPager");
                    if (pager) {
                        pager.refresh();
                    }
                    var kendoList = list.data("kendoListView");
                    if (kendoList) {
                        kendoList.refresh();

                        $("#image-list .image").on("dblclick", function (e) {
                            var imageId = this.id;
                            if (imageId.indexOf("image-") > -1) {
                                imageId = imageId.substring("image-".length);
                            }
                            var urlParams = new URLSearchParams(window.location.search);
                            var eventEditParam = urlParams.get('selection') || "";
                            var url = VR.Common.GetRootURL();
                            window.open(url + "event/imagewindow?" + eventEditParam + "&vrsimageid=" + imageId, "_blank", "popup=1,menubar=no,toolbar=no,status=no,resizable=yes,fullscreen=yes");
                        });
                    }
                }
            },
            true,
            undefined,
            false,
            false
        );
    }; //UpdateImage

    /* =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
    /// <summary>
    /// Check For Error Message.
    /// </summary>
    /// <returns></returns> */
    self.CheckForErrorMessage = function () {
        if (self.IsDataCached && self.EventId > 0) {
            var selection = "event=" + self.EventName + "|id=" + self.EventId;
            VR.Common.SecurePost("event/checkforerrormessage", selection, function (result) {
                if (result.Code != 0) {
                    VR.Common.HandleInvalidResult(result, self.EventName, false);
                }
            });
        }
    }; //CheckForErrorMessage

    self.ValidDate = function (field) {
        self.Validating = true;
        var elemModel = field.data("field");
        var invalidMessage = "";

        function requirements() {
            invalidMessage = "This field is required to save the record.";
            return (
                (!elemModel.RequiredForTransmit &&
                    !elemModel.RequiredForRegister) ||
                (elemModel.RequiredForTransmit &&
                    elemModel.FieldType === "Hidden") ||
                field.val()
            );
        }
        function valDate() {
            invalidMessage = "Enter a valid date.";
            var isLeapYear = function (year) {
                return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
            };
            var returnValue = false;

            var val = self.GetInputValue(field, true);
            if (val === "__/__/____") {
                val = "";
            }
            if (val.length && elemModel.FieldType == "DatePicker") {
                let dateParts = val.split("/");
                let month = parseInt(dateParts[0]);
                let day = parseInt(dateParts[1]);
                let year = parseInt(dateParts[2]);
                if (!isNaN(month) && !isNaN(day) && !isNaN(year) && isDate(val)) {
                    if (month === 88 || month === 99) {
                        returnValue = day <= 31 || day === 88 || day === 99;
                        if (!returnValue) {
                            invalidMessage = "Enter a valid day.";
                        }
                    }
                    else {
                        let daysInMonth = [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                        returnValue = month <= 12 && month > 0;
                        if (returnValue) {
                            returnValue = day <= daysInMonth[month - 1] || day === 88 || day === 99;
                            if (!returnValue) {
                                invalidMessage = "Enter a valid day.";
                            }
                        }
                        else {
                            invalidMessage = "Enter a valid month.";
                        }
                    }
                }
            } else {
                returnValue = true;
            }
            return returnValue;
        }
        function checkRequired() {
            invalidMessage = "This field is required to complete the record.";
            if (elemModel.IsRequired && !field.val()) {
                elemModel.RequiredFlag = true;
            }
            return elemModel.IsRequired ? field.val() : true;
        }
        function validationSteps() {
            return (
                requirements() &&
                valDate()
            );
        }

        var valid = checkRequired() && validationSteps();

        if (!valid) {
            self.ErrorPanel.setError({
                field: field,
                model: elemModel,
                message: invalidMessage,
                location: null,
                isHardEdit: elemModel.isHardEdit,
                errorType: "validation"
            });
            self.TakeActionOnField("skipped", invalidMessage, null, field, elemModel);
            self.AddErrorField(elemModel);
        }
        self.Validating = false;
        return valid;
    };  //ValidDate

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
     /// <summary>
     /// Creates a field validator.
     /// </summary>
     /// <param name="model">The field model.</param>
     /// <returns></returns>*/
    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
        /// <summary>
        /// Validates a field against all rules (required, integer, combobox literal, custom edits).
        /// Replaces the kendoValidator isValid rule.
        /// </summary>
        /// <param name="field">The input field element or selector.</param>
        /// <param name="model">The field model (optional, resolved from element if not provided).</param>
        /// <returns>True if valid, false otherwise.</returns>*/
    self.ValidateFieldRules = function (field, elemModel) {
        var elem = $(field);
        if (!elemModel) {
            elemModel = (elem[0] && elem[0].type === "radio"
                ? $("#" + elem[0].name)
                : elem
            ).data("field");
        }
        if (!elemModel || (elem.hasClass("readonly-text") && !self.IsSaving()) || elemModel.HasSaveError) {
            return true;
        }

        self.Validating = true;
        var invalidMessage = "";
        var val = self.GetInputValue(elem, true);

        // Required field check
        if (elemModel.IsRequired && !elem.val()) {
            elemModel.RequiredFlag = true;
            invalidMessage = "This field is required to save the record.";
            self.Validating = false;
            self.ErrorPanel.setError({
                field: elem, model: elemModel, message: invalidMessage,
                location: null, isHardEdit: true, errorType: "validation"
            });
            self.TakeActionOnField("skipped", invalidMessage, null, elem, elemModel);
            self.AddErrorField(elemModel);
            return false;
        }

        // Transmit/Register requirements
        if (val === "" && (elemModel.RequiredForTransmit || elemModel.RequiredForRegister) &&
            !(elemModel.RequiredForTransmit && elemModel.FieldType === "Hidden")) {
            invalidMessage = "This field is required to save the record.";
            self.Validating = false;
            self.ErrorPanel.setError({
                field: elem, model: elemModel, message: invalidMessage,
                location: null, isHardEdit: true, errorType: "validation"
            });
            self.TakeActionOnField("skipped", invalidMessage, null, elem, elemModel);
            self.AddErrorField(elemModel);
            return false;
        }

        // Integer-only validation
        if (val && self.State === 0 && elemModel.FieldDataType === "integer") {
            var hasNonDigit = val.split("").filter(function (c) {
                return "0123456789".indexOf(c) === -1;
            }).length > 0;
            if (hasNonDigit) {
                invalidMessage = "This field accepts numbers only.";
                self.Validating = false;
                self.ErrorPanel.setError({
                    field: elem, model: elemModel, message: invalidMessage,
                    location: null, isHardEdit: false, errorType: "validation"
                });
                self.TakeActionOnField("skipped", invalidMessage, null, elem, elemModel);
                self.AddErrorField(elemModel);
                return false;
            }
        }

        // DatePicker early return
        if (val.length && elemModel.FieldType === "DatePicker") {
            self.Validating = false;
            return self.ValidateField(elem);
        }

        // ComboBox "other literal" check
        if (!self.CheckIsComboBoxValueAllowed(elem)) {
            invalidMessage = "Entry doesn't exist. Please select an entry from the list.";
            self.Validating = false;
            self.ErrorPanel.setError({
                field: elem, model: elemModel, message: invalidMessage,
                location: null, isHardEdit: false, errorType: "validation"
            });
            self.TakeActionOnField("skipped", invalidMessage, null, elem, elemModel);
            self.AddErrorField(elemModel);
            return false;
        }

        // Custom edit rules
        var customValid = self.ValidateField(elem);

        self.Validating = false;
        return customValid;
    }; //ValidateFieldRules

    /*// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-= 
        /// <summary>
        /// Validates the current field.
        /// </summary>
        /// <param name="sender">The sender.</param>
        /// <returns>Alawys return false.</returns>*/
    self.ValidateField = function (sender, theState) {
        if (theState == undefined) {
            theState = self.State;
        }
        var field = $(sender);
        var value = field.val();
        var model = field.data("field");
        if (!model && field[0].name) {
            model = $("#" + field[0].name).data("field");
        }

        if (!model) {
            return true;
        }


        // Prevent multiple validation runs on the same field
        // Grid fields are exempt — row clicks are discrete user actions, not rapid-fire blur events
        if (model._validating && model.FieldType !== "Grid") {
            // console.log("ValidateField blocked - already validating", model.FieldName);
            return true;
        }
        
        self.validatingFieldCount++;
        model._validating = true;
        setTimeout(function() {
            model._validating = false;
            self.validatingFieldCount--;
        }, 300);
        var fieldKey = model.FieldId + "_" + value;
        if (self.validatingFields && self.validatingFields[fieldKey]) {
            return true; // Already validating this field with this value
        }

        if (!self.validatingFields) {
            self.validatingFields = {};
        }
        self.validatingFields[fieldKey] = true;

        self.editModel = model;
        self.editField = field;

        var state = field.data("state");

        if (model.SkipValidation) {
            model.SkipValidation = false; // Reset flag
            delete self.validatingFields[fieldKey];
            return true; // Skip validation entirely
        }
        self.RemoveErrorField(model);

        if (model.FieldStatus != "literal" && (model.FieldStatus != "overridden" && model.FieldStatus != "queried")) {
            // Gets rid of leading zeros if a value is a number for better comparison
            if (!!model.PreviousValue && !!model.FieldValue && !Number.isNaN(model.PreviousValue) && !Number.isNaN(model.FieldValue)) {
                model.FieldStatus = (parseInt(model.PreviousValue) !== parseInt(model.FieldValue)) ? null : model.FieldStatus;
            }
            else {
                model.FieldStatus = null;
            }
        }

        if (model.FieldStatus == "overridden" || model.FieldStatus == "queried") {
            delete self.validatingFields[fieldKey];
            return true;
        }

        // when the field is a textbox type and data type of char then remove extra spaces
        if (model.FieldDataType === "char" && model.FieldType === "TextBox") {
            if (typeof value === "string") {
                // if value is a string check for multi-spaces
                var multispaces = RegExp(/\s\s+/g);
                if (multispaces.test(value)) {
                    // replace multiple spaces with a single space
                    field.val(value.replace(/\s\s+/g, " "));
                    //VR.Script.MoveLit(model.FieldValue, model.FieldName);
                }
            }
        }

        //model.HasError = false;
        if ((model.Edits && model.ShouldRunEdits)|| model.IsRequired) {
            var parameter = {
                message: null,
                location: null,
                lastedit: null,
                edittype: null,
                errorat: null,
                state: state
            };

            if (model.FieldType !== "Button") {
                $.each(model.Edits, function (index, edit) {
                    if (self.IsSaving() || !edit.EditOnSaveOnly) {
                        var result = VR.Script.Validate(field, model, edit, parameter);
                        if (!result) {
                            return false;
                        }
                    }
                });
            }

            var isHardEdit = null;
            if (model.IsRequired && self.load) {
                parameter.message = "This field is required to complete the record.";
                isHardEdit = true;
            }
            var message = parameter.message;
            var location = parameter.location;
            var edit = parameter.lastedit;
            if (edit && isHardEdit == null) {
                isHardEdit = edit.IsHardEdit;
            }
            if (model.FieldStatus !== "literal" && message == null || message == "") {
                if (model.FieldType != "Grid") {
                    var msgID = "#f" + model.FieldId + "-msg";
                    if ($(msgID).length == 0) self.ResetField(sender, true);
                }
            } else if (
                model.FieldStatus != null &&
                model.FieldStatus != "" &&
                model.FieldStatus != "alerttrigger" &&
                model.FieldStatus != "skipped" &&
                model.FieldStatus != "forcequery" &&
                model.FieldStatus != "overridden" &&
                model.FieldStatus != "literal"
            ) {
                model.QueryLocation = location;
                model.ErrorMessage = message;
            } else if (
                model.FieldStatus === "literal" &&
                message == null
            ) {
                model.QueryLocation = location;
                model.ErrorMessage = message;
            } else {
                if (model.FieldStatus === "literal") {
                    model.QueryLocation = location;
                    model.ErrorMessage = message;
                }
                if (model.FieldType != "Grid" && parameter.edittype != "alert") {
                    self.ErrorPanel.setError({
                        field: field,
                        model: model,
                        message: message,
                        location: location,
                        isHardEdit: isHardEdit
                    });

                    self.TakeActionOnField("skipped", message, location, field, model);

                    self.AddErrorField(model);
                }
            }
        }
        if (model.FieldType == "DatePicker") {
            var result = self.ValidDate(field);
            delete self.validatingFields[fieldKey];
            return result;
        }
        delete self.validatingFields[fieldKey];
        return true;
    }; //ValidateField

    self.PutFocusOnFirstWritableField = function () {
        //add focus to the first writeable control
        var topMostControls = $.grep(VR.Edit.Fields, function (field) {
            return (
                field.IsEditable &&
                field.IsEnabled &&
                field.FieldType != "Hidden" &&
                field.FieldType != "Button" &&
                field.FieldType != "Label"
            );
        });

        //if there are no writable controls select the first tab
        if (topMostControls.length === 0) {
            var tabs = $("a[role='tab']").toArray();
            tabs[0].click();
        } else {
            self.FirstField = topMostControls[0];
            var gadget = null;
            var input = $("#f" + self.FirstField.FieldId);
            switch (self.FirstField.FieldType) {
                case "AutoComplete":
                    gadget = $(input).data("kendoAutoComplete");
                    break;
                case "ComboBox":
                    gadget = $(input).data("kendoComboBox");
                    break;
                case "MultiSelect":
                    gadget = $(input).data("kendoMultiSelect");
                    break;
                case "NumericTextBox":
                    gadget = $(input).data("kendoNumericTextBox");
                    break;
                case "RadioButton":
                    gadget = $(input).find("input:first");
                    break;
            }
            var tabId = input.closest("div[role='tabpanel']").attr("id");
            $("a[href='#" + tabId + "']").click();
            if (gadget) {
                gadget.focus();
            } else {
                $(input).focus();
            }
            VR.Script.LastFocus = { input: input, model: self.FirstField };
        }
    }; //PutFocusOnFirstWritableField
    return self;
})(); //VR.Edit

// =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
/// <summary>
/// Document object ready event handler.
/// </summary>
/// <returns></returns>
window.editOnLoad = function () {
    if (window.location.href.indexOf("jsedit") > -1) {
        VR.Common.Location = "/jsedit";
    } else if (window.location.href.indexOf("batch") > -1) {
        VR.Common.Location = "/event/batchupdate";
    } else {
        VR.Common.Location = "/event/edit";
    }
    VR.Common.FieldPopup = VR.Edit.SetupPopupMenu;
    VR.Edit.Initialize();
    VR.Edit.CheckForErrorMessage();
    VR.Common.ValidateSession();
    VR.Common.CreateWorkQueueHandler();
    if (editPageData.ShowWorkQueues === true) {
        VR.Common.SetupWorkQueueCounts();
    }
    VR.Common.CreateMainMenus();
    VR.Common.CreatePopOverToolTop();
    VR.Common.SetupLogin();
    VR.Common.SetupTwoFactor();
    VR.Common.SetupLogout();
    VR.Common.SetupQuickSearch();
    VR.Common.SetupMessageRead();
    VR.Common.SetupOnResize(VR.Edit.ResizeWindow);
    VR.Common.SetupConnection();
    VR.Common.CreateAmendments();
    VR.Common.CreateDocuments();
    setTimeout(function () {
        VR.Edit.ExecuteOnDisplay();
        if (VR.Edit.IsDisplayOnly) {
            VR.Script.EnableField(";a", false);
        }
        if (VR.Script.FocusOnDisplay === null) {
            VR.Edit.PutFocusOnFirstWritableField();
        }
        else {
            nx.Focus(VR.Script.FocusOnDisplay);
        }
    }, 100);

    $("#backToTop").hide();
    $('[data-toggle="popover"]').popover();
};
